import type { Process, ProcessSummary } from "../openapi-aliases";

export const processesData: ProcessSummary[] = [
  {
    slug: "outbound-pipeline-generation",
    name: "Outbound Pipeline Generation",
    description:
      "Process B — Create and send a personalized first-outreach email in 9 minutes 15 seconds by copying and repeatedly rewriting a previous prospect's email.",
    aliases: [],
    frequency: 23,
    avgDuration: 503.55652,
    firstSeen: "2025-02-04T08:47:13Z",
    lastSeen: "2026-07-29T09:14:30Z",
    stepCount: 219,
  },
  {
    slug: "internal-collaboration-admin",
    name: "Internal Collaboration & Admin",
    description:
      "Review the fictional conversation in #demo-ops-71 and post a sample status update using the workspace.",
    aliases: [],
    frequency: 14,
    avgDuration: 329.50714,
    firstSeen: "2025-02-04T08:48:38.824Z",
    lastSeen: "2025-02-04T15:45:28.672Z",
    stepCount: 81,
  },
  {
    slug: "team-enablement-onboarding",
    name: "Team Enablement & Onboarding",
    description:
      "Review and update Sample Enablement Guide 50 with fictional onboarding details in the workspace.",
    aliases: [],
    frequency: 4,
    avgDuration: 712.35,
    firstSeen: "2025-02-04T09:01:02.042Z",
    lastSeen: "2025-02-04T15:42:23.726Z",
    stepCount: 56,
  },
  {
    slug: "navigate-workspace",
    name: "Navigate Workspace",
    description: "Move through the workspace to continue Sample Workflow 72.",
    aliases: [],
    frequency: 1,
    avgDuration: 4298.1,
    firstSeen: "2025-02-04T08:48:08.219Z",
    lastSeen: "2025-02-04T15:30:37.327Z",
    stepCount: 76,
  },
];

// biome-ignore format: keep the large static demo fixture compact for manual replacement.
export const outboundPipelineGeneration = {
    "slug": "outbound-pipeline-generation",
    "name": "Outbound Pipeline Generation",
    "description": "Process B — Create and send a personalized first-outreach email in 9 minutes 15 seconds by copying and repeatedly rewriting a previous prospect's email.",
    "aliases": [],
    "frequency": 23,
    "avgDuration": 503.55652,
    "firstSeen": "2025-02-04T08:47:13Z",
    "lastSeen": "2026-07-29T09:14:30Z",
    "nodes": [
        {
            "id": "step:adapt-outreach-for-different-seniority#gmail",
            "name": "Adapt Outreach for Different Seniority",
            "app": "Gmail"
        },
        {
            "id": "step:attend-internal-meeting-vimeo#vimeo",
            "name": "Attend Internal Meeting (Vimeo)",
            "app": "Vimeo"
        },
        {
            "id": "step:author-onboarding-or-reference-doc-claude#claude",
            "name": "Author Onboarding or Reference Doc (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:author-onboarding-or-reference-doc-lemlist#lemlist",
            "name": "Author Onboarding or Reference Doc (lemlist)",
            "app": "lemlist"
        },
        {
            "id": "step:build-prospect-list-arc#arc",
            "name": "Build Prospect List (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:build-prospect-list-lemlist#lemlist",
            "name": "Build Prospect List (lemlist)",
            "app": "lemlist"
        },
        {
            "id": "step:check-messages-gmail#gmail",
            "name": "Check Messages (Gmail)",
            "app": "Gmail"
        },
        {
            "id": "step:configure-onboarding-tools-and-resources-claude#claude",
            "name": "Configure Onboarding Tools and Resources (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:correct-copied-remnants-and-send#gmail",
            "name": "Correct Copied Remnants and Send",
            "app": "Gmail"
        },
        {
            "id": "step:create-crm-lead-contact-record-arc#arc",
            "name": "Create CRM Lead/Contact Record (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:create-crm-lead-contact-record-salesforce#salesforce",
            "name": "Create CRM Lead/Contact Record (Salesforce)",
            "app": "Salesforce"
        },
        {
            "id": "step:create-first-outreach-from-playbook#gmail",
            "name": "Create First Outreach from Playbook",
            "app": "Gmail"
        },
        {
            "id": "step:create-training-video-arc#arc",
            "name": "Create Training Video (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:enrich-contact-data-arc#arc",
            "name": "Enrich Contact Data (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:enrich-contact-data-salesforce#salesforce",
            "name": "Enrich Contact Data (Salesforce)",
            "app": "Salesforce"
        },
        {
            "id": "step:enrich-context-and-rework-draft#gmail",
            "name": "Enrich Context and Rework Draft",
            "app": "Gmail"
        },
        {
            "id": "step:lookup-reference-arc#arc",
            "name": "Lookup Reference (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:lookup-reference-claude#claude",
            "name": "Lookup Reference (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:make-outbound-call-log-call-outcome-arc#arc",
            "name": "Make Outbound Call / Log Call Outcome (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:manage-calendar-and-availability-arc#arc",
            "name": "Manage Calendar and Availability (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:message-teammate-claude#claude",
            "name": "Message Teammate (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:message-teammate-heyreach#arc",
            "name": "Message Teammate (HeyReach)",
            "app": "Arc"
        },
        {
            "id": "step:message-teammate-slack#slack",
            "name": "Message Teammate (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:navigate-workspace#arc",
            "name": "Navigate workspace",
            "app": "Arc"
        },
        {
            "id": "step:navigate-workspace#salesforce",
            "name": "Navigate workspace",
            "app": "Salesforce"
        },
        {
            "id": "step:navigate-workspace#slack",
            "name": "Navigate workspace",
            "app": "Slack"
        },
        {
            "id": "step:navigate-workspace#vimeo",
            "name": "Navigate workspace",
            "app": "Vimeo"
        },
        {
            "id": "step:qualify-assigned-lead#linkedin",
            "name": "Qualify Assigned Lead",
            "app": "LinkedIn"
        },
        {
            "id": "step:research-assigned-lead#linkedin",
            "name": "Research Assigned Lead",
            "app": "LinkedIn"
        },
        {
            "id": "step:research-target-account-arc#arc",
            "name": "Research Target Account (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:research-target-account-claude#claude",
            "name": "Research Target Account (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:research-target-account-gmail#gmail",
            "name": "Research Target Account (Gmail)",
            "app": "Gmail"
        },
        {
            "id": "step:research-target-account-salesforce#salesforce",
            "name": "Research Target Account (Salesforce)",
            "app": "Salesforce"
        },
        {
            "id": "step:reuse-previous-prospect-email#gmail",
            "name": "Reuse Previous Prospect Email",
            "app": "Gmail"
        },
        {
            "id": "step:review-pipeline-lead-queue-arc#arc",
            "name": "Review Pipeline / Lead Queue (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:review-pipeline-lead-queue-salesforce#salesforce",
            "name": "Review Pipeline / Lead Queue (Salesforce)",
            "app": "Salesforce"
        },
        {
            "id": "step:review-pipeline-lead-queue-salesforce#slack",
            "name": "Review Pipeline / Lead Queue (Salesforce)",
            "app": "Slack"
        },
        {
            "id": "step:review-recording-arc#arc",
            "name": "Review Recording (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:review-recording-vimeo#vimeo",
            "name": "Review Recording (Vimeo)",
            "app": "Vimeo"
        },
        {
            "id": "step:review-sequence-campaign-performance-arc#arc",
            "name": "Review Sequence/Campaign Performance (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:review-and-send-first-outreach#gmail",
            "name": "Review and Send First Outreach",
            "app": "Gmail"
        },
        {
            "id": "step:schedule-meeting-arc#arc",
            "name": "Schedule Meeting (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:schedule-meeting-salesforce#salesforce",
            "name": "Schedule Meeting (Salesforce)",
            "app": "Salesforce"
        },
        {
            "id": "step:send-follow-up-email#lemlist",
            "name": "Send Follow-up Email",
            "app": "lemlist"
        },
        {
            "id": "step:send-follow-up-email-arc#arc",
            "name": "Send Follow-up Email (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:send-follow-up-email-lemlist#lemlist",
            "name": "Send Follow-up Email (lemlist)",
            "app": "lemlist"
        },
        {
            "id": "step:update-crm-record-arc#arc",
            "name": "Update CRM Record (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:update-crm-record-salesforce#salesforce",
            "name": "Update CRM Record (Salesforce)",
            "app": "Salesforce"
        }
    ],
    "sources": [
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 0,
            "traceStart": "2025-02-04T08:47:13Z",
            "traceEnd": "2025-02-04T15:44:23.120Z",
            "avgDuration": 115.4
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 3,
            "traceStart": "2025-02-04T08:48:58.096Z",
            "traceEnd": "2025-02-04T08:55:34.520Z",
            "avgDuration": 368.7
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 6,
            "traceStart": "2025-02-04T09:02:10.220Z",
            "traceEnd": "2025-02-04T15:01:34.764Z",
            "avgDuration": 186.3
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 7,
            "traceStart": "2025-02-04T09:04:23.097Z",
            "traceEnd": "2025-02-04T10:01:18.992Z",
            "avgDuration": 2631.0
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 12,
            "traceStart": "2025-02-04T10:04:15.530Z",
            "traceEnd": "2025-02-04T10:13:58.522Z",
            "avgDuration": 553.6
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 16,
            "traceStart": "2025-02-04T10:58:39.424Z",
            "traceEnd": "2025-02-04T15:34:39.277Z",
            "avgDuration": 144.8
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 17,
            "traceStart": "2025-02-04T10:58:39.424Z",
            "traceEnd": "2025-02-04T12:07:19.623Z",
            "avgDuration": 832.9
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 18,
            "traceStart": "2025-02-04T11:01:23.258Z",
            "traceEnd": "2025-02-04T12:05:57.804Z",
            "avgDuration": 840.8
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 19,
            "traceStart": "2025-02-04T11:03:00.492Z",
            "traceEnd": "2025-02-04T13:15:18.498Z",
            "avgDuration": 187.8
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 20,
            "traceStart": "2025-02-04T11:04:28.540Z",
            "traceEnd": "2025-02-04T15:11:22.076Z",
            "avgDuration": 758.2
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 21,
            "traceStart": "2025-02-04T11:05:27.320Z",
            "traceEnd": "2025-02-04T15:27:34.522Z",
            "avgDuration": 1073.3
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 22,
            "traceStart": "2025-02-04T11:05:27.320Z",
            "traceEnd": "2025-02-04T15:12:43.088Z",
            "avgDuration": 771.3
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 23,
            "traceStart": "2025-02-04T11:21:16.258Z",
            "traceEnd": "2025-02-04T11:40:26.886Z",
            "avgDuration": 100.5
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 27,
            "traceStart": "2025-02-04T13:20:00.843Z",
            "traceEnd": "2025-02-04T15:26:28.661Z",
            "avgDuration": 108.3
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 28,
            "traceStart": "2025-02-04T13:20:45.714Z",
            "traceEnd": "2025-02-04T15:06:48.600Z",
            "avgDuration": 214.5
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 29,
            "traceStart": "2025-02-04T13:23:32.798Z",
            "traceEnd": "2025-02-04T14:53:02.348Z",
            "avgDuration": 565.7
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 30,
            "traceStart": "2025-02-04T13:24:25.184Z",
            "traceEnd": "2025-02-04T13:37:03.740Z",
            "avgDuration": 123.3
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 31,
            "traceStart": "2025-02-04T13:29:46.838Z",
            "traceEnd": "2025-02-04T13:38:42.914Z",
            "avgDuration": 208.0
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 32,
            "traceStart": "2025-02-04T13:30:39.054Z",
            "traceEnd": "2025-02-04T15:12:13.164Z",
            "avgDuration": 116.0
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 37,
            "traceStart": "2025-02-04T14:52:44.870Z",
            "traceEnd": "2025-02-04T15:12:13.164Z",
            "avgDuration": 672.7
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 38,
            "traceStart": "2025-02-04T14:55:32.907Z",
            "traceEnd": "2025-02-04T15:01:34.764Z",
            "avgDuration": 168.7
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-cccccccccccc",
            "recordingName": "Pipeline generation",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2026-07-29",
            "traceIndex": 0,
            "traceStart": "2026-07-29T09:00:00Z",
            "traceEnd": "2026-07-29T09:04:45Z",
            "avgDuration": 285.0
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-cccccccccccc",
            "recordingName": "Pipeline generation",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2026-07-29",
            "traceIndex": 1,
            "traceStart": "2026-07-29T09:05:15Z",
            "traceEnd": "2026-07-29T09:14:30Z",
            "avgDuration": 555.0
        }
    ],
    "instances": [
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:0",
            "analysisNodeId": 91001,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 0,
                "traceStart": "2025-02-04T08:47:13Z",
                "traceEnd": "2025-02-04T15:44:23.120Z",
                "avgDuration": 115.4
            },
            "steps": [
                {
                    "nodeId": "step:send-follow-up-email#lemlist",
                    "analysisNodeId": 87001,
                    "duration": 49.9,
                    "description": "Draft and send a sample follow-up to Demo Contact 59 using the workspace.",
                    "screenshots": [
                        "demo_alpha_frame_00001_051.png",
                        "demo_alpha_frame_00002_334.png",
                        "demo_alpha_frame_00003_445.png",
                        "demo_alpha_frame_00004_653.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 18.6,
                        "lemlist": 23.2
                    }
                },
                {
                    "nodeId": "step:send-follow-up-email-arc#arc",
                    "analysisNodeId": 87135,
                    "duration": 43.6,
                    "description": "Draft and send a sample follow-up to Demo Contact 63 using Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00733_946.png",
                        "demo_alpha_frame_00734_000.png",
                        "demo_alpha_frame_00735_116.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 43.6
                    }
                },
                {
                    "nodeId": "step:send-follow-up-email-lemlist#lemlist",
                    "analysisNodeId": 87350,
                    "duration": 21.9,
                    "description": "Draft and send a sample follow-up to Demo Contact 51 using lemlist.",
                    "screenshots": [
                        "demo_alpha_frame_01620_067.png",
                        "demo_alpha_frame_01621_717.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 01",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "lemlist": 17.6
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:3",
            "analysisNodeId": 91004,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 3,
                "traceStart": "2025-02-04T08:48:58.096Z",
                "traceEnd": "2025-02-04T08:55:34.520Z",
                "avgDuration": 368.7
            },
            "steps": [
                {
                    "nodeId": "step:review-pipeline-lead-queue-salesforce#slack",
                    "analysisNodeId": 87004,
                    "duration": 312.0,
                    "description": "Review the sample outreach workflow for Demo Account 80 and update its demo status in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_00009_478.png",
                        "demo_alpha_frame_00010_430.png",
                        "demo_alpha_frame_00011_433.png",
                        "demo_alpha_frame_00012_345.png",
                        "demo_alpha_frame_00013_504.png",
                        "demo_alpha_frame_00014_454.png",
                        "demo_alpha_frame_00015_424.png",
                        "demo_alpha_frame_00016_239.png",
                        "demo_alpha_frame_00017_560.png",
                        "demo_alpha_frame_00018_275.png",
                        "demo_alpha_frame_00019_754.png",
                        "demo_alpha_frame_00020_461.png",
                        "demo_alpha_frame_00021_197.png",
                        "demo_alpha_frame_00022_975.png",
                        "demo_alpha_frame_00023_258.png",
                        "demo_alpha_frame_00024_030.png",
                        "demo_alpha_frame_00025_783.png",
                        "demo_alpha_frame_00026_412.png",
                        "demo_alpha_frame_00027_564.png",
                        "demo_alpha_frame_00028_634.png",
                        "demo_alpha_frame_00029_836.png",
                        "demo_alpha_frame_00030_696.png",
                        "demo_alpha_frame_00031_022.png",
                        "demo_alpha_frame_00032_798.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 73",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 309.0
                    }
                },
                {
                    "nodeId": "step:create-crm-lead-contact-record-arc#arc",
                    "analysisNodeId": 87006,
                    "duration": 56.7,
                    "description": "Open the fictional record for Demo Account 94 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00036_444.png",
                        "demo_alpha_frame_00037_000.png",
                        "demo_alpha_frame_00038_624.png",
                        "demo_alpha_frame_00039_308.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 95",
                            "qualifier": "reviewed-meetings"
                        },
                        {
                            "object": "Demo Account 15",
                            "qualifier": "created-opportunity"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 56.7
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:6",
            "analysisNodeId": 91007,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 6,
                "traceStart": "2025-02-04T09:02:10.220Z",
                "traceEnd": "2025-02-04T15:01:34.764Z",
                "avgDuration": 186.3
            },
            "steps": [
                {
                    "nodeId": "step:configure-onboarding-tools-and-resources-claude#claude",
                    "analysisNodeId": 87015,
                    "duration": 12.1,
                    "description": "Review and update Sample Enablement Guide 47 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00079_852.png",
                        "demo_alpha_frame_00080_346.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Google Chrome": 4.1,
                        "Claude": 8.0
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87294,
                    "duration": 10.5,
                    "description": "Open the fictional record for Demo Account 64 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01398_560.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 64",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 10.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87297,
                    "duration": 22.1,
                    "description": "Open the fictional record for Demo Account 78 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01405_826.png",
                        "demo_alpha_frame_01406_820.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 97",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 22.1
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87298,
                    "duration": 9.6,
                    "description": "Open the fictional record for Demo Account 85 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01407_607.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 11",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 9.6
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87299,
                    "duration": 9.0,
                    "description": "Open the fictional record for Demo Account 92 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01408_973.png",
                        "demo_alpha_frame_01409_112.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 22",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 9.0
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87300,
                    "duration": 10.4,
                    "description": "Open the fictional record for Demo Account 10 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01410_715.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 33",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 50",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 10.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87301,
                    "duration": 21.2,
                    "description": "Open the fictional record for Demo Account 17 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01411_721.png",
                        "demo_alpha_frame_01412_413.png",
                        "demo_alpha_frame_01413_072.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 44",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 61",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 21.2
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87302,
                    "duration": 18.0,
                    "description": "Open the fictional record for Demo Account 24 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01414_095.png",
                        "demo_alpha_frame_01415_767.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 55",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 72",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 18.0
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87303,
                    "duration": 18.7,
                    "description": "Open the fictional record for Demo Account 31 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01416_356.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 66",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 18.7
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87304,
                    "duration": 14.4,
                    "description": "Open the fictional record for Demo Account 38 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01417_697.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 77",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 94",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 14.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87308,
                    "duration": 5.5,
                    "description": "Open the fictional record for Demo Account 66 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01426_732.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 24",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 41",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 5.5
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87309,
                    "duration": 8.4,
                    "description": "Open the fictional record for Demo Account 73 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01427_143.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 35",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 8.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87310,
                    "duration": 20.1,
                    "description": "Open the fictional record for Demo Account 80 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01428_414.png",
                        "demo_alpha_frame_01429_869.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 46",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 20.1
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87311,
                    "duration": 6.3,
                    "description": "Open the fictional record for Demo Account 87 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01430_462.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 57",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 6.3
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:7",
            "analysisNodeId": 91008,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 7,
                "traceStart": "2025-02-04T09:04:23.097Z",
                "traceEnd": "2025-02-04T10:01:18.992Z",
                "avgDuration": 2631.0
            },
            "steps": [
                {
                    "nodeId": "step:attend-internal-meeting-vimeo#vimeo",
                    "analysisNodeId": 87019,
                    "duration": 789.8,
                    "description": "Review a sample calendar entry for Demo Account 68 and update its demo availability in Vimeo.",
                    "screenshots": [
                        "demo_alpha_frame_00091_586.png",
                        "demo_alpha_frame_00092_636.png",
                        "demo_alpha_frame_00093_837.png",
                        "demo_alpha_frame_00094_367.png",
                        "demo_alpha_frame_00095_352.png",
                        "demo_alpha_frame_00096_067.png",
                        "demo_alpha_frame_00097_965.png",
                        "demo_alpha_frame_00098_382.png",
                        "demo_alpha_frame_00099_482.png",
                        "demo_alpha_frame_00100_415.png",
                        "demo_alpha_frame_00101_735.png",
                        "demo_alpha_frame_00102_557.png",
                        "demo_alpha_frame_00103_786.png",
                        "demo_alpha_frame_00104_172.png",
                        "demo_alpha_frame_00105_395.png",
                        "demo_alpha_frame_00106_521.png",
                        "demo_alpha_frame_00107_034.png",
                        "demo_alpha_frame_00108_737.png",
                        "demo_alpha_frame_00109_815.png",
                        "demo_alpha_frame_00110_170.png",
                        "demo_alpha_frame_00111_046.png",
                        "demo_alpha_frame_00112_244.png",
                        "demo_alpha_frame_00113_324.png",
                        "demo_alpha_frame_00114_026.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Session 55",
                            "qualifier": "attended-call"
                        }
                    ],
                    "appSeconds": {
                        "Vimeo": 785.1
                    }
                },
                {
                    "nodeId": "step:message-teammate-claude#claude",
                    "analysisNodeId": 87020,
                    "duration": 21.3,
                    "description": "Review the fictional conversation in #demo-ops-75 and post a sample status update using Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00115_440.png",
                        "demo_alpha_frame_00116_799.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Vimeo": 6.6,
                        "Claude": 14.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#vimeo",
                    "analysisNodeId": 87021,
                    "duration": 39.2,
                    "description": "Move through the workspace to continue Sample Workflow 82.",
                    "screenshots": [
                        "demo_alpha_frame_00117_068.png",
                        "demo_alpha_frame_00118_139.png",
                        "demo_alpha_frame_00119_396.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 13.7,
                        "Vimeo": 25.5
                    }
                },
                {
                    "nodeId": "step:lookup-reference-claude#claude",
                    "analysisNodeId": 87022,
                    "duration": 9.1,
                    "description": "Review and update Sample Enablement Guide 89 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00120_013.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 6.8
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-claude#claude",
                    "analysisNodeId": 87023,
                    "duration": 44.1,
                    "description": "Review and update Sample Enablement Guide 96 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00121_271.png",
                        "demo_alpha_frame_00122_516.png",
                        "demo_alpha_frame_00123_217.png",
                        "demo_alpha_frame_00124_726.png",
                        "demo_alpha_frame_00125_287.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 44.1
                    }
                },
                {
                    "nodeId": "step:configure-onboarding-tools-and-resources-claude#claude",
                    "analysisNodeId": 87024,
                    "duration": 6.1,
                    "description": "Review and update Sample Enablement Guide 14 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00126_768.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 3.9,
                        "Vimeo": 2.2
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#vimeo",
                    "analysisNodeId": 87025,
                    "duration": 32.6,
                    "description": "Move through the workspace to continue Sample Workflow 21.",
                    "screenshots": [
                        "demo_alpha_frame_00127_036.png",
                        "demo_alpha_frame_00128_112.png",
                        "demo_alpha_frame_00129_781.png",
                        "demo_alpha_frame_00130_671.png",
                        "demo_alpha_frame_00131_048.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Vimeo": 20.4,
                        "Claude": 9.7,
                        "Slack": 2.5
                    }
                },
                {
                    "nodeId": "step:research-target-account-arc#arc",
                    "analysisNodeId": 87026,
                    "duration": 38.0,
                    "description": "Research Demo Account 28 and summarize its fictional business profile in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00132_626.png",
                        "demo_alpha_frame_00133_387.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 79",
                            "qualifier": "searched"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 33.0
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#vimeo",
                    "analysisNodeId": 87027,
                    "duration": 154.5,
                    "description": "Move through the workspace to continue Sample Workflow 35.",
                    "screenshots": [
                        "demo_alpha_frame_00134_996.png",
                        "demo_alpha_frame_00135_436.png",
                        "demo_alpha_frame_00136_503.png",
                        "demo_alpha_frame_00137_870.png",
                        "demo_alpha_frame_00138_543.png",
                        "demo_alpha_frame_00139_933.png",
                        "demo_alpha_frame_00140_939.png",
                        "demo_alpha_frame_00141_578.png",
                        "demo_alpha_frame_00142_970.png",
                        "demo_alpha_frame_00143_319.png",
                        "demo_alpha_frame_00144_523.png",
                        "demo_alpha_frame_00145_565.png",
                        "demo_alpha_frame_00146_120.png",
                        "demo_alpha_frame_00147_741.png",
                        "demo_alpha_frame_00148_212.png",
                        "demo_alpha_frame_00149_424.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 22.0,
                        "Vimeo": 128.7
                    }
                },
                {
                    "nodeId": "step:review-recording-vimeo#vimeo",
                    "analysisNodeId": 87028,
                    "duration": 887.4,
                    "description": "Review Sample Session 42 and record a fictional outcome in Vimeo.",
                    "screenshots": [
                        "demo_alpha_frame_00150_963.png",
                        "demo_alpha_frame_00151_755.png",
                        "demo_alpha_frame_00152_360.png",
                        "demo_alpha_frame_00153_890.png",
                        "demo_alpha_frame_00154_939.png",
                        "demo_alpha_frame_00155_943.png",
                        "demo_alpha_frame_00156_590.png",
                        "demo_alpha_frame_00157_142.png",
                        "demo_alpha_frame_00158_245.png",
                        "demo_alpha_frame_00159_954.png",
                        "demo_alpha_frame_00160_220.png",
                        "demo_alpha_frame_00161_052.png",
                        "demo_alpha_frame_00162_292.png",
                        "demo_alpha_frame_00163_502.png",
                        "demo_alpha_frame_00164_382.png",
                        "demo_alpha_frame_00165_383.png",
                        "demo_alpha_frame_00166_452.png",
                        "demo_alpha_frame_00167_703.png",
                        "demo_alpha_frame_00168_804.png",
                        "demo_alpha_frame_00169_934.png",
                        "demo_alpha_frame_00170_896.png",
                        "demo_alpha_frame_00171_477.png",
                        "demo_alpha_frame_00172_643.png",
                        "demo_alpha_frame_00173_532.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 48",
                            "qualifier": "reviewed-content"
                        }
                    ],
                    "appSeconds": {
                        "Vimeo": 887.4
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87029,
                    "duration": 337.5,
                    "description": "Review the fictional conversation in #demo-ops-49 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00174_405.png",
                        "demo_alpha_frame_00175_546.png",
                        "demo_alpha_frame_00176_684.png",
                        "demo_alpha_frame_00177_331.png",
                        "demo_alpha_frame_00178_741.png",
                        "demo_alpha_frame_00179_262.png",
                        "demo_alpha_frame_00180_506.png",
                        "demo_alpha_frame_00181_479.png",
                        "demo_alpha_frame_00182_019.png",
                        "demo_alpha_frame_00183_857.png",
                        "demo_alpha_frame_00184_654.png",
                        "demo_alpha_frame_00185_217.png",
                        "demo_alpha_frame_00186_469.png",
                        "demo_alpha_frame_00187_634.png",
                        "demo_alpha_frame_00188_483.png",
                        "demo_alpha_frame_00189_353.png",
                        "demo_alpha_frame_00190_667.png",
                        "demo_alpha_frame_00191_795.png",
                        "demo_alpha_frame_00192_613.png",
                        "demo_alpha_frame_00193_132.png",
                        "demo_alpha_frame_00194_146.png",
                        "demo_alpha_frame_00195_685.png",
                        "demo_alpha_frame_00196_908.png",
                        "demo_alpha_frame_00197_845.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 59",
                            "qualifier": "messaged"
                        },
                        {
                            "object": "Demo Item 76",
                            "qualifier": "discussed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 331.1
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87033,
                    "duration": 137.0,
                    "description": "Research Demo Account 77 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00223_512.png",
                        "demo_alpha_frame_00224_998.png",
                        "demo_alpha_frame_00225_237.png",
                        "demo_alpha_frame_00226_591.png",
                        "demo_alpha_frame_00227_416.png",
                        "demo_alpha_frame_00228_958.png",
                        "demo_alpha_frame_00229_615.png",
                        "demo_alpha_frame_00230_713.png",
                        "demo_alpha_frame_00231_920.png",
                        "demo_alpha_frame_00232_436.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 06",
                            "qualifier": "researched"
                        },
                        {
                            "object": "Demo Account 23",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 137.0
                    }
                },
                {
                    "nodeId": "step:review-recording-arc#arc",
                    "analysisNodeId": 87034,
                    "duration": 48.8,
                    "description": "Review Sample Session 84 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00233_385.png",
                        "demo_alpha_frame_00234_494.png",
                        "demo_alpha_frame_00235_283.png",
                        "demo_alpha_frame_00236_905.png",
                        "demo_alpha_frame_00237_291.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 17",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 48.8
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87040,
                    "duration": 17.6,
                    "description": "Research Demo Account 23 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00253_291.png",
                        "demo_alpha_frame_00254_695.png",
                        "demo_alpha_frame_00255_999.png",
                        "demo_alpha_frame_00256_402.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 83",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 17.6
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87042,
                    "duration": 16.0,
                    "description": "Review the fictional conversation in #demo-ops-30 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00265_217.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 08",
                            "qualifier": "researched"
                        },
                        {
                            "object": "Demo Account 25",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 9.3,
                        "Claude": 6.7
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87045,
                    "duration": 42.0,
                    "description": "Research Demo Account 37 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00280_172.png",
                        "demo_alpha_frame_00281_040.png",
                        "demo_alpha_frame_00282_623.png",
                        "demo_alpha_frame_00283_540.png",
                        "demo_alpha_frame_00284_131.png",
                        "demo_alpha_frame_00285_077.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 41",
                            "qualifier": "researched"
                        },
                        {
                            "object": "Sample Reference 58",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 42.0
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87048,
                    "duration": 10.0,
                    "description": "Research Demo Account 58 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00312_632.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 74",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 10.0
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:12",
            "analysisNodeId": 91013,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 12,
                "traceStart": "2025-02-04T10:04:15.530Z",
                "traceEnd": "2025-02-04T10:13:58.522Z",
                "avgDuration": 553.6
            },
            "steps": [
                {
                    "nodeId": "step:message-teammate-heyreach#arc",
                    "analysisNodeId": 87057,
                    "duration": 20.4,
                    "description": "Review the fictional conversation in #demo-ops-18 and post a sample status update using HeyReach.",
                    "screenshots": [
                        "demo_alpha_frame_00329_846.png",
                        "demo_alpha_frame_00330_172.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 76",
                            "qualifier": "filtered"
                        },
                        {
                            "object": "Demo Contact 93",
                            "qualifier": "messaged"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 20.4
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87058,
                    "duration": 404.7,
                    "description": "Move through the workspace to continue Sample Workflow 25.",
                    "screenshots": [
                        "demo_alpha_frame_00331_180.png",
                        "demo_alpha_frame_00332_715.png",
                        "demo_alpha_frame_00333_389.png",
                        "demo_alpha_frame_00334_192.png",
                        "demo_alpha_frame_00335_578.png",
                        "demo_alpha_frame_00336_766.png",
                        "demo_alpha_frame_00337_520.png",
                        "demo_alpha_frame_00338_398.png",
                        "demo_alpha_frame_00339_078.png",
                        "demo_alpha_frame_00340_667.png",
                        "demo_alpha_frame_00341_052.png",
                        "demo_alpha_frame_00342_823.png",
                        "demo_alpha_frame_00343_830.png",
                        "demo_alpha_frame_00344_047.png",
                        "demo_alpha_frame_00345_404.png",
                        "demo_alpha_frame_00346_763.png",
                        "demo_alpha_frame_00347_162.png",
                        "demo_alpha_frame_00348_125.png",
                        "demo_alpha_frame_00349_675.png",
                        "demo_alpha_frame_00350_444.png",
                        "demo_alpha_frame_00351_662.png",
                        "demo_alpha_frame_00352_970.png",
                        "demo_alpha_frame_00353_574.png",
                        "demo_alpha_frame_00354_854.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 404.7
                    }
                },
                {
                    "nodeId": "step:message-teammate-heyreach#arc",
                    "analysisNodeId": 87059,
                    "duration": 91.2,
                    "description": "Review the fictional conversation in #demo-ops-32 and post a sample status update using HeyReach.",
                    "screenshots": [
                        "demo_alpha_frame_00355_663.png",
                        "demo_alpha_frame_00356_364.png",
                        "demo_alpha_frame_00357_683.png",
                        "demo_alpha_frame_00358_364.png",
                        "demo_alpha_frame_00359_636.png",
                        "demo_alpha_frame_00360_771.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 91.2
                    }
                },
                {
                    "nodeId": "step:message-teammate-heyreach#arc",
                    "analysisNodeId": 87061,
                    "duration": 37.3,
                    "description": "Review the fictional conversation in #demo-ops-46 and post a sample status update using HeyReach.",
                    "screenshots": [
                        "demo_alpha_frame_00363_359.png",
                        "demo_alpha_frame_00364_866.png",
                        "demo_alpha_frame_00365_543.png",
                        "demo_alpha_frame_00366_764.png",
                        "demo_alpha_frame_00367_829.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 37.3
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:16",
            "analysisNodeId": 91017,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 16,
                "traceStart": "2025-02-04T10:58:39.424Z",
                "traceEnd": "2025-02-04T15:34:39.277Z",
                "avgDuration": 144.8
            },
            "steps": [
                {
                    "nodeId": "step:build-prospect-list-lemlist#lemlist",
                    "analysisNodeId": 87075,
                    "duration": 101.2,
                    "description": "Review the sample outreach workflow for Demo Account 34 and update its demo status in lemlist.",
                    "screenshots": [
                        "demo_alpha_frame_00458_198.png",
                        "demo_alpha_frame_00459_344.png",
                        "demo_alpha_frame_00460_930.png",
                        "demo_alpha_frame_00461_126.png",
                        "demo_alpha_frame_00462_194.png",
                        "demo_alpha_frame_00463_128.png",
                        "demo_alpha_frame_00464_874.png",
                        "demo_alpha_frame_00465_389.png",
                        "demo_alpha_frame_00466_979.png",
                        "demo_alpha_frame_00467_923.png",
                        "demo_alpha_frame_00468_074.png",
                        "demo_alpha_frame_00469_770.png",
                        "demo_alpha_frame_00470_834.png",
                        "demo_alpha_frame_00471_508.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 80",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Item 97",
                            "qualifier": "imported-from"
                        }
                    ],
                    "appSeconds": {
                        "lemlist": 98.6
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-lemlist#lemlist",
                    "analysisNodeId": 87341,
                    "duration": 32.7,
                    "description": "Review and update Sample Enablement Guide 77 with fictional onboarding details in lemlist.",
                    "screenshots": [
                        "demo_alpha_frame_01550_329.png",
                        "demo_alpha_frame_01551_235.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 96",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "lemlist": 30.1
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-lemlist#lemlist",
                    "analysisNodeId": 87344,
                    "duration": 10.9,
                    "description": "Review and update Sample Enablement Guide 98 with fictional onboarding details in lemlist.",
                    "screenshots": [
                        "demo_alpha_frame_01563_195.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 32",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "lemlist": 10.9
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:17",
            "analysisNodeId": 91018,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 17,
                "traceStart": "2025-02-04T10:58:39.424Z",
                "traceEnd": "2025-02-04T12:07:19.623Z",
                "avgDuration": 832.9
            },
            "steps": [
                {
                    "nodeId": "step:build-prospect-list-lemlist#lemlist",
                    "analysisNodeId": 87075,
                    "duration": 101.2,
                    "description": "Review the sample outreach workflow for Demo Account 34 and update its demo status in lemlist.",
                    "screenshots": [
                        "demo_alpha_frame_00458_198.png",
                        "demo_alpha_frame_00459_344.png",
                        "demo_alpha_frame_00460_930.png",
                        "demo_alpha_frame_00461_126.png",
                        "demo_alpha_frame_00462_194.png",
                        "demo_alpha_frame_00463_128.png",
                        "demo_alpha_frame_00464_874.png",
                        "demo_alpha_frame_00465_389.png",
                        "demo_alpha_frame_00466_979.png",
                        "demo_alpha_frame_00467_923.png",
                        "demo_alpha_frame_00468_074.png",
                        "demo_alpha_frame_00469_770.png",
                        "demo_alpha_frame_00470_834.png",
                        "demo_alpha_frame_00471_508.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 80",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Item 97",
                            "qualifier": "imported-from"
                        }
                    ],
                    "appSeconds": {
                        "lemlist": 98.6
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87077,
                    "duration": 20.9,
                    "description": "Review the sample outreach workflow for Demo Account 48 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00478_889.png",
                        "demo_alpha_frame_00479_364.png",
                        "demo_alpha_frame_00480_590.png",
                        "demo_alpha_frame_00481_685.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 05",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 20.9
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87079,
                    "duration": 74.5,
                    "description": "Review the sample outreach workflow for Demo Account 62 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00487_699.png",
                        "demo_alpha_frame_00488_163.png",
                        "demo_alpha_frame_00489_275.png",
                        "demo_alpha_frame_00490_338.png",
                        "demo_alpha_frame_00491_606.png",
                        "demo_alpha_frame_00492_526.png",
                        "demo_alpha_frame_00493_661.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 74.5
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87086,
                    "duration": 15.3,
                    "description": "Review the sample outreach workflow for Demo Account 97 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00533_116.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 07",
                            "qualifier": "accessed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 15.3
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87102,
                    "duration": 50.7,
                    "description": "Review the sample outreach workflow for Demo Account 17 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00594_727.png",
                        "demo_alpha_frame_00595_470.png",
                        "demo_alpha_frame_00596_279.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 50.7
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87103,
                    "duration": 81.4,
                    "description": "Review the sample outreach workflow for Demo Account 24 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00597_084.png",
                        "demo_alpha_frame_00598_115.png",
                        "demo_alpha_frame_00599_875.png",
                        "demo_alpha_frame_00600_434.png",
                        "demo_alpha_frame_00601_885.png",
                        "demo_alpha_frame_00602_167.png",
                        "demo_alpha_frame_00603_717.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 81.4
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87107,
                    "duration": 50.4,
                    "description": "Review the sample outreach workflow for Demo Account 52 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00613_122.png",
                        "demo_alpha_frame_00614_307.png",
                        "demo_alpha_frame_00615_464.png",
                        "demo_alpha_frame_00616_424.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 50.4
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87109,
                    "duration": 38.5,
                    "description": "Review the sample outreach workflow for Demo Account 66 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00621_391.png",
                        "demo_alpha_frame_00622_464.png",
                        "demo_alpha_frame_00623_608.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 38.5
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87111,
                    "duration": 78.1,
                    "description": "Review the sample outreach workflow for Demo Account 80 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00628_058.png",
                        "demo_alpha_frame_00629_823.png",
                        "demo_alpha_frame_00630_059.png",
                        "demo_alpha_frame_00631_742.png",
                        "demo_alpha_frame_00632_826.png",
                        "demo_alpha_frame_00633_733.png",
                        "demo_alpha_frame_00634_562.png",
                        "demo_alpha_frame_00635_061.png",
                        "demo_alpha_frame_00636_583.png",
                        "demo_alpha_frame_00637_476.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 88",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 78.1
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87112,
                    "duration": 24.4,
                    "description": "Review the sample outreach workflow for Demo Account 87 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00638_845.png",
                        "demo_alpha_frame_00639_573.png",
                        "demo_alpha_frame_00640_335.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 24.4
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87120,
                    "duration": 158.7,
                    "description": "Review the sample outreach workflow for Demo Account 54 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00674_496.png",
                        "demo_alpha_frame_00675_141.png",
                        "demo_alpha_frame_00676_578.png",
                        "demo_alpha_frame_00677_550.png",
                        "demo_alpha_frame_00678_535.png",
                        "demo_alpha_frame_00679_838.png",
                        "demo_alpha_frame_00680_915.png",
                        "demo_alpha_frame_00681_076.png",
                        "demo_alpha_frame_00682_687.png",
                        "demo_alpha_frame_00683_835.png",
                        "demo_alpha_frame_00684_671.png",
                        "demo_alpha_frame_00685_660.png",
                        "demo_alpha_frame_00686_885.png",
                        "demo_alpha_frame_00687_161.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 158.7
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87129,
                    "duration": 3.7,
                    "description": "Review the sample outreach workflow for Demo Account 28 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00712_906.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 3.7
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87130,
                    "duration": 20.9,
                    "description": "Review the sample outreach workflow for Demo Account 35 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00713_451.png",
                        "demo_alpha_frame_00714_675.png",
                        "demo_alpha_frame_00715_585.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 20.9
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87136,
                    "duration": 10.4,
                    "description": "Review the sample outreach workflow for Demo Account 70 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00736_782.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 10.4
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87138,
                    "duration": 52.3,
                    "description": "Review the sample outreach workflow for Demo Account 84 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00739_708.png",
                        "demo_alpha_frame_00740_308.png",
                        "demo_alpha_frame_00741_842.png",
                        "demo_alpha_frame_00742_404.png",
                        "demo_alpha_frame_00743_272.png",
                        "demo_alpha_frame_00744_535.png",
                        "demo_alpha_frame_00745_610.png",
                        "demo_alpha_frame_00746_649.png",
                        "demo_alpha_frame_00747_456.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 52.3
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87141,
                    "duration": 40.8,
                    "description": "Review the sample outreach workflow for Demo Account 16 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00756_920.png",
                        "demo_alpha_frame_00757_257.png",
                        "demo_alpha_frame_00758_782.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 30",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 40.8
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87148,
                    "duration": 10.7,
                    "description": "Review the sample outreach workflow for Demo Account 51 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00806_163.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 10.7
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:18",
            "analysisNodeId": 91019,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 18,
                "traceStart": "2025-02-04T11:01:23.258Z",
                "traceEnd": "2025-02-04T12:05:57.804Z",
                "avgDuration": 840.8
            },
            "steps": [
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87077,
                    "duration": 20.9,
                    "description": "Review the sample outreach workflow for Demo Account 48 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00478_889.png",
                        "demo_alpha_frame_00479_364.png",
                        "demo_alpha_frame_00480_590.png",
                        "demo_alpha_frame_00481_685.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 05",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 20.9
                    }
                },
                {
                    "nodeId": "step:review-pipeline-lead-queue-arc#arc",
                    "analysisNodeId": 87096,
                    "duration": 4.6,
                    "description": "Review the sample outreach workflow for Demo Account 64 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00553_110.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 20",
                            "qualifier": "opened"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 4.6
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87098,
                    "duration": 9.0,
                    "description": "Review the sample outreach workflow for Demo Account 78 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00578_512.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 42",
                            "qualifier": "filtered"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 9.0
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87099,
                    "duration": 6.1,
                    "description": "Review the sample outreach workflow for Demo Account 85 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00579_198.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 53",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 6.1
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87100,
                    "duration": 49.6,
                    "description": "Review Sample Session 92 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00580_085.png",
                        "demo_alpha_frame_00581_641.png",
                        "demo_alpha_frame_00582_382.png",
                        "demo_alpha_frame_00583_811.png",
                        "demo_alpha_frame_00584_924.png",
                        "demo_alpha_frame_00585_737.png",
                        "demo_alpha_frame_00586_647.png",
                        "demo_alpha_frame_00587_101.png",
                        "demo_alpha_frame_00588_468.png",
                        "demo_alpha_frame_00589_643.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 64",
                            "qualifier": "filtered"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 49.6
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87101,
                    "duration": 35.5,
                    "description": "Review Sample Session 10 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00590_886.png",
                        "demo_alpha_frame_00591_064.png",
                        "demo_alpha_frame_00592_825.png",
                        "demo_alpha_frame_00593_667.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 75",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 35.5
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87111,
                    "duration": 78.1,
                    "description": "Review the sample outreach workflow for Demo Account 80 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00628_058.png",
                        "demo_alpha_frame_00629_823.png",
                        "demo_alpha_frame_00630_059.png",
                        "demo_alpha_frame_00631_742.png",
                        "demo_alpha_frame_00632_826.png",
                        "demo_alpha_frame_00633_733.png",
                        "demo_alpha_frame_00634_562.png",
                        "demo_alpha_frame_00635_061.png",
                        "demo_alpha_frame_00636_583.png",
                        "demo_alpha_frame_00637_476.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 88",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 78.1
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87113,
                    "duration": 126.5,
                    "description": "Review the sample outreach workflow for Demo Account 94 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00641_558.png",
                        "demo_alpha_frame_00642_928.png",
                        "demo_alpha_frame_00643_062.png",
                        "demo_alpha_frame_00644_591.png",
                        "demo_alpha_frame_00645_701.png",
                        "demo_alpha_frame_00646_936.png",
                        "demo_alpha_frame_00647_126.png",
                        "demo_alpha_frame_00648_525.png",
                        "demo_alpha_frame_00649_556.png",
                        "demo_alpha_frame_00650_229.png",
                        "demo_alpha_frame_00651_218.png",
                        "demo_alpha_frame_00652_660.png",
                        "demo_alpha_frame_00653_013.png",
                        "demo_alpha_frame_00654_795.png",
                        "demo_alpha_frame_00655_144.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 13",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Sample Calendar Item 30",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 126.5
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87114,
                    "duration": 24.4,
                    "description": "Open the fictional record for Demo Account 12 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00656_756.png",
                        "demo_alpha_frame_00657_032.png",
                        "demo_alpha_frame_00658_404.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 24",
                            "qualifier": "configured"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 24.4
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87121,
                    "duration": 6.6,
                    "description": "Review the sample outreach workflow for Demo Account 61 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00688_506.png",
                        "demo_alpha_frame_00689_906.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 04",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 6.6
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87127,
                    "duration": 39.4,
                    "description": "Review the sample outreach workflow for Demo Account 14 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00703_045.png",
                        "demo_alpha_frame_00704_489.png",
                        "demo_alpha_frame_00705_986.png",
                        "demo_alpha_frame_00706_228.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 70",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 39.4
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87140,
                    "duration": 59.0,
                    "description": "Review the sample outreach workflow for Demo Account 98 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00750_509.png",
                        "demo_alpha_frame_00751_010.png",
                        "demo_alpha_frame_00752_920.png",
                        "demo_alpha_frame_00753_081.png",
                        "demo_alpha_frame_00754_735.png",
                        "demo_alpha_frame_00755_120.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 19",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 59.0
                    }
                },
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87141,
                    "duration": 40.8,
                    "description": "Review the sample outreach workflow for Demo Account 16 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00756_920.png",
                        "demo_alpha_frame_00757_257.png",
                        "demo_alpha_frame_00758_782.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 30",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 40.8
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87142,
                    "duration": 104.5,
                    "description": "Review Sample Session 23 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00759_531.png",
                        "demo_alpha_frame_00760_699.png",
                        "demo_alpha_frame_00761_217.png",
                        "demo_alpha_frame_00762_319.png",
                        "demo_alpha_frame_00763_892.png",
                        "demo_alpha_frame_00764_993.png",
                        "demo_alpha_frame_00765_527.png",
                        "demo_alpha_frame_00766_230.png",
                        "demo_alpha_frame_00767_002.png",
                        "demo_alpha_frame_00768_675.png",
                        "demo_alpha_frame_00769_967.png",
                        "demo_alpha_frame_00770_292.png",
                        "demo_alpha_frame_00771_346.png",
                        "demo_alpha_frame_00772_690.png",
                        "demo_alpha_frame_00773_935.png",
                        "demo_alpha_frame_00774_989.png",
                        "demo_alpha_frame_00775_809.png",
                        "demo_alpha_frame_00776_348.png",
                        "demo_alpha_frame_00777_551.png",
                        "demo_alpha_frame_00778_631.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 41",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 104.5
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87143,
                    "duration": 139.2,
                    "description": "Review the sample outreach workflow for Demo Account 30 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00779_544.png",
                        "demo_alpha_frame_00780_186.png",
                        "demo_alpha_frame_00781_076.png",
                        "demo_alpha_frame_00782_181.png",
                        "demo_alpha_frame_00783_126.png",
                        "demo_alpha_frame_00784_773.png",
                        "demo_alpha_frame_00785_164.png",
                        "demo_alpha_frame_00786_537.png",
                        "demo_alpha_frame_00787_467.png",
                        "demo_alpha_frame_00788_117.png",
                        "demo_alpha_frame_00789_211.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 52",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 139.2
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87144,
                    "duration": 96.6,
                    "description": "Review the sample outreach workflow for Demo Account 37 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00790_669.png",
                        "demo_alpha_frame_00791_186.png",
                        "demo_alpha_frame_00792_122.png",
                        "demo_alpha_frame_00793_289.png",
                        "demo_alpha_frame_00794_611.png",
                        "demo_alpha_frame_00795_935.png",
                        "demo_alpha_frame_00796_911.png",
                        "demo_alpha_frame_00797_264.png",
                        "demo_alpha_frame_00798_240.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 63",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 96.6
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:19",
            "analysisNodeId": 91020,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 19,
                "traceStart": "2025-02-04T11:03:00.492Z",
                "traceEnd": "2025-02-04T13:15:18.498Z",
                "avgDuration": 187.8
            },
            "steps": [
                {
                    "nodeId": "step:build-prospect-list-arc#arc",
                    "analysisNodeId": 87079,
                    "duration": 74.5,
                    "description": "Review the sample outreach workflow for Demo Account 62 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00487_699.png",
                        "demo_alpha_frame_00488_163.png",
                        "demo_alpha_frame_00489_275.png",
                        "demo_alpha_frame_00490_338.png",
                        "demo_alpha_frame_00491_606.png",
                        "demo_alpha_frame_00492_526.png",
                        "demo_alpha_frame_00493_661.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 74.5
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87108,
                    "duration": 51.3,
                    "description": "Review Sample Session 59 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00617_373.png",
                        "demo_alpha_frame_00618_713.png",
                        "demo_alpha_frame_00619_200.png",
                        "demo_alpha_frame_00620_854.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 55",
                            "qualifier": "accessed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 51.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87119,
                    "duration": 8.4,
                    "description": "Move through the workspace to continue Sample Workflow 47.",
                    "screenshots": [
                        "demo_alpha_frame_00673_551.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 8.4
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87196,
                    "duration": 53.6,
                    "description": "Move through the workspace to continue Sample Workflow 85.",
                    "screenshots": [
                        "demo_alpha_frame_00976_895.png",
                        "demo_alpha_frame_00977_260.png",
                        "demo_alpha_frame_00978_067.png",
                        "demo_alpha_frame_00979_806.png",
                        "demo_alpha_frame_00980_499.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 51.0
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:20",
            "analysisNodeId": 91021,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 20,
                "traceStart": "2025-02-04T11:04:28.540Z",
                "traceEnd": "2025-02-04T15:11:22.076Z",
                "avgDuration": 758.2
            },
            "steps": [
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87081,
                    "duration": 51.7,
                    "description": "Review Sample Session 69 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00495_791.png",
                        "demo_alpha_frame_00496_344.png",
                        "demo_alpha_frame_00497_650.png",
                        "demo_alpha_frame_00498_849.png",
                        "demo_alpha_frame_00499_078.png",
                        "demo_alpha_frame_00500_660.png",
                        "demo_alpha_frame_00501_275.png",
                        "demo_alpha_frame_00502_365.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 51.7
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87090,
                    "duration": 4.4,
                    "description": "Review Sample Session 29 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00539_896.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 4.4
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87105,
                    "duration": 21.8,
                    "description": "Review Sample Session 38 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00607_750.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 21.8
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87115,
                    "duration": 64.8,
                    "description": "Review Sample Session 19 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00659_295.png",
                        "demo_alpha_frame_00660_346.png",
                        "demo_alpha_frame_00661_482.png",
                        "demo_alpha_frame_00662_261.png",
                        "demo_alpha_frame_00663_941.png",
                        "demo_alpha_frame_00664_460.png",
                        "demo_alpha_frame_00665_989.png",
                        "demo_alpha_frame_00666_888.png",
                        "demo_alpha_frame_00667_076.png",
                        "demo_alpha_frame_00668_797.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 64.8
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87131,
                    "duration": 46.8,
                    "description": "Review Sample Session 42 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00716_731.png",
                        "demo_alpha_frame_00717_889.png",
                        "demo_alpha_frame_00718_075.png",
                        "demo_alpha_frame_00719_329.png",
                        "demo_alpha_frame_00720_670.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 46.8
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87139,
                    "duration": 28.5,
                    "description": "Review Sample Session 91 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00748_354.png",
                        "demo_alpha_frame_00749_905.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 28.5
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87142,
                    "duration": 104.5,
                    "description": "Review Sample Session 23 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00759_531.png",
                        "demo_alpha_frame_00760_699.png",
                        "demo_alpha_frame_00761_217.png",
                        "demo_alpha_frame_00762_319.png",
                        "demo_alpha_frame_00763_892.png",
                        "demo_alpha_frame_00764_993.png",
                        "demo_alpha_frame_00765_527.png",
                        "demo_alpha_frame_00766_230.png",
                        "demo_alpha_frame_00767_002.png",
                        "demo_alpha_frame_00768_675.png",
                        "demo_alpha_frame_00769_967.png",
                        "demo_alpha_frame_00770_292.png",
                        "demo_alpha_frame_00771_346.png",
                        "demo_alpha_frame_00772_690.png",
                        "demo_alpha_frame_00773_935.png",
                        "demo_alpha_frame_00774_989.png",
                        "demo_alpha_frame_00775_809.png",
                        "demo_alpha_frame_00776_348.png",
                        "demo_alpha_frame_00777_551.png",
                        "demo_alpha_frame_00778_631.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 41",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 104.5
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87195,
                    "duration": 34.5,
                    "description": "Review Sample Session 78 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00973_742.png",
                        "demo_alpha_frame_00974_722.png",
                        "demo_alpha_frame_00975_851.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 34.5
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87200,
                    "duration": 88.0,
                    "description": "Review Sample Session 17 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00997_168.png",
                        "demo_alpha_frame_00998_769.png",
                        "demo_alpha_frame_00999_019.png",
                        "demo_alpha_frame_01000_231.png",
                        "demo_alpha_frame_01001_049.png",
                        "demo_alpha_frame_01002_119.png",
                        "demo_alpha_frame_01003_667.png",
                        "demo_alpha_frame_01004_692.png",
                        "demo_alpha_frame_01005_037.png",
                        "demo_alpha_frame_01006_516.png",
                        "demo_alpha_frame_01007_233.png",
                        "demo_alpha_frame_01008_322.png",
                        "demo_alpha_frame_01009_390.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 97",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 88.0
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87206,
                    "duration": 91.3,
                    "description": "Review Sample Session 52 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01022_718.png",
                        "demo_alpha_frame_01023_270.png",
                        "demo_alpha_frame_01024_523.png",
                        "demo_alpha_frame_01025_453.png",
                        "demo_alpha_frame_01026_185.png",
                        "demo_alpha_frame_01027_952.png",
                        "demo_alpha_frame_01028_000.png",
                        "demo_alpha_frame_01029_983.png",
                        "demo_alpha_frame_01030_037.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 66",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 85.6
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87209,
                    "duration": 9.7,
                    "description": "Review Sample Session 73 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01038_188.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 02",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 8.7
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87212,
                    "duration": 24.8,
                    "description": "Review a sample calendar entry for Demo Account 94 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01068_126.png",
                        "demo_alpha_frame_01069_112.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 35",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 19.7
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87279,
                    "duration": 39.8,
                    "description": "Review Sample Session 62 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01366_364.png",
                        "demo_alpha_frame_01367_459.png",
                        "demo_alpha_frame_01368_939.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Session 93",
                            "qualifier": "called"
                        },
                        {
                            "object": "Sample Reference 13",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 34.1
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87312,
                    "duration": 134.9,
                    "description": "Review Sample Session 94 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01431_021.png",
                        "demo_alpha_frame_01432_435.png",
                        "demo_alpha_frame_01433_650.png",
                        "demo_alpha_frame_01434_067.png",
                        "demo_alpha_frame_01435_169.png",
                        "demo_alpha_frame_01436_172.png",
                        "demo_alpha_frame_01437_562.png",
                        "demo_alpha_frame_01438_091.png",
                        "demo_alpha_frame_01439_546.png",
                        "demo_alpha_frame_01440_116.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Session 68",
                            "qualifier": "called"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 134.9
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87320,
                    "duration": 6.2,
                    "description": "Review Sample Session 61 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01496_250.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 6.2
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87323,
                    "duration": 6.5,
                    "description": "Review Sample Session 82 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01499_482.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 92",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 2.8,
                        "Arc": 3.7
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:21",
            "analysisNodeId": 91022,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 21,
                "traceStart": "2025-02-04T11:05:27.320Z",
                "traceEnd": "2025-02-04T15:27:34.522Z",
                "avgDuration": 1073.3
            },
            "steps": [
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87082,
                    "duration": 143.0,
                    "description": "Review the sample outreach workflow for Demo Account 76 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00503_802.png",
                        "demo_alpha_frame_00504_114.png",
                        "demo_alpha_frame_00505_758.png",
                        "demo_alpha_frame_00506_309.png",
                        "demo_alpha_frame_00507_871.png",
                        "demo_alpha_frame_00508_852.png",
                        "demo_alpha_frame_00509_439.png",
                        "demo_alpha_frame_00510_031.png",
                        "demo_alpha_frame_00511_581.png",
                        "demo_alpha_frame_00512_071.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 60",
                            "qualifier": "filtered"
                        },
                        {
                            "object": "Sample Calendar Item 77",
                            "qualifier": "filtered"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 143.0
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87092,
                    "duration": 96.0,
                    "description": "Review the sample outreach workflow for Demo Account 36 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00542_274.png",
                        "demo_alpha_frame_00543_412.png",
                        "demo_alpha_frame_00544_384.png",
                        "demo_alpha_frame_00545_192.png",
                        "demo_alpha_frame_00546_957.png",
                        "demo_alpha_frame_00547_803.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 96.0
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87106,
                    "duration": 72.2,
                    "description": "Review the sample outreach workflow for Demo Account 45 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00608_146.png",
                        "demo_alpha_frame_00609_372.png",
                        "demo_alpha_frame_00610_475.png",
                        "demo_alpha_frame_00611_590.png",
                        "demo_alpha_frame_00612_495.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 72.2
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87113,
                    "duration": 126.5,
                    "description": "Review the sample outreach workflow for Demo Account 94 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00641_558.png",
                        "demo_alpha_frame_00642_928.png",
                        "demo_alpha_frame_00643_062.png",
                        "demo_alpha_frame_00644_591.png",
                        "demo_alpha_frame_00645_701.png",
                        "demo_alpha_frame_00646_936.png",
                        "demo_alpha_frame_00647_126.png",
                        "demo_alpha_frame_00648_525.png",
                        "demo_alpha_frame_00649_556.png",
                        "demo_alpha_frame_00650_229.png",
                        "demo_alpha_frame_00651_218.png",
                        "demo_alpha_frame_00652_660.png",
                        "demo_alpha_frame_00653_013.png",
                        "demo_alpha_frame_00654_795.png",
                        "demo_alpha_frame_00655_144.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 13",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Sample Calendar Item 30",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 126.5
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87116,
                    "duration": 8.7,
                    "description": "Review Sample Session 26 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00669_081.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 46",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 8.7
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87127,
                    "duration": 39.4,
                    "description": "Review the sample outreach workflow for Demo Account 14 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00703_045.png",
                        "demo_alpha_frame_00704_489.png",
                        "demo_alpha_frame_00705_986.png",
                        "demo_alpha_frame_00706_228.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 70",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 39.4
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87133,
                    "duration": 95.7,
                    "description": "Review the sample outreach workflow for Demo Account 49 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00725_774.png",
                        "demo_alpha_frame_00726_431.png",
                        "demo_alpha_frame_00727_756.png",
                        "demo_alpha_frame_00728_860.png",
                        "demo_alpha_frame_00729_598.png",
                        "demo_alpha_frame_00730_697.png",
                        "demo_alpha_frame_00731_865.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 39",
                            "qualifier": "filtered-by"
                        },
                        {
                            "object": "Demo Item 56",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 95.7
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87134,
                    "duration": 9.7,
                    "description": "Review the sample outreach workflow for Demo Account 56 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00732_010.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 50",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 9.7
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87143,
                    "duration": 139.2,
                    "description": "Review the sample outreach workflow for Demo Account 30 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00779_544.png",
                        "demo_alpha_frame_00780_186.png",
                        "demo_alpha_frame_00781_076.png",
                        "demo_alpha_frame_00782_181.png",
                        "demo_alpha_frame_00783_126.png",
                        "demo_alpha_frame_00784_773.png",
                        "demo_alpha_frame_00785_164.png",
                        "demo_alpha_frame_00786_537.png",
                        "demo_alpha_frame_00787_467.png",
                        "demo_alpha_frame_00788_117.png",
                        "demo_alpha_frame_00789_211.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 52",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 139.2
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87144,
                    "duration": 96.6,
                    "description": "Review the sample outreach workflow for Demo Account 37 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00790_669.png",
                        "demo_alpha_frame_00791_186.png",
                        "demo_alpha_frame_00792_122.png",
                        "demo_alpha_frame_00793_289.png",
                        "demo_alpha_frame_00794_611.png",
                        "demo_alpha_frame_00795_935.png",
                        "demo_alpha_frame_00796_911.png",
                        "demo_alpha_frame_00797_264.png",
                        "demo_alpha_frame_00798_240.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 63",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 96.6
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87190,
                    "duration": 27.6,
                    "description": "Review the sample outreach workflow for Demo Account 57 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00928_572.png",
                        "demo_alpha_frame_00929_046.png",
                        "demo_alpha_frame_00930_623.png",
                        "demo_alpha_frame_00931_968.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 84",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 27.6
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87194,
                    "duration": 46.1,
                    "description": "Review the sample outreach workflow for Demo Account 71 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00965_268.png",
                        "demo_alpha_frame_00966_150.png",
                        "demo_alpha_frame_00967_046.png",
                        "demo_alpha_frame_00968_881.png",
                        "demo_alpha_frame_00969_667.png",
                        "demo_alpha_frame_00970_013.png",
                        "demo_alpha_frame_00971_410.png",
                        "demo_alpha_frame_00972_709.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 43.4
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87217,
                    "duration": 26.7,
                    "description": "Review the sample outreach workflow for Demo Account 40 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01086_528.png",
                        "demo_alpha_frame_01087_150.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 26.7
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87229,
                    "duration": 10.6,
                    "description": "Review the sample outreach workflow for Demo Account 35 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01110_984.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 10.6
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87236,
                    "duration": 16.2,
                    "description": "Review the sample outreach workflow for Demo Account 77 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01119_781.png",
                        "demo_alpha_frame_01120_214.png",
                        "demo_alpha_frame_01121_119.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 16.2
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87252,
                    "duration": 37.3,
                    "description": "Review the sample outreach workflow for Demo Account 93 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01263_622.png",
                        "demo_alpha_frame_01264_724.png",
                        "demo_alpha_frame_01265_971.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 87",
                            "qualifier": "downloaded"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 32.6
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87295,
                    "duration": 28.4,
                    "description": "Review the sample outreach workflow for Demo Account 71 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01399_957.png",
                        "demo_alpha_frame_01400_372.png",
                        "demo_alpha_frame_01401_274.png",
                        "demo_alpha_frame_01402_715.png",
                        "demo_alpha_frame_01403_817.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 75",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 28.4
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87325,
                    "duration": 27.5,
                    "description": "Review the sample outreach workflow for Demo Account 96 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01506_166.png",
                        "demo_alpha_frame_01507_131.png",
                        "demo_alpha_frame_01508_190.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 17",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 27.4
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87327,
                    "duration": 18.6,
                    "description": "Review the sample outreach workflow for Demo Account 14 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01510_721.png",
                        "demo_alpha_frame_01511_480.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 39",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 10.7,
                        "Salesforce": 7.9
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87331,
                    "duration": 7.3,
                    "description": "Review the sample outreach workflow for Demo Account 35 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01527_372.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 7.3
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:22",
            "analysisNodeId": 91023,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 22,
                "traceStart": "2025-02-04T11:05:27.320Z",
                "traceEnd": "2025-02-04T15:12:43.088Z",
                "avgDuration": 771.3
            },
            "steps": [
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87082,
                    "duration": 143.0,
                    "description": "Review the sample outreach workflow for Demo Account 76 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00503_802.png",
                        "demo_alpha_frame_00504_114.png",
                        "demo_alpha_frame_00505_758.png",
                        "demo_alpha_frame_00506_309.png",
                        "demo_alpha_frame_00507_871.png",
                        "demo_alpha_frame_00508_852.png",
                        "demo_alpha_frame_00509_439.png",
                        "demo_alpha_frame_00510_031.png",
                        "demo_alpha_frame_00511_581.png",
                        "demo_alpha_frame_00512_071.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 60",
                            "qualifier": "filtered"
                        },
                        {
                            "object": "Sample Calendar Item 77",
                            "qualifier": "filtered"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 143.0
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87092,
                    "duration": 96.0,
                    "description": "Review the sample outreach workflow for Demo Account 36 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00542_274.png",
                        "demo_alpha_frame_00543_412.png",
                        "demo_alpha_frame_00544_384.png",
                        "demo_alpha_frame_00545_192.png",
                        "demo_alpha_frame_00546_957.png",
                        "demo_alpha_frame_00547_803.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 96.0
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87113,
                    "duration": 126.5,
                    "description": "Review the sample outreach workflow for Demo Account 94 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00641_558.png",
                        "demo_alpha_frame_00642_928.png",
                        "demo_alpha_frame_00643_062.png",
                        "demo_alpha_frame_00644_591.png",
                        "demo_alpha_frame_00645_701.png",
                        "demo_alpha_frame_00646_936.png",
                        "demo_alpha_frame_00647_126.png",
                        "demo_alpha_frame_00648_525.png",
                        "demo_alpha_frame_00649_556.png",
                        "demo_alpha_frame_00650_229.png",
                        "demo_alpha_frame_00651_218.png",
                        "demo_alpha_frame_00652_660.png",
                        "demo_alpha_frame_00653_013.png",
                        "demo_alpha_frame_00654_795.png",
                        "demo_alpha_frame_00655_144.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 13",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Sample Calendar Item 30",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 126.5
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87116,
                    "duration": 8.7,
                    "description": "Review Sample Session 26 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00669_081.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 46",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 8.7
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87133,
                    "duration": 95.7,
                    "description": "Review the sample outreach workflow for Demo Account 49 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00725_774.png",
                        "demo_alpha_frame_00726_431.png",
                        "demo_alpha_frame_00727_756.png",
                        "demo_alpha_frame_00728_860.png",
                        "demo_alpha_frame_00729_598.png",
                        "demo_alpha_frame_00730_697.png",
                        "demo_alpha_frame_00731_865.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 39",
                            "qualifier": "filtered-by"
                        },
                        {
                            "object": "Demo Item 56",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 95.7
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87134,
                    "duration": 9.7,
                    "description": "Review the sample outreach workflow for Demo Account 56 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00732_010.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 50",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 9.7
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87143,
                    "duration": 139.2,
                    "description": "Review the sample outreach workflow for Demo Account 30 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00779_544.png",
                        "demo_alpha_frame_00780_186.png",
                        "demo_alpha_frame_00781_076.png",
                        "demo_alpha_frame_00782_181.png",
                        "demo_alpha_frame_00783_126.png",
                        "demo_alpha_frame_00784_773.png",
                        "demo_alpha_frame_00785_164.png",
                        "demo_alpha_frame_00786_537.png",
                        "demo_alpha_frame_00787_467.png",
                        "demo_alpha_frame_00788_117.png",
                        "demo_alpha_frame_00789_211.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 52",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 139.2
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87144,
                    "duration": 96.6,
                    "description": "Review the sample outreach workflow for Demo Account 37 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00790_669.png",
                        "demo_alpha_frame_00791_186.png",
                        "demo_alpha_frame_00792_122.png",
                        "demo_alpha_frame_00793_289.png",
                        "demo_alpha_frame_00794_611.png",
                        "demo_alpha_frame_00795_935.png",
                        "demo_alpha_frame_00796_911.png",
                        "demo_alpha_frame_00797_264.png",
                        "demo_alpha_frame_00798_240.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 63",
                            "qualifier": "filtered-by"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 96.6
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87295,
                    "duration": 28.4,
                    "description": "Review the sample outreach workflow for Demo Account 71 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01399_957.png",
                        "demo_alpha_frame_01400_372.png",
                        "demo_alpha_frame_01401_274.png",
                        "demo_alpha_frame_01402_715.png",
                        "demo_alpha_frame_01403_817.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 75",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 28.4
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87325,
                    "duration": 27.5,
                    "description": "Review the sample outreach workflow for Demo Account 96 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01506_166.png",
                        "demo_alpha_frame_01507_131.png",
                        "demo_alpha_frame_01508_190.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 17",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 27.4
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:23",
            "analysisNodeId": 91024,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 23,
                "traceStart": "2025-02-04T11:21:16.258Z",
                "traceEnd": "2025-02-04T11:40:26.886Z",
                "avgDuration": 100.5
            },
            "steps": [
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87104,
                    "duration": 28.9,
                    "description": "Open the fictional record for Demo Account 31 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00604_364.png",
                        "demo_alpha_frame_00605_073.png",
                        "demo_alpha_frame_00606_989.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 28.9
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87114,
                    "duration": 24.4,
                    "description": "Open the fictional record for Demo Account 12 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00656_756.png",
                        "demo_alpha_frame_00657_032.png",
                        "demo_alpha_frame_00658_404.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 24",
                            "qualifier": "configured"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 24.4
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87128,
                    "duration": 47.2,
                    "description": "Open the fictional record for Demo Account 21 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00707_181.png",
                        "demo_alpha_frame_00708_759.png",
                        "demo_alpha_frame_00709_441.png",
                        "demo_alpha_frame_00710_328.png",
                        "demo_alpha_frame_00711_638.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 47.2
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:27",
            "analysisNodeId": 91028,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 27,
                "traceStart": "2025-02-04T13:20:00.843Z",
                "traceEnd": "2025-02-04T15:26:28.661Z",
                "avgDuration": 108.3
            },
            "steps": [
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87201,
                    "duration": 32.8,
                    "description": "Open the fictional record for Demo Account 24 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01010_939.png",
                        "demo_alpha_frame_01011_349.png",
                        "demo_alpha_frame_01012_879.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 11",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 32.8
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87204,
                    "duration": 9.5,
                    "description": "Open the fictional record for Demo Account 38 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01018_390.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 44",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 61",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 7.2
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87276,
                    "duration": 16.1,
                    "description": "Open the fictional record for Demo Account 41 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01359_575.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 60",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 77",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 11.2
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87281,
                    "duration": 25.7,
                    "description": "Open the fictional record for Demo Account 76 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01376_228.png",
                        "demo_alpha_frame_01377_030.png",
                        "demo_alpha_frame_01378_106.png",
                        "demo_alpha_frame_01379_788.png",
                        "demo_alpha_frame_01380_693.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 18",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 25.7
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87329,
                    "duration": 24.2,
                    "description": "Open the fictional record for Demo Account 28 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01519_474.png",
                        "demo_alpha_frame_01520_936.png",
                        "demo_alpha_frame_01521_690.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 61",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 24.2
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:28",
            "analysisNodeId": 91029,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 28,
                "traceStart": "2025-02-04T13:20:45.714Z",
                "traceEnd": "2025-02-04T15:06:48.600Z",
                "avgDuration": 214.5
            },
            "steps": [
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87203,
                    "duration": 27.2,
                    "description": "Research Demo Account 31 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01014_244.png",
                        "demo_alpha_frame_01015_283.png",
                        "demo_alpha_frame_01016_329.png",
                        "demo_alpha_frame_01017_788.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 33",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 24.7
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-salesforce#salesforce",
                    "analysisNodeId": 87205,
                    "duration": 28.1,
                    "description": "Open the fictional record for Demo Account 45 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01019_149.png",
                        "demo_alpha_frame_01020_721.png",
                        "demo_alpha_frame_01021_743.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 55",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 72",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 28.1
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87225,
                    "duration": 13.9,
                    "description": "Research Demo Account 96 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01104_079.png",
                        "demo_alpha_frame_01105_998.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 81",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 13.9
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-salesforce#salesforce",
                    "analysisNodeId": 87227,
                    "duration": 31.8,
                    "description": "Open the fictional record for Demo Account 21 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01107_944.png",
                        "demo_alpha_frame_01108_093.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 06",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 23",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 29.5
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87251,
                    "duration": 37.9,
                    "description": "Research Demo Account 86 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01259_122.png",
                        "demo_alpha_frame_01260_121.png",
                        "demo_alpha_frame_01261_647.png",
                        "demo_alpha_frame_01262_893.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 76",
                            "qualifier": "searched"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 37.9
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87265,
                    "duration": 12.9,
                    "description": "Research Demo Account 60 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01298_936.png",
                        "demo_alpha_frame_01299_305.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 36",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 53",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 7.2
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87274,
                    "duration": 20.6,
                    "description": "Research Demo Account 27 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01355_211.png",
                        "demo_alpha_frame_01356_211.png",
                        "demo_alpha_frame_01357_260.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 38",
                            "qualifier": "searched"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 20.6
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87278,
                    "duration": 21.6,
                    "description": "Research Demo Account 55 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01362_822.png",
                        "demo_alpha_frame_01363_145.png",
                        "demo_alpha_frame_01364_553.png",
                        "demo_alpha_frame_01365_054.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 82",
                            "qualifier": "searched"
                        },
                        {
                            "object": "Sample Reference 02",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 20.2
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87282,
                    "duration": 4.4,
                    "description": "Research Demo Account 83 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01381_625.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 29",
                            "qualifier": "searched"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 3.4,
                        "Arc": 1.0
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87287,
                    "duration": 7.3,
                    "description": "Research Demo Account 22 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01386_196.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 84",
                            "qualifier": "searched"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 7.3
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-salesforce#salesforce",
                    "analysisNodeId": 87315,
                    "duration": 8.8,
                    "description": "Review a sample calendar entry for Demo Account 26 and update its demo availability in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01467_865.png",
                        "demo_alpha_frame_01468_953.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 04",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 21",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 8.8
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:29",
            "analysisNodeId": 91030,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 29,
                "traceStart": "2025-02-04T13:23:32.798Z",
                "traceEnd": "2025-02-04T14:53:02.348Z",
                "avgDuration": 565.7
            },
            "steps": [
                {
                    "nodeId": "step:research-target-account-gmail#gmail",
                    "analysisNodeId": 87207,
                    "duration": 51.0,
                    "description": "Research Demo Account 59 and summarize its fictional business profile in Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01031_169.png",
                        "demo_alpha_frame_01032_951.png",
                        "demo_alpha_frame_01033_042.png",
                        "demo_alpha_frame_01034_512.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 77",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 43.3
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-salesforce#salesforce",
                    "analysisNodeId": 87208,
                    "duration": 16.3,
                    "description": "Open the fictional record for Demo Account 66 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01035_806.png",
                        "demo_alpha_frame_01036_396.png",
                        "demo_alpha_frame_01037_503.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 88",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 08",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 12.2
                    }
                },
                {
                    "nodeId": "step:review-pipeline-lead-queue-arc#arc",
                    "analysisNodeId": 87213,
                    "duration": 49.6,
                    "description": "Review the sample outreach workflow for Demo Account 12 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01070_151.png",
                        "demo_alpha_frame_01071_420.png",
                        "demo_alpha_frame_01072_133.png",
                        "demo_alpha_frame_01073_477.png",
                        "demo_alpha_frame_01074_819.png",
                        "demo_alpha_frame_01075_759.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 46",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 25.6,
                        "Gmail": 24.0
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87225,
                    "duration": 13.9,
                    "description": "Research Demo Account 96 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01104_079.png",
                        "demo_alpha_frame_01105_998.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 81",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 13.9
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-salesforce#salesforce",
                    "analysisNodeId": 87227,
                    "duration": 31.8,
                    "description": "Open the fictional record for Demo Account 21 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01107_944.png",
                        "demo_alpha_frame_01108_093.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 06",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 23",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 29.5
                    }
                },
                {
                    "nodeId": "step:review-pipeline-lead-queue-salesforce#salesforce",
                    "analysisNodeId": 87241,
                    "duration": 344.9,
                    "description": "Review the sample outreach workflow for Demo Account 16 and update its demo status in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01153_735.png",
                        "demo_alpha_frame_01154_938.png",
                        "demo_alpha_frame_01155_756.png",
                        "demo_alpha_frame_01156_337.png",
                        "demo_alpha_frame_01157_477.png",
                        "demo_alpha_frame_01158_445.png",
                        "demo_alpha_frame_01159_924.png",
                        "demo_alpha_frame_01160_334.png",
                        "demo_alpha_frame_01161_481.png",
                        "demo_alpha_frame_01162_072.png",
                        "demo_alpha_frame_01163_450.png",
                        "demo_alpha_frame_01164_033.png",
                        "demo_alpha_frame_01165_360.png",
                        "demo_alpha_frame_01166_453.png",
                        "demo_alpha_frame_01167_676.png",
                        "demo_alpha_frame_01168_117.png",
                        "demo_alpha_frame_01169_287.png",
                        "demo_alpha_frame_01170_155.png",
                        "demo_alpha_frame_01171_829.png",
                        "demo_alpha_frame_01172_663.png",
                        "demo_alpha_frame_01173_231.png",
                        "demo_alpha_frame_01174_127.png",
                        "demo_alpha_frame_01175_683.png",
                        "demo_alpha_frame_01176_520.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 63",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 344.9
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87265,
                    "duration": 12.9,
                    "description": "Research Demo Account 60 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01298_936.png",
                        "demo_alpha_frame_01299_305.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 36",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 53",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 7.2
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87276,
                    "duration": 16.1,
                    "description": "Open the fictional record for Demo Account 41 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01359_575.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 60",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 77",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 11.2
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87277,
                    "duration": 18.7,
                    "description": "Open the fictional record for Demo Account 48 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01360_639.png",
                        "demo_alpha_frame_01361_341.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 71",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 18.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#salesforce",
                    "analysisNodeId": 87283,
                    "duration": 4.1,
                    "description": "Move through the workspace to continue Sample Workflow 90.",
                    "screenshots": [
                        "demo_alpha_frame_01382_021.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 40",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 4.1
                    }
                },
                {
                    "nodeId": "step:research-target-account-arc#arc",
                    "analysisNodeId": 87284,
                    "duration": 6.4,
                    "description": "Research Demo Account 97 and summarize its fictional business profile in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01383_176.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 51",
                            "qualifier": "searched"
                        },
                        {
                            "object": "Sample Reference 68",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 6.4
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:30",
            "analysisNodeId": 91031,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 30,
                "traceStart": "2025-02-04T13:24:25.184Z",
                "traceEnd": "2025-02-04T13:37:03.740Z",
                "avgDuration": 123.3
            },
            "steps": [
                {
                    "nodeId": "step:enrich-contact-data-salesforce#salesforce",
                    "analysisNodeId": 87208,
                    "duration": 16.3,
                    "description": "Open the fictional record for Demo Account 66 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01035_806.png",
                        "demo_alpha_frame_01036_396.png",
                        "demo_alpha_frame_01037_503.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 88",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 08",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 12.2
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87209,
                    "duration": 9.7,
                    "description": "Review Sample Session 73 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01038_188.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 02",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 8.7
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87212,
                    "duration": 24.8,
                    "description": "Review a sample calendar entry for Demo Account 94 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01068_126.png",
                        "demo_alpha_frame_01069_112.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 35",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 19.7
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87225,
                    "duration": 13.9,
                    "description": "Research Demo Account 96 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01104_079.png",
                        "demo_alpha_frame_01105_998.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 81",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 13.9
                    }
                },
                {
                    "nodeId": "step:update-crm-record-arc#arc",
                    "analysisNodeId": 87226,
                    "duration": 11.0,
                    "description": "Open the fictional record for Demo Account 14 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01106_338.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 92",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 11.0
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-salesforce#salesforce",
                    "analysisNodeId": 87227,
                    "duration": 31.8,
                    "description": "Open the fictional record for Demo Account 21 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01107_944.png",
                        "demo_alpha_frame_01108_093.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 06",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 23",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 29.5
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87228,
                    "duration": 15.8,
                    "description": "Review Sample Session 28 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01109_610.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 17",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 11.7
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:31",
            "analysisNodeId": 91032,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 31,
                "traceStart": "2025-02-04T13:29:46.838Z",
                "traceEnd": "2025-02-04T13:38:42.914Z",
                "avgDuration": 208.0
            },
            "steps": [
                {
                    "nodeId": "step:review-pipeline-lead-queue-arc#arc",
                    "analysisNodeId": 87213,
                    "duration": 49.6,
                    "description": "Review the sample outreach workflow for Demo Account 12 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01070_151.png",
                        "demo_alpha_frame_01071_420.png",
                        "demo_alpha_frame_01072_133.png",
                        "demo_alpha_frame_01073_477.png",
                        "demo_alpha_frame_01074_819.png",
                        "demo_alpha_frame_01075_759.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 46",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 24.0,
                        "Arc": 25.6
                    }
                },
                {
                    "nodeId": "step:create-crm-lead-contact-record-arc#arc",
                    "analysisNodeId": 87214,
                    "duration": 46.1,
                    "description": "Open the fictional record for Demo Account 19 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01076_780.png",
                        "demo_alpha_frame_01077_984.png",
                        "demo_alpha_frame_01078_304.png",
                        "demo_alpha_frame_01079_903.png",
                        "demo_alpha_frame_01080_901.png",
                        "demo_alpha_frame_01081_345.png",
                        "demo_alpha_frame_01082_548.png",
                        "demo_alpha_frame_01083_159.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 57",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Item 74",
                            "qualifier": "created"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 20.5,
                        "Arc": 25.6
                    }
                },
                {
                    "nodeId": "step:create-crm-lead-contact-record-salesforce#salesforce",
                    "analysisNodeId": 87215,
                    "duration": 11.5,
                    "description": "Open the fictional record for Demo Account 26 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01084_100.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 68",
                            "qualifier": "created"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 6.8
                    }
                },
                {
                    "nodeId": "step:update-crm-record-salesforce#salesforce",
                    "analysisNodeId": 87216,
                    "duration": 12.6,
                    "description": "Open the fictional record for Demo Account 33 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01085_968.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 79",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 12.6
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87219,
                    "duration": 11.9,
                    "description": "Review a sample calendar entry for Demo Account 54 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01089_588.png",
                        "demo_alpha_frame_01090_328.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 15",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 11.9
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87220,
                    "duration": 5.7,
                    "description": "Review a sample calendar entry for Demo Account 61 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01091_139.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 26",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 5.7
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87228,
                    "duration": 15.8,
                    "description": "Review Sample Session 28 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01109_610.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 17",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 11.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#salesforce",
                    "analysisNodeId": 87231,
                    "duration": 15.8,
                    "description": "Move through the workspace to continue Sample Workflow 42.",
                    "screenshots": [
                        "demo_alpha_frame_01112_033.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 50",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 11.5
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#gmail",
                    "analysisNodeId": 87232,
                    "duration": 12.5,
                    "description": "Review the fictional conversation in #demo-ops-49 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01113_130.png",
                        "demo_alpha_frame_01114_794.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 61",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 8.5
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87233,
                    "duration": 8.2,
                    "description": "Review a sample calendar entry for Demo Account 56 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01115_020.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 72",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 89",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 8.2
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87234,
                    "duration": 8.8,
                    "description": "Review a sample calendar entry for Demo Account 63 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01116_912.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 5.1
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87235,
                    "duration": 9.5,
                    "description": "Review a sample calendar entry for Demo Account 70 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01117_791.png",
                        "demo_alpha_frame_01118_243.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 9.5
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:32",
            "analysisNodeId": 91033,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 32,
                "traceStart": "2025-02-04T13:30:39.054Z",
                "traceEnd": "2025-02-04T15:12:13.164Z",
                "avgDuration": 116.0
            },
            "steps": [
                {
                    "nodeId": "step:create-crm-lead-contact-record-arc#arc",
                    "analysisNodeId": 87214,
                    "duration": 46.1,
                    "description": "Open the fictional record for Demo Account 19 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01076_780.png",
                        "demo_alpha_frame_01077_984.png",
                        "demo_alpha_frame_01078_304.png",
                        "demo_alpha_frame_01079_903.png",
                        "demo_alpha_frame_01080_901.png",
                        "demo_alpha_frame_01081_345.png",
                        "demo_alpha_frame_01082_548.png",
                        "demo_alpha_frame_01083_159.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 57",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Item 74",
                            "qualifier": "created"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 20.5,
                        "Arc": 25.6
                    }
                },
                {
                    "nodeId": "step:create-crm-lead-contact-record-salesforce#salesforce",
                    "analysisNodeId": 87215,
                    "duration": 11.5,
                    "description": "Open the fictional record for Demo Account 26 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01084_100.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 68",
                            "qualifier": "created"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 6.8
                    }
                },
                {
                    "nodeId": "step:update-crm-record-salesforce#salesforce",
                    "analysisNodeId": 87216,
                    "duration": 12.6,
                    "description": "Open the fictional record for Demo Account 33 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01085_968.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 79",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 12.6
                    }
                },
                {
                    "nodeId": "step:create-crm-lead-contact-record-salesforce#salesforce",
                    "analysisNodeId": 87324,
                    "duration": 45.8,
                    "description": "Open the fictional record for Demo Account 89 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01500_941.png",
                        "demo_alpha_frame_01501_163.png",
                        "demo_alpha_frame_01502_199.png",
                        "demo_alpha_frame_01503_251.png",
                        "demo_alpha_frame_01504_066.png",
                        "demo_alpha_frame_01505_735.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 06",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Item 23",
                            "qualifier": "created"
                        },
                        {
                            "object": "Demo Item 40",
                            "qualifier": "created"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 45.8
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:37",
            "analysisNodeId": 91038,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 37,
                "traceStart": "2025-02-04T14:52:44.870Z",
                "traceEnd": "2025-02-04T15:12:13.164Z",
                "avgDuration": 672.7
            },
            "steps": [
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87282,
                    "duration": 4.4,
                    "description": "Research Demo Account 83 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01381_625.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 29",
                            "qualifier": "searched"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 1.0,
                        "Salesforce": 3.4
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#salesforce",
                    "analysisNodeId": 87283,
                    "duration": 4.1,
                    "description": "Move through the workspace to continue Sample Workflow 90.",
                    "screenshots": [
                        "demo_alpha_frame_01382_021.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 40",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 4.1
                    }
                },
                {
                    "nodeId": "step:research-target-account-arc#arc",
                    "analysisNodeId": 87284,
                    "duration": 6.4,
                    "description": "Research Demo Account 97 and summarize its fictional business profile in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01383_176.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 51",
                            "qualifier": "searched"
                        },
                        {
                            "object": "Sample Reference 68",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 6.4
                    }
                },
                {
                    "nodeId": "step:research-target-account-salesforce#salesforce",
                    "analysisNodeId": 87287,
                    "duration": 7.3,
                    "description": "Research Demo Account 22 and summarize its fictional business profile in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01386_196.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 84",
                            "qualifier": "searched"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 7.3
                    }
                },
                {
                    "nodeId": "step:review-pipeline-lead-queue-salesforce#salesforce",
                    "analysisNodeId": 87288,
                    "duration": 19.0,
                    "description": "Review the sample outreach workflow for Demo Account 29 and update its demo status in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01387_076.png",
                        "demo_alpha_frame_01388_161.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 95",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 15",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 19.0
                    }
                },
                {
                    "nodeId": "step:research-target-account-arc#arc",
                    "analysisNodeId": 87306,
                    "duration": 31.1,
                    "description": "Research Demo Account 52 and summarize its fictional business profile in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01420_275.png",
                        "demo_alpha_frame_01421_895.png",
                        "demo_alpha_frame_01422_624.png",
                        "demo_alpha_frame_01423_690.png",
                        "demo_alpha_frame_01424_979.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 02",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 31.1
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87307,
                    "duration": 14.7,
                    "description": "Open the fictional record for Demo Account 59 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01425_399.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 13",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 14.7
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87308,
                    "duration": 5.5,
                    "description": "Open the fictional record for Demo Account 66 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01426_732.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 24",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 41",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 5.5
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87312,
                    "duration": 134.9,
                    "description": "Review Sample Session 94 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01431_021.png",
                        "demo_alpha_frame_01432_435.png",
                        "demo_alpha_frame_01433_650.png",
                        "demo_alpha_frame_01434_067.png",
                        "demo_alpha_frame_01435_169.png",
                        "demo_alpha_frame_01436_172.png",
                        "demo_alpha_frame_01437_562.png",
                        "demo_alpha_frame_01438_091.png",
                        "demo_alpha_frame_01439_546.png",
                        "demo_alpha_frame_01440_116.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Session 68",
                            "qualifier": "called"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 134.9
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-arc#arc",
                    "analysisNodeId": 87313,
                    "duration": 22.9,
                    "description": "Review a sample calendar entry for Demo Account 12 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01441_614.png",
                        "demo_alpha_frame_01442_814.png",
                        "demo_alpha_frame_01443_371.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 79",
                            "qualifier": "created"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 19.6
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-arc#arc",
                    "analysisNodeId": 87314,
                    "duration": 127.0,
                    "description": "Review a sample calendar entry for Demo Account 19 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01444_763.png",
                        "demo_alpha_frame_01445_391.png",
                        "demo_alpha_frame_01446_900.png",
                        "demo_alpha_frame_01447_599.png",
                        "demo_alpha_frame_01448_942.png",
                        "demo_alpha_frame_01449_508.png",
                        "demo_alpha_frame_01450_775.png",
                        "demo_alpha_frame_01451_847.png",
                        "demo_alpha_frame_01452_199.png",
                        "demo_alpha_frame_01453_264.png",
                        "demo_alpha_frame_01454_069.png",
                        "demo_alpha_frame_01455_868.png",
                        "demo_alpha_frame_01456_042.png",
                        "demo_alpha_frame_01457_749.png",
                        "demo_alpha_frame_01458_081.png",
                        "demo_alpha_frame_01459_861.png",
                        "demo_alpha_frame_01460_966.png",
                        "demo_alpha_frame_01461_331.png",
                        "demo_alpha_frame_01462_117.png",
                        "demo_alpha_frame_01463_045.png",
                        "demo_alpha_frame_01464_102.png",
                        "demo_alpha_frame_01465_816.png",
                        "demo_alpha_frame_01466_074.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 90",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 123.8
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-salesforce#salesforce",
                    "analysisNodeId": 87315,
                    "duration": 8.8,
                    "description": "Review a sample calendar entry for Demo Account 26 and update its demo availability in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01467_865.png",
                        "demo_alpha_frame_01468_953.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 04",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 21",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 8.8
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-arc#arc",
                    "analysisNodeId": 87316,
                    "duration": 17.4,
                    "description": "Review a sample calendar entry for Demo Account 33 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01469_197.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 15",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 5.5,
                        "Arc": 9.3
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-arc#arc",
                    "analysisNodeId": 87317,
                    "duration": 21.3,
                    "description": "Review a sample calendar entry for Demo Account 40 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01470_278.png",
                        "demo_alpha_frame_01471_600.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 26",
                            "qualifier": "finalized"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 21.3
                    }
                },
                {
                    "nodeId": "step:lookup-reference-arc#arc",
                    "analysisNodeId": 87318,
                    "duration": 13.8,
                    "description": "Review and update Sample Enablement Guide 47 with fictional onboarding details in Arc.",
                    "screenshots": [],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 13.8
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87319,
                    "duration": 158.3,
                    "description": "Review a sample calendar entry for Demo Account 54 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01472_984.png",
                        "demo_alpha_frame_01473_212.png",
                        "demo_alpha_frame_01474_957.png",
                        "demo_alpha_frame_01475_174.png",
                        "demo_alpha_frame_01476_655.png",
                        "demo_alpha_frame_01477_398.png",
                        "demo_alpha_frame_01478_369.png",
                        "demo_alpha_frame_01479_396.png",
                        "demo_alpha_frame_01480_255.png",
                        "demo_alpha_frame_01481_141.png",
                        "demo_alpha_frame_01482_364.png",
                        "demo_alpha_frame_01483_114.png",
                        "demo_alpha_frame_01484_876.png",
                        "demo_alpha_frame_01485_582.png",
                        "demo_alpha_frame_01486_798.png",
                        "demo_alpha_frame_01487_475.png",
                        "demo_alpha_frame_01488_140.png",
                        "demo_alpha_frame_01489_754.png",
                        "demo_alpha_frame_01490_813.png",
                        "demo_alpha_frame_01491_599.png",
                        "demo_alpha_frame_01492_599.png",
                        "demo_alpha_frame_01493_421.png",
                        "demo_alpha_frame_01494_661.png",
                        "demo_alpha_frame_01495_816.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 48",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 65",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 158.3
                    }
                },
                {
                    "nodeId": "step:create-crm-lead-contact-record-arc#arc",
                    "analysisNodeId": 87321,
                    "duration": 18.2,
                    "description": "Open the fictional record for Demo Account 68 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01497_530.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 70",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 87",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 14.4
                    }
                },
                {
                    "nodeId": "step:create-crm-lead-contact-record-arc#arc",
                    "analysisNodeId": 87322,
                    "duration": 5.3,
                    "description": "Open the fictional record for Demo Account 75 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01498_381.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 81",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 01",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 3.4,
                        "Salesforce": 1.9
                    }
                },
                {
                    "nodeId": "step:make-outbound-call-log-call-outcome-arc#arc",
                    "analysisNodeId": 87323,
                    "duration": 6.5,
                    "description": "Review Sample Session 82 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01499_482.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 92",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 3.7,
                        "Salesforce": 2.8
                    }
                },
                {
                    "nodeId": "step:create-crm-lead-contact-record-salesforce#salesforce",
                    "analysisNodeId": 87324,
                    "duration": 45.8,
                    "description": "Open the fictional record for Demo Account 89 and update its sample fields in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01500_941.png",
                        "demo_alpha_frame_01501_163.png",
                        "demo_alpha_frame_01502_199.png",
                        "demo_alpha_frame_01503_251.png",
                        "demo_alpha_frame_01504_066.png",
                        "demo_alpha_frame_01505_735.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 06",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Item 23",
                            "qualifier": "created"
                        },
                        {
                            "object": "Demo Item 40",
                            "qualifier": "created"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 45.8
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:38",
            "analysisNodeId": 91039,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 38,
                "traceStart": "2025-02-04T14:55:32.907Z",
                "traceEnd": "2025-02-04T15:01:34.764Z",
                "avgDuration": 168.7
            },
            "steps": [
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87294,
                    "duration": 10.5,
                    "description": "Open the fictional record for Demo Account 64 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01398_560.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 64",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 10.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87297,
                    "duration": 22.1,
                    "description": "Open the fictional record for Demo Account 78 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01405_826.png",
                        "demo_alpha_frame_01406_820.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 97",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 22.1
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87298,
                    "duration": 9.6,
                    "description": "Open the fictional record for Demo Account 85 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01407_607.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 11",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 9.6
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87299,
                    "duration": 9.0,
                    "description": "Open the fictional record for Demo Account 92 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01408_973.png",
                        "demo_alpha_frame_01409_112.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 22",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 9.0
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87300,
                    "duration": 10.4,
                    "description": "Open the fictional record for Demo Account 10 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01410_715.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 33",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 50",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 10.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87301,
                    "duration": 21.2,
                    "description": "Open the fictional record for Demo Account 17 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01411_721.png",
                        "demo_alpha_frame_01412_413.png",
                        "demo_alpha_frame_01413_072.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 44",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 61",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 21.2
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87302,
                    "duration": 18.0,
                    "description": "Open the fictional record for Demo Account 24 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01414_095.png",
                        "demo_alpha_frame_01415_767.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 55",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 72",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 18.0
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87303,
                    "duration": 18.7,
                    "description": "Open the fictional record for Demo Account 31 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01416_356.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 66",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 18.7
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87304,
                    "duration": 14.4,
                    "description": "Open the fictional record for Demo Account 38 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01417_697.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 77",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 94",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 14.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87309,
                    "duration": 8.4,
                    "description": "Open the fictional record for Demo Account 73 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01427_143.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 35",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 8.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87310,
                    "duration": 20.1,
                    "description": "Open the fictional record for Demo Account 80 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01428_414.png",
                        "demo_alpha_frame_01429_869.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 46",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 20.1
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87311,
                    "duration": 6.3,
                    "description": "Open the fictional record for Demo Account 87 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01430_462.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 57",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 6.3
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-cccccccccccc:0",
            "analysisNodeId": 7001,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-cccccccccccc",
                "recordingName": "Pipeline generation",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2026-07-29",
                "traceIndex": 0,
                "traceStart": "2026-07-29T09:00:00Z",
                "traceEnd": "2026-07-29T09:04:45Z",
                "avgDuration": 285.0
            },
            "steps": [
                {
                    "nodeId": "step:qualify-assigned-lead#linkedin",
                    "analysisNodeId": 6001,
                    "duration": 90.0,
                    "description": "Review Lead A in Salesforce and verify role, seniority, and company context on LinkedIn.",
                    "screenshots": [
                        "2026-07-29_09_00_04_000.png",
                        "2026-07-29_09_00_29_000.png",
                        "2026-07-29_09_00_42_000.png",
                        "2026-07-29_09_01_18_000.png"
                    ],
                    "objects": [
                        {
                            "object": "Lead A",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Prospect A",
                            "qualifier": "qualified"
                        },
                        {
                            "object": "Company Alpha",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "LinkedIn": 55.0,
                        "Salesforce": 35.0
                    }
                },
                {
                    "nodeId": "step:create-first-outreach-from-playbook#gmail",
                    "analysisNodeId": 6002,
                    "duration": 145.0,
                    "description": "Use the 'VP Operations — first outreach' template and personalize only the prospect name, company, and one context sentence.",
                    "screenshots": [
                        "2026-07-29_09_01_36_000.png",
                        "2026-07-29_09_01_56_000.png",
                        "2026-07-29_09_02_05_000.png",
                        "2026-07-29_09_02_13_000.png",
                        "2026-07-29_09_02_25_000.png",
                        "2026-07-29_09_02_44_000.png",
                        "2026-07-29_09_03_24_000.png",
                        "2026-07-29_09_03_49_000.png"
                    ],
                    "objects": [
                        {
                            "object": "Personal Outreach Playbook",
                            "qualifier": "opened"
                        },
                        {
                            "object": "VP Operations — first outreach",
                            "qualifier": "selected"
                        },
                        {
                            "object": "VP Operations — first outreach",
                            "qualifier": "copied-to-gmail"
                        },
                        {
                            "object": "Prospect A",
                            "qualifier": "personalized"
                        },
                        {
                            "object": "Company Alpha",
                            "qualifier": "personalized"
                        }
                    ],
                    "appSeconds": {
                        "Google Docs": 47.0,
                        "Gmail": 98.0
                    }
                },
                {
                    "nodeId": "step:review-and-send-first-outreach#gmail",
                    "analysisNodeId": 6003,
                    "duration": 50.0,
                    "description": "Perform a quick final review and send the standardized first-outreach email.",
                    "screenshots": [
                        "2026-07-29_09_04_05_000.png",
                        "2026-07-29_09_04_39_000.png"
                    ],
                    "objects": [
                        {
                            "object": "Prospect A",
                            "qualifier": "emailed"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 50.0
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-cccccccccccc:1",
            "analysisNodeId": 7002,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-cccccccccccc",
                "recordingName": "Pipeline generation",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2026-07-29",
                "traceIndex": 1,
                "traceStart": "2026-07-29T09:05:15Z",
                "traceEnd": "2026-07-29T09:14:30Z",
                "avgDuration": 555.0
            },
            "steps": [
                {
                    "nodeId": "step:research-assigned-lead#linkedin",
                    "analysisNodeId": 6004,
                    "duration": 100.0,
                    "description": "Review Lead B in Salesforce and research Prospect B and Company Beta on LinkedIn.",
                    "screenshots": [
                        "2026-07-29_09_05_20_000.png",
                        "2026-07-29_09_05_39_000.png",
                        "2026-07-29_09_05_54_000.png",
                        "2026-07-29_09_06_31_000.png",
                        "2026-07-29_09_06_49_000.png"
                    ],
                    "objects": [
                        {
                            "object": "Lead B",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Prospect B",
                            "qualifier": "researched"
                        },
                        {
                            "object": "Company Beta",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 30.0,
                        "LinkedIn": 70.0
                    }
                },
                {
                    "nodeId": "step:reuse-previous-prospect-email#gmail",
                    "analysisNodeId": 6005,
                    "duration": 95.0,
                    "description": "Search Gmail for an email sent to a different prospect and copy it into a new draft.",
                    "screenshots": [
                        "2026-07-29_09_07_08_000.png",
                        "2026-07-29_09_07_44_000.png",
                        "2026-07-29_09_08_00_000.png",
                        "2026-07-29_09_08_12_000.png",
                        "2026-07-29_09_08_26_000.png"
                    ],
                    "objects": [
                        {
                            "object": "Prospect C",
                            "qualifier": "previous-email-found"
                        },
                        {
                            "object": "Prospect C outreach email",
                            "qualifier": "copied-to-new-draft"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 95.0
                    }
                },
                {
                    "nodeId": "step:adapt-outreach-for-different-seniority#gmail",
                    "analysisNodeId": 6006,
                    "duration": 175.0,
                    "description": "Recheck the target role and rewrite the value proposition, examples, and call to action for VP-level seniority.",
                    "screenshots": [
                        "2026-07-29_09_08_39_000.png",
                        "2026-07-29_09_09_16_000.png",
                        "2026-07-29_09_09_39_000.png",
                        "2026-07-29_09_10_18_000.png",
                        "2026-07-29_09_10_57_000.png",
                        "2026-07-29_09_11_19_000.png"
                    ],
                    "objects": [
                        {
                            "object": "Prospect B",
                            "qualifier": "seniority-rechecked"
                        },
                        {
                            "object": "Company Beta",
                            "qualifier": "context-rechecked"
                        },
                        {
                            "object": "VP Operations value proposition",
                            "qualifier": "rewritten"
                        },
                        {
                            "object": "Executive-level call to action",
                            "qualifier": "rewritten"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 120.0,
                        "LinkedIn": 55.0
                    }
                },
                {
                    "nodeId": "step:enrich-context-and-rework-draft#gmail",
                    "analysisNodeId": 6007,
                    "duration": 145.0,
                    "description": "Research the company website, rewrite multiple paragraphs, and reopen the old email to recover wording.",
                    "screenshots": [
                        "2026-07-29_09_11_34_000.png",
                        "2026-07-29_09_12_03_000.png",
                        "2026-07-29_09_12_24_000.png",
                        "2026-07-29_09_12_41_000.png",
                        "2026-07-29_09_13_17_000.png",
                        "2026-07-29_09_13_31_000.png",
                        "2026-07-29_09_13_45_000.png"
                    ],
                    "objects": [
                        {
                            "object": "Company Beta website",
                            "qualifier": "researched"
                        },
                        {
                            "object": "EMEA fulfillment center announcement",
                            "qualifier": "selected-as-context"
                        },
                        {
                            "object": "Company Beta outreach draft",
                            "qualifier": "rewritten"
                        },
                        {
                            "object": "Prospect C outreach email",
                            "qualifier": "reopened-for-phrasing"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 80.0,
                        "Google Chrome": 65.0
                    }
                },
                {
                    "nodeId": "step:correct-copied-remnants-and-send#gmail",
                    "analysisNodeId": 6008,
                    "duration": 40.0,
                    "description": "Remove references left from the previous prospect, perform a final review, and send the email.",
                    "screenshots": [
                        "2026-07-29_09_13_58_000.png",
                        "2026-07-29_09_14_18_000.png",
                        "2026-07-29_09_14_27_000.png"
                    ],
                    "objects": [
                        {
                            "object": "Prospect C",
                            "qualifier": "stale-reference-removed"
                        },
                        {
                            "object": "Company Gamma",
                            "qualifier": "stale-reference-removed"
                        },
                        {
                            "object": "Prospect B",
                            "qualifier": "emailed"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 40.0
                    }
                }
            ]
        }
    ]
}

// biome-ignore format: keep the large static demo fixture compact for manual replacement.
export const internalCollaborationAdmin = {
    "slug": "internal-collaboration-admin",
    "name": "Internal Collaboration & Admin",
    "description": "Review the fictional conversation in #demo-ops-71 and post a sample status update using the workspace.",
    "aliases": [],
    "frequency": 14,
    "avgDuration": 329.50714,
    "firstSeen": "2025-02-04T08:48:38.824Z",
    "lastSeen": "2025-02-04T15:45:28.672Z",
    "nodes": [
        {
            "id": "step:attend-internal-meeting-granola#arc",
            "name": "Attend Internal Meeting (Granola)",
            "app": "Arc"
        },
        {
            "id": "step:check-messages-gmail#arc",
            "name": "Check Messages (Gmail)",
            "app": "Arc"
        },
        {
            "id": "step:check-messages-gmail#gmail",
            "name": "Check Messages (Gmail)",
            "app": "Gmail"
        },
        {
            "id": "step:check-messages-gmail#linkedin",
            "name": "Check Messages (Gmail)",
            "app": "LinkedIn"
        },
        {
            "id": "step:check-messages-gmail#salesforce",
            "name": "Check Messages (Gmail)",
            "app": "Salesforce"
        },
        {
            "id": "step:check-messages-slack#arc",
            "name": "Check Messages (Slack)",
            "app": "Arc"
        },
        {
            "id": "step:check-messages-slack#slack",
            "name": "Check Messages (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:create-training-video-arc#arc",
            "name": "Create Training Video (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:manage-calendar-and-availability-arc#arc",
            "name": "Manage Calendar and Availability (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:message-teammate#slack",
            "name": "Message Teammate",
            "app": "Slack"
        },
        {
            "id": "step:message-teammate-slack#slack",
            "name": "Message Teammate (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:navigate-workspace#gmail",
            "name": "Navigate workspace",
            "app": "Gmail"
        },
        {
            "id": "step:navigate-workspace#salesforce",
            "name": "Navigate workspace",
            "app": "Salesforce"
        },
        {
            "id": "step:navigate-workspace#slack",
            "name": "Navigate workspace",
            "app": "Slack"
        },
        {
            "id": "step:research-target-account-claude#claude",
            "name": "Research Target Account (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:research-target-account-gmail#gmail",
            "name": "Research Target Account (Gmail)",
            "app": "Gmail"
        },
        {
            "id": "step:research-target-account-slack#slack",
            "name": "Research Target Account (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:review-pipeline-lead-queue-arc#arc",
            "name": "Review Pipeline / Lead Queue (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:review-pipeline-lead-queue-salesforce#salesforce",
            "name": "Review Pipeline / Lead Queue (Salesforce)",
            "app": "Salesforce"
        },
        {
            "id": "step:review-pipeline-lead-queue-salesforce#slack",
            "name": "Review Pipeline / Lead Queue (Salesforce)",
            "app": "Slack"
        },
        {
            "id": "step:review-sequence-campaign-performance-arc#arc",
            "name": "Review Sequence/Campaign Performance (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:schedule-meeting-arc#arc",
            "name": "Schedule Meeting (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:share-content-slack#granola",
            "name": "Share Content (Slack)",
            "app": "Granola"
        }
    ],
    "sources": [
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 2,
            "traceStart": "2025-02-04T08:48:38.824Z",
            "traceEnd": "2025-02-04T13:33:46.715Z",
            "avgDuration": 1187.9
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 4,
            "traceStart": "2025-02-04T08:55:38.019Z",
            "traceEnd": "2025-02-04T15:28:53.999Z",
            "avgDuration": 119.1
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 8,
            "traceStart": "2025-02-04T10:00:47.122Z",
            "traceEnd": "2025-02-04T15:07:07.951Z",
            "avgDuration": 563.1
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 9,
            "traceStart": "2025-02-04T10:02:05.348Z",
            "traceEnd": "2025-02-04T10:54:33.365Z",
            "avgDuration": 237.5
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 10,
            "traceStart": "2025-02-04T10:02:05.348Z",
            "traceEnd": "2025-02-04T15:30:03.408Z",
            "avgDuration": 206.2
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 11,
            "traceStart": "2025-02-04T10:02:57.821Z",
            "traceEnd": "2025-02-04T12:12:36.583Z",
            "avgDuration": 332.7
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 13,
            "traceStart": "2025-02-04T10:13:04.792Z",
            "traceEnd": "2025-02-04T15:31:33.924Z",
            "avgDuration": 499.5
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 14,
            "traceStart": "2025-02-04T10:52:25.004Z",
            "traceEnd": "2025-02-04T12:07:28.858Z",
            "avgDuration": 223.8
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 24,
            "traceStart": "2025-02-04T11:32:16.829Z",
            "traceEnd": "2025-02-04T15:07:34.764Z",
            "avgDuration": 339.3
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 26,
            "traceStart": "2025-02-04T12:30:03.956Z",
            "traceEnd": "2025-02-04T15:26:02.092Z",
            "avgDuration": 96.2
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 33,
            "traceStart": "2025-02-04T13:33:31.327Z",
            "traceEnd": "2025-02-04T14:38:48.697Z",
            "avgDuration": 137.6
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 34,
            "traceStart": "2025-02-04T13:33:31.327Z",
            "traceEnd": "2025-02-04T14:18:31.171Z",
            "avgDuration": 130.1
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 35,
            "traceStart": "2025-02-04T13:37:36.566Z",
            "traceEnd": "2025-02-04T13:49:52.077Z",
            "avgDuration": 360.7
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 39,
            "traceStart": "2025-02-04T15:31:34.291Z",
            "traceEnd": "2025-02-04T15:45:28.672Z",
            "avgDuration": 179.4
        }
    ],
    "instances": [
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:2",
            "analysisNodeId": 91003,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 2,
                "traceStart": "2025-02-04T08:48:38.824Z",
                "traceEnd": "2025-02-04T13:33:46.715Z",
                "avgDuration": 1187.9
            },
            "steps": [
                {
                    "nodeId": "step:message-teammate#slack",
                    "analysisNodeId": 87003,
                    "duration": 15.2,
                    "description": "Review the fictional conversation in #demo-ops-73 and post a sample status update using the workspace.",
                    "screenshots": [
                        "demo_alpha_frame_00008_996.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 62",
                            "qualifier": "messaged"
                        },
                        {
                            "object": "Demo Item 79",
                            "qualifier": "navigated-to"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 14.1
                    }
                },
                {
                    "nodeId": "step:review-pipeline-lead-queue-salesforce#slack",
                    "analysisNodeId": 87004,
                    "duration": 312.0,
                    "description": "Review the sample outreach workflow for Demo Account 80 and update its demo status in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_00009_478.png",
                        "demo_alpha_frame_00010_430.png",
                        "demo_alpha_frame_00011_433.png",
                        "demo_alpha_frame_00012_345.png",
                        "demo_alpha_frame_00013_504.png",
                        "demo_alpha_frame_00014_454.png",
                        "demo_alpha_frame_00015_424.png",
                        "demo_alpha_frame_00016_239.png",
                        "demo_alpha_frame_00017_560.png",
                        "demo_alpha_frame_00018_275.png",
                        "demo_alpha_frame_00019_754.png",
                        "demo_alpha_frame_00020_461.png",
                        "demo_alpha_frame_00021_197.png",
                        "demo_alpha_frame_00022_975.png",
                        "demo_alpha_frame_00023_258.png",
                        "demo_alpha_frame_00024_030.png",
                        "demo_alpha_frame_00025_783.png",
                        "demo_alpha_frame_00026_412.png",
                        "demo_alpha_frame_00027_564.png",
                        "demo_alpha_frame_00028_634.png",
                        "demo_alpha_frame_00029_836.png",
                        "demo_alpha_frame_00030_696.png",
                        "demo_alpha_frame_00031_022.png",
                        "demo_alpha_frame_00032_798.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 73",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 309.0
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87016,
                    "duration": 53.4,
                    "description": "Review the fictional conversation in #demo-ops-54 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00081_941.png",
                        "demo_alpha_frame_00082_122.png",
                        "demo_alpha_frame_00083_700.png",
                        "demo_alpha_frame_00084_794.png",
                        "demo_alpha_frame_00085_772.png",
                        "demo_alpha_frame_00086_076.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 22",
                            "qualifier": "messaged"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 48.4
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87029,
                    "duration": 337.5,
                    "description": "Review the fictional conversation in #demo-ops-49 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00174_405.png",
                        "demo_alpha_frame_00175_546.png",
                        "demo_alpha_frame_00176_684.png",
                        "demo_alpha_frame_00177_331.png",
                        "demo_alpha_frame_00178_741.png",
                        "demo_alpha_frame_00179_262.png",
                        "demo_alpha_frame_00180_506.png",
                        "demo_alpha_frame_00181_479.png",
                        "demo_alpha_frame_00182_019.png",
                        "demo_alpha_frame_00183_857.png",
                        "demo_alpha_frame_00184_654.png",
                        "demo_alpha_frame_00185_217.png",
                        "demo_alpha_frame_00186_469.png",
                        "demo_alpha_frame_00187_634.png",
                        "demo_alpha_frame_00188_483.png",
                        "demo_alpha_frame_00189_353.png",
                        "demo_alpha_frame_00190_667.png",
                        "demo_alpha_frame_00191_795.png",
                        "demo_alpha_frame_00192_613.png",
                        "demo_alpha_frame_00193_132.png",
                        "demo_alpha_frame_00194_146.png",
                        "demo_alpha_frame_00195_685.png",
                        "demo_alpha_frame_00196_908.png",
                        "demo_alpha_frame_00197_845.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 59",
                            "qualifier": "messaged"
                        },
                        {
                            "object": "Demo Item 76",
                            "qualifier": "discussed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 331.1
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87037,
                    "duration": 25.9,
                    "description": "Review the fictional conversation in #demo-ops-98 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00244_329.png",
                        "demo_alpha_frame_00245_314.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 50",
                            "qualifier": "messaged"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 7.5,
                        "Slack": 18.4
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87039,
                    "duration": 9.4,
                    "description": "Review the fictional conversation in #demo-ops-16 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00252_006.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 8.0
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87045,
                    "duration": 42.0,
                    "description": "Research Demo Account 37 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00280_172.png",
                        "demo_alpha_frame_00281_040.png",
                        "demo_alpha_frame_00282_623.png",
                        "demo_alpha_frame_00283_540.png",
                        "demo_alpha_frame_00284_131.png",
                        "demo_alpha_frame_00285_077.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 41",
                            "qualifier": "researched"
                        },
                        {
                            "object": "Sample Reference 58",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 42.0
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87046,
                    "duration": 156.0,
                    "description": "Review the fictional conversation in #demo-ops-44 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00286_561.png",
                        "demo_alpha_frame_00287_588.png",
                        "demo_alpha_frame_00288_939.png",
                        "demo_alpha_frame_00289_331.png",
                        "demo_alpha_frame_00290_742.png",
                        "demo_alpha_frame_00291_397.png",
                        "demo_alpha_frame_00292_375.png",
                        "demo_alpha_frame_00293_737.png",
                        "demo_alpha_frame_00294_262.png",
                        "demo_alpha_frame_00295_085.png",
                        "demo_alpha_frame_00296_475.png",
                        "demo_alpha_frame_00297_721.png",
                        "demo_alpha_frame_00298_546.png",
                        "demo_alpha_frame_00299_262.png",
                        "demo_alpha_frame_00300_018.png",
                        "demo_alpha_frame_00301_632.png",
                        "demo_alpha_frame_00302_527.png",
                        "demo_alpha_frame_00303_300.png",
                        "demo_alpha_frame_00304_824.png",
                        "demo_alpha_frame_00305_420.png",
                        "demo_alpha_frame_00306_356.png",
                        "demo_alpha_frame_00307_173.png",
                        "demo_alpha_frame_00308_667.png",
                        "demo_alpha_frame_00309_404.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 52",
                            "qualifier": "reviewed-message"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 155.9
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87047,
                    "duration": 18.4,
                    "description": "Review the fictional conversation in #demo-ops-51 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00310_263.png",
                        "demo_alpha_frame_00311_625.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 63",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Item 80",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Contact 97",
                            "qualifier": "mentioned"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 18.4
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87067,
                    "duration": 75.5,
                    "description": "Review the fictional conversation in #demo-ops-88 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00384_705.png",
                        "demo_alpha_frame_00385_195.png",
                        "demo_alpha_frame_00386_342.png",
                        "demo_alpha_frame_00387_804.png",
                        "demo_alpha_frame_00388_858.png",
                        "demo_alpha_frame_00389_650.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 89",
                            "qualifier": "messaged"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 72.5
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87070,
                    "duration": 72.9,
                    "description": "Review the fictional conversation in #demo-ops-95 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00430_094.png",
                        "demo_alpha_frame_00431_680.png",
                        "demo_alpha_frame_00432_922.png",
                        "demo_alpha_frame_00433_593.png",
                        "demo_alpha_frame_00434_601.png",
                        "demo_alpha_frame_00435_297.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 25",
                            "qualifier": "messaged"
                        },
                        {
                            "object": "Demo Contact 42",
                            "qualifier": "mentioned"
                        }
                    ],
                    "appSeconds": {
                        "lemlist": 18.7,
                        "Slack": 46.7
                    }
                },
                {
                    "nodeId": "step:share-content-slack#granola",
                    "analysisNodeId": 87185,
                    "duration": 54.3,
                    "description": "Review and update Sample Enablement Guide 29 with fictional onboarding details in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00913_004.png",
                        "demo_alpha_frame_00914_775.png",
                        "demo_alpha_frame_00915_874.png",
                        "demo_alpha_frame_00916_281.png",
                        "demo_alpha_frame_00917_673.png",
                        "demo_alpha_frame_00918_568.png",
                        "demo_alpha_frame_00919_841.png",
                        "demo_alpha_frame_00920_255.png",
                        "demo_alpha_frame_00921_691.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 29",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Sample Reference 46",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Granola": 41.7,
                        "Slack": 12.6
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87222,
                    "duration": 15.4,
                    "description": "Review the fictional conversation in #demo-ops-75 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01094_473.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 48",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 65",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 82",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 02",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 15.4
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:4",
            "analysisNodeId": 91005,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 4,
                "traceStart": "2025-02-04T08:55:38.019Z",
                "traceEnd": "2025-02-04T15:28:53.999Z",
                "avgDuration": 119.1
            },
            "steps": [
                {
                    "nodeId": "step:review-pipeline-lead-queue-arc#arc",
                    "analysisNodeId": 87007,
                    "duration": 28.3,
                    "description": "Review the sample outreach workflow for Demo Account 12 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00040_014.png",
                        "demo_alpha_frame_00041_186.png",
                        "demo_alpha_frame_00042_589.png",
                        "demo_alpha_frame_00043_200.png",
                        "demo_alpha_frame_00044_144.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 20",
                            "qualifier": "reviewed-invite"
                        },
                        {
                            "object": "Sample Calendar Item 37",
                            "qualifier": "reviewed-invite"
                        },
                        {
                            "object": "Sample Calendar Item 54",
                            "qualifier": "reviewed-invite"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 22.3
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87219,
                    "duration": 11.9,
                    "description": "Review a sample calendar entry for Demo Account 54 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01089_588.png",
                        "demo_alpha_frame_01090_328.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 15",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 11.9
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87220,
                    "duration": 5.7,
                    "description": "Review a sample calendar entry for Demo Account 61 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01091_139.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 26",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 5.7
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#gmail",
                    "analysisNodeId": 87232,
                    "duration": 12.5,
                    "description": "Review the fictional conversation in #demo-ops-49 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01113_130.png",
                        "demo_alpha_frame_01114_794.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 61",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 8.5
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87233,
                    "duration": 8.2,
                    "description": "Review a sample calendar entry for Demo Account 56 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01115_020.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 72",
                            "qualifier": "edited"
                        },
                        {
                            "object": "Sample Reference 89",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 8.2
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87234,
                    "duration": 8.8,
                    "description": "Review a sample calendar entry for Demo Account 63 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01116_912.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 5.1
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87235,
                    "duration": 9.5,
                    "description": "Review a sample calendar entry for Demo Account 70 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01117_791.png",
                        "demo_alpha_frame_01118_243.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 9.5
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87333,
                    "duration": 34.2,
                    "description": "Review a sample calendar entry for Demo Account 42 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01533_755.png",
                        "demo_alpha_frame_01534_192.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 08",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 25",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 42",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 31.8
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:8",
            "analysisNodeId": 91009,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 8,
                "traceStart": "2025-02-04T10:00:47.122Z",
                "traceEnd": "2025-02-04T15:07:07.951Z",
                "avgDuration": 563.1
            },
            "steps": [
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87047,
                    "duration": 18.4,
                    "description": "Review the fictional conversation in #demo-ops-51 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00310_263.png",
                        "demo_alpha_frame_00311_625.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 63",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Item 80",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Contact 97",
                            "qualifier": "mentioned"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 18.4
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87055,
                    "duration": 14.6,
                    "description": "Move through the workspace to continue Sample Workflow 93.",
                    "screenshots": [
                        "demo_alpha_frame_00326_878.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 54",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 14.6
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87174,
                    "duration": 32.4,
                    "description": "Review the fictional conversation in #demo-ops-41 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00872_636.png",
                        "demo_alpha_frame_00873_260.png",
                        "demo_alpha_frame_00874_234.png",
                        "demo_alpha_frame_00875_433.png"
                    ],
                    "objects": [
                        {
                            "object": "#demo-ops-05",
                            "qualifier": "posted-to"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 32.4
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87175,
                    "duration": 22.9,
                    "description": "Review the fictional conversation in #demo-ops-48 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00876_676.png",
                        "demo_alpha_frame_00877_629.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 22.9
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87176,
                    "duration": 189.9,
                    "description": "Review the fictional conversation in #demo-ops-55 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00878_355.png",
                        "demo_alpha_frame_00879_820.png",
                        "demo_alpha_frame_00880_230.png",
                        "demo_alpha_frame_00881_708.png",
                        "demo_alpha_frame_00882_450.png",
                        "demo_alpha_frame_00883_736.png",
                        "demo_alpha_frame_00884_919.png",
                        "demo_alpha_frame_00885_432.png",
                        "demo_alpha_frame_00886_650.png",
                        "demo_alpha_frame_00887_108.png",
                        "demo_alpha_frame_00888_148.png",
                        "demo_alpha_frame_00889_162.png",
                        "demo_alpha_frame_00890_420.png",
                        "demo_alpha_frame_00891_841.png",
                        "demo_alpha_frame_00892_320.png"
                    ],
                    "objects": [
                        {
                            "object": "#demo-ops-27",
                            "qualifier": "posted-to"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 189.9
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87177,
                    "duration": 27.6,
                    "description": "Review the fictional conversation in #demo-ops-62 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00893_266.png",
                        "demo_alpha_frame_00894_082.png",
                        "demo_alpha_frame_00895_140.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 38",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 27.6
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87223,
                    "duration": 74.7,
                    "description": "Move through the workspace to continue Sample Workflow 82.",
                    "screenshots": [
                        "demo_alpha_frame_01095_733.png",
                        "demo_alpha_frame_01096_893.png",
                        "demo_alpha_frame_01097_739.png",
                        "demo_alpha_frame_01098_753.png",
                        "demo_alpha_frame_01099_614.png",
                        "demo_alpha_frame_01100_558.png",
                        "demo_alpha_frame_01101_172.png",
                        "demo_alpha_frame_01102_196.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 74.7
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87248,
                    "duration": 114.7,
                    "description": "Review the fictional conversation in #demo-ops-65 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01247_262.png",
                        "demo_alpha_frame_01248_216.png",
                        "demo_alpha_frame_01249_603.png",
                        "demo_alpha_frame_01250_017.png",
                        "demo_alpha_frame_01251_992.png",
                        "demo_alpha_frame_01252_239.png",
                        "demo_alpha_frame_01253_738.png",
                        "demo_alpha_frame_01254_758.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 43",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Contact 60",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 77",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 94",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 114.7
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87249,
                    "duration": 50.5,
                    "description": "Review the fictional conversation in #demo-ops-72 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01255_005.png",
                        "demo_alpha_frame_01256_473.png",
                        "demo_alpha_frame_01257_740.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 54",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Sample Reference 71",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 50.5
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-arc#arc",
                    "analysisNodeId": 87316,
                    "duration": 17.4,
                    "description": "Review a sample calendar entry for Demo Account 33 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01469_197.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 15",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 5.5,
                        "Arc": 9.3
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:9",
            "analysisNodeId": 91010,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 9,
                "traceStart": "2025-02-04T10:02:05.348Z",
                "traceEnd": "2025-02-04T10:54:33.365Z",
                "avgDuration": 237.5
            },
            "steps": [
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87052,
                    "duration": 34.6,
                    "description": "Review a sample calendar entry for Demo Account 72 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00316_585.png",
                        "demo_alpha_frame_00317_492.png",
                        "demo_alpha_frame_00318_251.png",
                        "demo_alpha_frame_00319_940.png",
                        "demo_alpha_frame_00320_635.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 21",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Item 38",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Item 55",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 34.6
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87064,
                    "duration": 135.4,
                    "description": "Review a sample calendar entry for Demo Account 67 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00372_339.png",
                        "demo_alpha_frame_00373_917.png",
                        "demo_alpha_frame_00374_228.png",
                        "demo_alpha_frame_00375_059.png",
                        "demo_alpha_frame_00376_453.png",
                        "demo_alpha_frame_00377_053.png",
                        "demo_alpha_frame_00378_205.png",
                        "demo_alpha_frame_00379_537.png",
                        "demo_alpha_frame_00380_842.png"
                    ],
                    "objects": [
                        {
                            "object": "#demo-ops-56",
                            "qualifier": "joined"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 107.2,
                        "Gmail": 28.2
                    }
                },
                {
                    "nodeId": "step:attend-internal-meeting-granola#arc",
                    "analysisNodeId": 87065,
                    "duration": 14.7,
                    "description": "Review a sample calendar entry for Demo Account 74 and update its demo availability in Granola.",
                    "screenshots": [
                        "demo_alpha_frame_00381_179.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 12.6
                    }
                },
                {
                    "nodeId": "step:attend-internal-meeting-granola#arc",
                    "analysisNodeId": 87071,
                    "duration": 52.8,
                    "description": "Review a sample calendar entry for Demo Account 13 and update its demo availability in Granola.",
                    "screenshots": [
                        "demo_alpha_frame_00436_505.png",
                        "demo_alpha_frame_00437_410.png",
                        "demo_alpha_frame_00438_458.png",
                        "demo_alpha_frame_00439_200.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Session 36",
                            "qualifier": "attended"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 30.0,
                        "Granola": 22.8
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:10",
            "analysisNodeId": 91011,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 10,
                "traceStart": "2025-02-04T10:02:05.348Z",
                "traceEnd": "2025-02-04T15:30:03.408Z",
                "avgDuration": 206.2
            },
            "steps": [
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87052,
                    "duration": 34.6,
                    "description": "Review a sample calendar entry for Demo Account 72 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00316_585.png",
                        "demo_alpha_frame_00317_492.png",
                        "demo_alpha_frame_00318_251.png",
                        "demo_alpha_frame_00319_940.png",
                        "demo_alpha_frame_00320_635.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 21",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Item 38",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Item 55",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 34.6
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87073,
                    "duration": 155.6,
                    "description": "Review Sample Session 27 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00442_592.png",
                        "demo_alpha_frame_00443_904.png",
                        "demo_alpha_frame_00444_363.png",
                        "demo_alpha_frame_00445_733.png",
                        "demo_alpha_frame_00446_526.png",
                        "demo_alpha_frame_00447_338.png",
                        "demo_alpha_frame_00448_241.png",
                        "demo_alpha_frame_00449_057.png",
                        "demo_alpha_frame_00450_520.png",
                        "demo_alpha_frame_00451_883.png",
                        "demo_alpha_frame_00452_806.png",
                        "demo_alpha_frame_00453_207.png",
                        "demo_alpha_frame_00454_861.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 58",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 65.2,
                        "Shortcut": 64.7
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87336,
                    "duration": 16.0,
                    "description": "Review a sample calendar entry for Demo Account 49 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01539_713.png",
                        "demo_alpha_frame_01540_672.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 41",
                            "qualifier": "reviewed"
                        },
                        {
                            "object": "Demo Item 58",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 16.0
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:11",
            "analysisNodeId": 91012,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 11,
                "traceStart": "2025-02-04T10:02:57.821Z",
                "traceEnd": "2025-02-04T12:12:36.583Z",
                "avgDuration": 332.7
            },
            "steps": [
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87054,
                    "duration": 13.9,
                    "description": "Review the fictional conversation in #demo-ops-86 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00323_544.png",
                        "demo_alpha_frame_00324_572.png",
                        "demo_alpha_frame_00325_798.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 43",
                            "qualifier": "messaged"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 13.9
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87055,
                    "duration": 14.6,
                    "description": "Move through the workspace to continue Sample Workflow 93.",
                    "screenshots": [
                        "demo_alpha_frame_00326_878.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 54",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 14.6
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87150,
                    "duration": 304.2,
                    "description": "Review the fictional conversation in #demo-ops-65 and post a sample status update using Slack.",
                    "screenshots": [],
                    "objects": [
                        {
                            "object": "Demo Contact 32",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 304.2
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:13",
            "analysisNodeId": 91014,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 13,
                "traceStart": "2025-02-04T10:13:04.792Z",
                "traceEnd": "2025-02-04T15:31:33.924Z",
                "avgDuration": 499.5
            },
            "steps": [
                {
                    "nodeId": "step:navigate-workspace#gmail",
                    "analysisNodeId": 87060,
                    "duration": 11.5,
                    "description": "Move through the workspace to continue Sample Workflow 39.",
                    "screenshots": [
                        "demo_alpha_frame_00361_686.png",
                        "demo_alpha_frame_00362_622.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Gmail": 11.5
                    }
                },
                {
                    "nodeId": "step:check-messages-slack#slack",
                    "analysisNodeId": 87072,
                    "duration": 20.6,
                    "description": "Review the fictional conversation in #demo-ops-20 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00440_028.png",
                        "demo_alpha_frame_00441_945.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 47",
                            "qualifier": "archived"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 11.5
                    }
                },
                {
                    "nodeId": "step:check-messages-slack#arc",
                    "analysisNodeId": 87167,
                    "duration": 122.5,
                    "description": "Review the fictional conversation in #demo-ops-88 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00844_067.png",
                        "demo_alpha_frame_00845_576.png",
                        "demo_alpha_frame_00846_850.png",
                        "demo_alpha_frame_00847_436.png",
                        "demo_alpha_frame_00848_759.png",
                        "demo_alpha_frame_00849_914.png",
                        "demo_alpha_frame_00850_380.png",
                        "demo_alpha_frame_00851_765.png",
                        "demo_alpha_frame_00852_591.png",
                        "demo_alpha_frame_00853_258.png",
                        "demo_alpha_frame_00854_174.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 108.2
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#gmail",
                    "analysisNodeId": 87183,
                    "duration": 4.9,
                    "description": "Review the fictional conversation in #demo-ops-15 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_00908_819.png",
                        "demo_alpha_frame_00909_777.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 07",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 4.9
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#arc",
                    "analysisNodeId": 87188,
                    "duration": 28.1,
                    "description": "Review the fictional conversation in #demo-ops-43 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_00924_923.png",
                        "demo_alpha_frame_00925_976.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 62",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 79",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 9.9,
                        "Arc": 16.2
                    }
                },
                {
                    "nodeId": "step:research-target-account-gmail#gmail",
                    "analysisNodeId": 87207,
                    "duration": 51.0,
                    "description": "Research Demo Account 59 and summarize its fictional business profile in Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01031_169.png",
                        "demo_alpha_frame_01032_951.png",
                        "demo_alpha_frame_01033_042.png",
                        "demo_alpha_frame_01034_512.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 77",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 43.3
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#gmail",
                    "analysisNodeId": 87232,
                    "duration": 12.5,
                    "description": "Review the fictional conversation in #demo-ops-49 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01113_130.png",
                        "demo_alpha_frame_01114_794.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 61",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 8.5
                    }
                },
                {
                    "nodeId": "step:check-messages-slack#slack",
                    "analysisNodeId": 87239,
                    "duration": 11.3,
                    "description": "Review the fictional conversation in #demo-ops-91 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01127_943.png",
                        "demo_alpha_frame_01128_388.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 11.3
                    }
                },
                {
                    "nodeId": "step:research-target-account-gmail#gmail",
                    "analysisNodeId": 87246,
                    "duration": 10.9,
                    "description": "Research Demo Account 51 and summarize its fictional business profile in Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01243_184.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 21",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 8.2
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#salesforce",
                    "analysisNodeId": 87268,
                    "duration": 9.1,
                    "description": "Review the fictional conversation in #demo-ops-81 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01330_608.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Salesforce": 4.0,
                        "Arc": 2.8
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#arc",
                    "analysisNodeId": 87270,
                    "duration": 21.8,
                    "description": "Review the fictional conversation in #demo-ops-95 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01333_458.png",
                        "demo_alpha_frame_01334_301.png",
                        "demo_alpha_frame_01335_701.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 11.6,
                        "LinkedIn": 10.3
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#arc",
                    "analysisNodeId": 87280,
                    "duration": 94.7,
                    "description": "Review the fictional conversation in #demo-ops-69 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01369_802.png",
                        "demo_alpha_frame_01370_165.png",
                        "demo_alpha_frame_01371_912.png",
                        "demo_alpha_frame_01372_268.png",
                        "demo_alpha_frame_01373_305.png",
                        "demo_alpha_frame_01374_594.png",
                        "demo_alpha_frame_01375_747.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 85.6
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#linkedin",
                    "analysisNodeId": 87293,
                    "duration": 7.2,
                    "description": "Review the fictional conversation in #demo-ops-57 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01397_106.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "LinkedIn": 5.8,
                        "lemlist": 1.4
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#gmail",
                    "analysisNodeId": 87328,
                    "duration": 63.2,
                    "description": "Review the fictional conversation in #demo-ops-21 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01512_404.png",
                        "demo_alpha_frame_01513_878.png",
                        "demo_alpha_frame_01514_378.png",
                        "demo_alpha_frame_01515_809.png",
                        "demo_alpha_frame_01516_304.png",
                        "demo_alpha_frame_01517_515.png",
                        "demo_alpha_frame_01518_305.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 50",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 67",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 63.2
                    }
                },
                {
                    "nodeId": "step:check-messages-slack#slack",
                    "analysisNodeId": 87339,
                    "duration": 30.2,
                    "description": "Review the fictional conversation in #demo-ops-63 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01545_951.png",
                        "demo_alpha_frame_01546_804.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 74",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 30.2
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:14",
            "analysisNodeId": 91015,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 14,
                "traceStart": "2025-02-04T10:52:25.004Z",
                "traceEnd": "2025-02-04T12:07:28.858Z",
                "avgDuration": 223.8
            },
            "steps": [
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87070,
                    "duration": 72.9,
                    "description": "Review the fictional conversation in #demo-ops-95 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00430_094.png",
                        "demo_alpha_frame_00431_680.png",
                        "demo_alpha_frame_00432_922.png",
                        "demo_alpha_frame_00433_593.png",
                        "demo_alpha_frame_00434_601.png",
                        "demo_alpha_frame_00435_297.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 25",
                            "qualifier": "messaged"
                        },
                        {
                            "object": "Demo Contact 42",
                            "qualifier": "mentioned"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 46.7,
                        "lemlist": 18.7
                    }
                },
                {
                    "nodeId": "step:review-sequence-campaign-performance-arc#arc",
                    "analysisNodeId": 87082,
                    "duration": 143.0,
                    "description": "Review the sample outreach workflow for Demo Account 76 and update its demo status in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00503_802.png",
                        "demo_alpha_frame_00504_114.png",
                        "demo_alpha_frame_00505_758.png",
                        "demo_alpha_frame_00506_309.png",
                        "demo_alpha_frame_00507_871.png",
                        "demo_alpha_frame_00508_852.png",
                        "demo_alpha_frame_00509_439.png",
                        "demo_alpha_frame_00510_031.png",
                        "demo_alpha_frame_00511_581.png",
                        "demo_alpha_frame_00512_071.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 60",
                            "qualifier": "filtered"
                        },
                        {
                            "object": "Sample Calendar Item 77",
                            "qualifier": "filtered"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 143.0
                    }
                },
                {
                    "nodeId": "step:research-target-account-slack#slack",
                    "analysisNodeId": 87149,
                    "duration": 7.9,
                    "description": "Research Demo Account 58 and summarize its fictional business profile in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00807_097.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 21",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 1.9,
                        "Slack": 5.9
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:24",
            "analysisNodeId": 91025,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 24,
                "traceStart": "2025-02-04T11:32:16.829Z",
                "traceEnd": "2025-02-04T15:07:34.764Z",
                "avgDuration": 339.3
            },
            "steps": [
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87117,
                    "duration": 11.0,
                    "description": "Review a sample calendar entry for Demo Account 33 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00670_144.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 11.0
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87118,
                    "duration": 15.8,
                    "description": "Review a sample calendar entry for Demo Account 40 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00671_267.png",
                        "demo_alpha_frame_00672_889.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 15.8
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87184,
                    "duration": 26.7,
                    "description": "Review a sample calendar entry for Demo Account 22 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00910_661.png",
                        "demo_alpha_frame_00911_059.png",
                        "demo_alpha_frame_00912_635.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 26.7
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87211,
                    "duration": 89.8,
                    "description": "Review a sample calendar entry for Demo Account 87 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01056_214.png",
                        "demo_alpha_frame_01057_267.png",
                        "demo_alpha_frame_01058_272.png",
                        "demo_alpha_frame_01059_517.png",
                        "demo_alpha_frame_01060_138.png",
                        "demo_alpha_frame_01061_040.png",
                        "demo_alpha_frame_01062_870.png",
                        "demo_alpha_frame_01063_231.png",
                        "demo_alpha_frame_01064_687.png",
                        "demo_alpha_frame_01065_109.png",
                        "demo_alpha_frame_01066_419.png",
                        "demo_alpha_frame_01067_594.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 89.8
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87212,
                    "duration": 24.8,
                    "description": "Review a sample calendar entry for Demo Account 94 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01068_126.png",
                        "demo_alpha_frame_01069_112.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 35",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 19.7
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-arc#arc",
                    "analysisNodeId": 87313,
                    "duration": 22.9,
                    "description": "Review a sample calendar entry for Demo Account 12 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01441_614.png",
                        "demo_alpha_frame_01442_814.png",
                        "demo_alpha_frame_01443_371.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 79",
                            "qualifier": "created"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 19.6
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-arc#arc",
                    "analysisNodeId": 87314,
                    "duration": 127.0,
                    "description": "Review a sample calendar entry for Demo Account 19 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01444_763.png",
                        "demo_alpha_frame_01445_391.png",
                        "demo_alpha_frame_01446_900.png",
                        "demo_alpha_frame_01447_599.png",
                        "demo_alpha_frame_01448_942.png",
                        "demo_alpha_frame_01449_508.png",
                        "demo_alpha_frame_01450_775.png",
                        "demo_alpha_frame_01451_847.png",
                        "demo_alpha_frame_01452_199.png",
                        "demo_alpha_frame_01453_264.png",
                        "demo_alpha_frame_01454_069.png",
                        "demo_alpha_frame_01455_868.png",
                        "demo_alpha_frame_01456_042.png",
                        "demo_alpha_frame_01457_749.png",
                        "demo_alpha_frame_01458_081.png",
                        "demo_alpha_frame_01459_861.png",
                        "demo_alpha_frame_01460_966.png",
                        "demo_alpha_frame_01461_331.png",
                        "demo_alpha_frame_01462_117.png",
                        "demo_alpha_frame_01463_045.png",
                        "demo_alpha_frame_01464_102.png",
                        "demo_alpha_frame_01465_816.png",
                        "demo_alpha_frame_01466_074.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 90",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 123.8
                    }
                },
                {
                    "nodeId": "step:schedule-meeting-arc#arc",
                    "analysisNodeId": 87317,
                    "duration": 21.3,
                    "description": "Review a sample calendar entry for Demo Account 40 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01470_278.png",
                        "demo_alpha_frame_01471_600.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 26",
                            "qualifier": "finalized"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 21.3
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:26",
            "analysisNodeId": 91027,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 26,
                "traceStart": "2025-02-04T12:30:03.956Z",
                "traceEnd": "2025-02-04T15:26:02.092Z",
                "avgDuration": 96.2
            },
            "steps": [
                {
                    "nodeId": "step:check-messages-gmail#gmail",
                    "analysisNodeId": 87183,
                    "duration": 4.9,
                    "description": "Review the fictional conversation in #demo-ops-15 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_00908_819.png",
                        "demo_alpha_frame_00909_777.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 07",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 4.9
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#arc",
                    "analysisNodeId": 87188,
                    "duration": 28.1,
                    "description": "Review the fictional conversation in #demo-ops-43 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_00924_923.png",
                        "demo_alpha_frame_00925_976.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 62",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 79",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 16.2,
                        "Gmail": 9.9
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#gmail",
                    "analysisNodeId": 87328,
                    "duration": 63.2,
                    "description": "Review the fictional conversation in #demo-ops-21 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01512_404.png",
                        "demo_alpha_frame_01513_878.png",
                        "demo_alpha_frame_01514_378.png",
                        "demo_alpha_frame_01515_809.png",
                        "demo_alpha_frame_01516_304.png",
                        "demo_alpha_frame_01517_515.png",
                        "demo_alpha_frame_01518_305.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 50",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 67",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Gmail": 63.2
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:33",
            "analysisNodeId": 91034,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 33,
                "traceStart": "2025-02-04T13:33:31.327Z",
                "traceEnd": "2025-02-04T14:38:48.697Z",
                "avgDuration": 137.6
            },
            "steps": [
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87222,
                    "duration": 15.4,
                    "description": "Review the fictional conversation in #demo-ops-75 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01094_473.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 48",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 65",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 82",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 02",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 15.4
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87248,
                    "duration": 114.7,
                    "description": "Review the fictional conversation in #demo-ops-65 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01247_262.png",
                        "demo_alpha_frame_01248_216.png",
                        "demo_alpha_frame_01249_603.png",
                        "demo_alpha_frame_01250_017.png",
                        "demo_alpha_frame_01251_992.png",
                        "demo_alpha_frame_01252_239.png",
                        "demo_alpha_frame_01253_738.png",
                        "demo_alpha_frame_01254_758.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 43",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Contact 60",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 77",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 94",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 114.7
                    }
                },
                {
                    "nodeId": "step:research-target-account-slack#slack",
                    "analysisNodeId": 87262,
                    "duration": 7.5,
                    "description": "Research Demo Account 39 and summarize its fictional business profile in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01295_372.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 03",
                            "qualifier": "searched"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 7.5
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:34",
            "analysisNodeId": 91035,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 34,
                "traceStart": "2025-02-04T13:33:31.327Z",
                "traceEnd": "2025-02-04T14:18:31.171Z",
                "avgDuration": 130.1
            },
            "steps": [
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87222,
                    "duration": 15.4,
                    "description": "Review the fictional conversation in #demo-ops-75 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01094_473.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Contact 48",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 65",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 82",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 02",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 15.4
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87248,
                    "duration": 114.7,
                    "description": "Review the fictional conversation in #demo-ops-65 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01247_262.png",
                        "demo_alpha_frame_01248_216.png",
                        "demo_alpha_frame_01249_603.png",
                        "demo_alpha_frame_01250_017.png",
                        "demo_alpha_frame_01251_992.png",
                        "demo_alpha_frame_01252_239.png",
                        "demo_alpha_frame_01253_738.png",
                        "demo_alpha_frame_01254_758.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 43",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Demo Contact 60",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 77",
                            "qualifier": "corresponded-with"
                        },
                        {
                            "object": "Demo Contact 94",
                            "qualifier": "corresponded-with"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 114.7
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:35",
            "analysisNodeId": 91036,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 35,
                "traceStart": "2025-02-04T13:37:36.566Z",
                "traceEnd": "2025-02-04T13:49:52.077Z",
                "avgDuration": 360.7
            },
            "steps": [
                {
                    "nodeId": "step:navigate-workspace#salesforce",
                    "analysisNodeId": 87231,
                    "duration": 15.8,
                    "description": "Move through the workspace to continue Sample Workflow 42.",
                    "screenshots": [
                        "demo_alpha_frame_01112_033.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 50",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 11.5
                    }
                },
                {
                    "nodeId": "step:review-pipeline-lead-queue-salesforce#salesforce",
                    "analysisNodeId": 87241,
                    "duration": 344.9,
                    "description": "Review the sample outreach workflow for Demo Account 16 and update its demo status in Salesforce.",
                    "screenshots": [
                        "demo_alpha_frame_01153_735.png",
                        "demo_alpha_frame_01154_938.png",
                        "demo_alpha_frame_01155_756.png",
                        "demo_alpha_frame_01156_337.png",
                        "demo_alpha_frame_01157_477.png",
                        "demo_alpha_frame_01158_445.png",
                        "demo_alpha_frame_01159_924.png",
                        "demo_alpha_frame_01160_334.png",
                        "demo_alpha_frame_01161_481.png",
                        "demo_alpha_frame_01162_072.png",
                        "demo_alpha_frame_01163_450.png",
                        "demo_alpha_frame_01164_033.png",
                        "demo_alpha_frame_01165_360.png",
                        "demo_alpha_frame_01166_453.png",
                        "demo_alpha_frame_01167_676.png",
                        "demo_alpha_frame_01168_117.png",
                        "demo_alpha_frame_01169_287.png",
                        "demo_alpha_frame_01170_155.png",
                        "demo_alpha_frame_01171_829.png",
                        "demo_alpha_frame_01172_663.png",
                        "demo_alpha_frame_01173_231.png",
                        "demo_alpha_frame_01174_127.png",
                        "demo_alpha_frame_01175_683.png",
                        "demo_alpha_frame_01176_520.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 63",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 344.9
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:39",
            "analysisNodeId": 91040,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 39,
                "traceStart": "2025-02-04T15:31:34.291Z",
                "traceEnd": "2025-02-04T15:45:28.672Z",
                "avgDuration": 179.4
            },
            "steps": [
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87340,
                    "duration": 48.1,
                    "description": "Review the fictional conversation in #demo-ops-70 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01547_790.png",
                        "demo_alpha_frame_01548_821.png",
                        "demo_alpha_frame_01549_319.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 48.1
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87348,
                    "duration": 62.1,
                    "description": "Review the fictional conversation in #demo-ops-37 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01609_407.png",
                        "demo_alpha_frame_01610_464.png",
                        "demo_alpha_frame_01611_627.png",
                        "demo_alpha_frame_01612_769.png",
                        "demo_alpha_frame_01613_830.png",
                        "demo_alpha_frame_01614_871.png",
                        "demo_alpha_frame_01615_799.png",
                        "demo_alpha_frame_01616_379.png",
                        "demo_alpha_frame_01617_360.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 62.1
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87349,
                    "duration": 27.2,
                    "description": "Review the fictional conversation in #demo-ops-44 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01618_791.png",
                        "demo_alpha_frame_01619_165.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 27.2
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87352,
                    "duration": 42.0,
                    "description": "Review the fictional conversation in #demo-ops-58 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01623_004.png",
                        "demo_alpha_frame_01624_033.png",
                        "demo_alpha_frame_01625_885.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 23",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 42.0
                    }
                }
            ]
        }
    ]
}
// biome-ignore format: keep the large static demo fixture compact for manual replacement.
export const teamEnablementOnboarding = {
    "slug": "team-enablement-onboarding",
    "name": "Team Enablement & Onboarding",
    "description": "Review and update Sample Enablement Guide 50 with fictional onboarding details in the workspace.",
    "aliases": [],
    "frequency": 4,
    "avgDuration": 712.35,
    "firstSeen": "2025-02-04T09:01:02.042Z",
    "lastSeen": "2025-02-04T15:42:23.726Z",
    "nodes": [
        {
            "id": "step:author-onboarding-or-reference-doc-arc#arc",
            "name": "Author Onboarding or Reference Doc (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:author-onboarding-or-reference-doc-claude#claude",
            "name": "Author Onboarding or Reference Doc (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:configure-onboarding-tools-and-resources-claude#claude",
            "name": "Configure Onboarding Tools and Resources (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:create-training-video-arc#arc",
            "name": "Create Training Video (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:create-training-video-chrome#google-chrome",
            "name": "Create Training Video (Chrome)",
            "app": "Google Chrome"
        },
        {
            "id": "step:create-training-video-lemlist#lemlist",
            "name": "Create Training Video (lemlist)",
            "app": "lemlist"
        },
        {
            "id": "step:message-teammate-slack#slack",
            "name": "Message Teammate (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:research-target-account-claude#claude",
            "name": "Research Target Account (Claude)",
            "app": "Claude"
        },
        {
            "id": "step:review-recording-quicktime-player#quicktime-player",
            "name": "Review Recording (QuickTime Player)",
            "app": "QuickTime Player"
        },
        {
            "id": "step:review-recording-slack#slack",
            "name": "Review Recording (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:share-content-slack#slack",
            "name": "Share Content (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:update-crm-record-slack#slack",
            "name": "Update CRM Record (Slack)",
            "app": "Slack"
        }
    ],
    "sources": [
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 5,
            "traceStart": "2025-02-04T09:01:02.042Z",
            "traceEnd": "2025-02-04T15:42:23.726Z",
            "avgDuration": 971.5
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 15,
            "traceStart": "2025-02-04T10:55:02.723Z",
            "traceEnd": "2025-02-04T14:43:49.714Z",
            "avgDuration": 1207.3
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 25,
            "traceStart": "2025-02-04T12:15:34.890Z",
            "traceEnd": "2025-02-04T13:12:45.124Z",
            "avgDuration": 435.7
        },
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 36,
            "traceStart": "2025-02-04T14:39:52.193Z",
            "traceEnd": "2025-02-04T14:43:49.714Z",
            "avgDuration": 234.9
        }
    ],
    "instances": [
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:5",
            "analysisNodeId": 91006,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 5,
                "traceStart": "2025-02-04T09:01:02.042Z",
                "traceEnd": "2025-02-04T15:42:23.726Z",
                "avgDuration": 971.5
            },
            "steps": [
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-claude#claude",
                    "analysisNodeId": 87013,
                    "duration": 51.5,
                    "description": "Review and update Sample Enablement Guide 40 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00072_736.png",
                        "demo_alpha_frame_00073_731.png",
                        "demo_alpha_frame_00074_264.png",
                        "demo_alpha_frame_00075_167.png",
                        "demo_alpha_frame_00076_248.png",
                        "demo_alpha_frame_00077_255.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 51.5
                    }
                },
                {
                    "nodeId": "step:configure-onboarding-tools-and-resources-claude#claude",
                    "analysisNodeId": 87015,
                    "duration": 12.1,
                    "description": "Review and update Sample Enablement Guide 47 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00079_852.png",
                        "demo_alpha_frame_00080_346.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 8.0,
                        "Google Chrome": 4.1
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-claude#claude",
                    "analysisNodeId": 87023,
                    "duration": 44.1,
                    "description": "Review and update Sample Enablement Guide 96 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00121_271.png",
                        "demo_alpha_frame_00122_516.png",
                        "demo_alpha_frame_00123_217.png",
                        "demo_alpha_frame_00124_726.png",
                        "demo_alpha_frame_00125_287.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 44.1
                    }
                },
                {
                    "nodeId": "step:configure-onboarding-tools-and-resources-claude#claude",
                    "analysisNodeId": 87024,
                    "duration": 6.1,
                    "description": "Review and update Sample Enablement Guide 14 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00126_768.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Vimeo": 2.2,
                        "Claude": 3.9
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-claude#claude",
                    "analysisNodeId": 87030,
                    "duration": 24.5,
                    "description": "Review and update Sample Enablement Guide 56 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00198_183.png",
                        "demo_alpha_frame_00199_931.png",
                        "demo_alpha_frame_00200_163.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 23.7
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87033,
                    "duration": 137.0,
                    "description": "Research Demo Account 77 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00223_512.png",
                        "demo_alpha_frame_00224_998.png",
                        "demo_alpha_frame_00225_237.png",
                        "demo_alpha_frame_00226_591.png",
                        "demo_alpha_frame_00227_416.png",
                        "demo_alpha_frame_00228_958.png",
                        "demo_alpha_frame_00229_615.png",
                        "demo_alpha_frame_00230_713.png",
                        "demo_alpha_frame_00231_920.png",
                        "demo_alpha_frame_00232_436.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 06",
                            "qualifier": "researched"
                        },
                        {
                            "object": "Demo Account 23",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 137.0
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87040,
                    "duration": 17.6,
                    "description": "Research Demo Account 23 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00253_291.png",
                        "demo_alpha_frame_00254_695.png",
                        "demo_alpha_frame_00255_999.png",
                        "demo_alpha_frame_00256_402.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 83",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 17.6
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87042,
                    "duration": 16.0,
                    "description": "Review the fictional conversation in #demo-ops-30 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00265_217.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 08",
                            "qualifier": "researched"
                        },
                        {
                            "object": "Demo Account 25",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 9.3,
                        "Claude": 6.7
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87045,
                    "duration": 42.0,
                    "description": "Research Demo Account 37 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00280_172.png",
                        "demo_alpha_frame_00281_040.png",
                        "demo_alpha_frame_00282_623.png",
                        "demo_alpha_frame_00283_540.png",
                        "demo_alpha_frame_00284_131.png",
                        "demo_alpha_frame_00285_077.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 41",
                            "qualifier": "researched"
                        },
                        {
                            "object": "Sample Reference 58",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 42.0
                    }
                },
                {
                    "nodeId": "step:research-target-account-claude#claude",
                    "analysisNodeId": 87048,
                    "duration": 10.0,
                    "description": "Research Demo Account 58 and summarize its fictional business profile in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_00312_632.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Account 74",
                            "qualifier": "researched"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 10.0
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-arc#arc",
                    "analysisNodeId": 87078,
                    "duration": 69.2,
                    "description": "Review and update Sample Enablement Guide 55 with fictional onboarding details in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00482_800.png",
                        "demo_alpha_frame_00483_933.png",
                        "demo_alpha_frame_00484_938.png",
                        "demo_alpha_frame_00485_946.png",
                        "demo_alpha_frame_00486_140.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 69.2
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-claude#claude",
                    "analysisNodeId": 87342,
                    "duration": 24.7,
                    "description": "Review and update Sample Enablement Guide 84 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_01552_117.png",
                        "demo_alpha_frame_01553_769.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 10",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 24.7
                    }
                },
                {
                    "nodeId": "step:configure-onboarding-tools-and-resources-claude#claude",
                    "analysisNodeId": 87343,
                    "duration": 60.6,
                    "description": "Review and update Sample Enablement Guide 91 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_01554_345.png",
                        "demo_alpha_frame_01555_928.png",
                        "demo_alpha_frame_01556_217.png",
                        "demo_alpha_frame_01557_986.png",
                        "demo_alpha_frame_01558_881.png",
                        "demo_alpha_frame_01559_410.png",
                        "demo_alpha_frame_01560_101.png",
                        "demo_alpha_frame_01561_344.png",
                        "demo_alpha_frame_01562_926.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 60.6
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-claude#claude",
                    "analysisNodeId": 87345,
                    "duration": 286.6,
                    "description": "Review and update Sample Enablement Guide 16 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_01564_542.png",
                        "demo_alpha_frame_01565_047.png",
                        "demo_alpha_frame_01566_463.png",
                        "demo_alpha_frame_01567_532.png",
                        "demo_alpha_frame_01568_748.png",
                        "demo_alpha_frame_01569_051.png",
                        "demo_alpha_frame_01570_521.png",
                        "demo_alpha_frame_01571_678.png",
                        "demo_alpha_frame_01572_791.png",
                        "demo_alpha_frame_01573_502.png",
                        "demo_alpha_frame_01574_979.png",
                        "demo_alpha_frame_01575_966.png",
                        "demo_alpha_frame_01576_554.png",
                        "demo_alpha_frame_01577_990.png",
                        "demo_alpha_frame_01578_161.png",
                        "demo_alpha_frame_01579_489.png",
                        "demo_alpha_frame_01580_443.png",
                        "demo_alpha_frame_01581_277.png",
                        "demo_alpha_frame_01582_373.png",
                        "demo_alpha_frame_01583_673.png",
                        "demo_alpha_frame_01584_751.png",
                        "demo_alpha_frame_01585_577.png",
                        "demo_alpha_frame_01586_937.png",
                        "demo_alpha_frame_01587_898.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 43",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Claude": 286.6
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-claude#claude",
                    "analysisNodeId": 87346,
                    "duration": 101.1,
                    "description": "Review and update Sample Enablement Guide 23 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_01588_654.png",
                        "demo_alpha_frame_01589_505.png",
                        "demo_alpha_frame_01590_943.png",
                        "demo_alpha_frame_01591_990.png",
                        "demo_alpha_frame_01592_223.png",
                        "demo_alpha_frame_01593_999.png",
                        "demo_alpha_frame_01594_404.png",
                        "demo_alpha_frame_01595_490.png",
                        "demo_alpha_frame_01596_085.png",
                        "demo_alpha_frame_01597_796.png",
                        "demo_alpha_frame_01598_583.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 101.1
                    }
                },
                {
                    "nodeId": "step:author-onboarding-or-reference-doc-claude#claude",
                    "analysisNodeId": 87347,
                    "duration": 68.4,
                    "description": "Review and update Sample Enablement Guide 30 with fictional onboarding details in Claude.",
                    "screenshots": [
                        "demo_alpha_frame_01599_665.png",
                        "demo_alpha_frame_01600_888.png",
                        "demo_alpha_frame_01601_014.png",
                        "demo_alpha_frame_01602_140.png",
                        "demo_alpha_frame_01603_944.png",
                        "demo_alpha_frame_01604_603.png",
                        "demo_alpha_frame_01605_399.png",
                        "demo_alpha_frame_01606_383.png",
                        "demo_alpha_frame_01607_631.png",
                        "demo_alpha_frame_01608_485.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 68.4
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:15",
            "analysisNodeId": 91016,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 15,
                "traceStart": "2025-02-04T10:55:02.723Z",
                "traceEnd": "2025-02-04T14:43:49.714Z",
                "avgDuration": 1207.3
            },
            "steps": [
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87073,
                    "duration": 155.6,
                    "description": "Review Sample Session 27 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00442_592.png",
                        "demo_alpha_frame_00443_904.png",
                        "demo_alpha_frame_00444_363.png",
                        "demo_alpha_frame_00445_733.png",
                        "demo_alpha_frame_00446_526.png",
                        "demo_alpha_frame_00447_338.png",
                        "demo_alpha_frame_00448_241.png",
                        "demo_alpha_frame_00449_057.png",
                        "demo_alpha_frame_00450_520.png",
                        "demo_alpha_frame_00451_883.png",
                        "demo_alpha_frame_00452_806.png",
                        "demo_alpha_frame_00453_207.png",
                        "demo_alpha_frame_00454_861.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 58",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 65.2,
                        "Shortcut": 64.7
                    }
                },
                {
                    "nodeId": "step:create-training-video-lemlist#lemlist",
                    "analysisNodeId": 87076,
                    "duration": 56.7,
                    "description": "Review Sample Session 41 and record a fictional outcome in lemlist.",
                    "screenshots": [
                        "demo_alpha_frame_00472_375.png",
                        "demo_alpha_frame_00473_961.png",
                        "demo_alpha_frame_00474_014.png",
                        "demo_alpha_frame_00475_148.png",
                        "demo_alpha_frame_00476_508.png",
                        "demo_alpha_frame_00477_968.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "lemlist": 47.9
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87083,
                    "duration": 9.9,
                    "description": "Review Sample Session 83 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00513_162.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 9.9
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87084,
                    "duration": 88.5,
                    "description": "Review Sample Session 90 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00514_187.png",
                        "demo_alpha_frame_00515_053.png",
                        "demo_alpha_frame_00516_306.png",
                        "demo_alpha_frame_00517_390.png",
                        "demo_alpha_frame_00518_488.png",
                        "demo_alpha_frame_00519_809.png",
                        "demo_alpha_frame_00520_037.png",
                        "demo_alpha_frame_00521_215.png",
                        "demo_alpha_frame_00522_486.png",
                        "demo_alpha_frame_00523_427.png",
                        "demo_alpha_frame_00524_673.png",
                        "demo_alpha_frame_00525_757.png",
                        "demo_alpha_frame_00526_116.png",
                        "demo_alpha_frame_00527_185.png",
                        "demo_alpha_frame_00528_923.png",
                        "demo_alpha_frame_00529_058.png",
                        "demo_alpha_frame_00530_061.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 88.5
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87087,
                    "duration": 7.6,
                    "description": "Review Sample Session 15 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00534_719.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 7.6
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87093,
                    "duration": 9.3,
                    "description": "Review Sample Session 43 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00548_029.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 9.3
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87095,
                    "duration": 8.5,
                    "description": "Review Sample Session 57 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00551_174.png",
                        "demo_alpha_frame_00552_067.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 8.5
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87097,
                    "duration": 150.0,
                    "description": "Review Sample Session 71 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00554_588.png",
                        "demo_alpha_frame_00555_030.png",
                        "demo_alpha_frame_00556_148.png",
                        "demo_alpha_frame_00557_400.png",
                        "demo_alpha_frame_00558_035.png",
                        "demo_alpha_frame_00559_881.png",
                        "demo_alpha_frame_00560_438.png",
                        "demo_alpha_frame_00561_276.png",
                        "demo_alpha_frame_00562_805.png",
                        "demo_alpha_frame_00563_774.png",
                        "demo_alpha_frame_00564_912.png",
                        "demo_alpha_frame_00565_497.png",
                        "demo_alpha_frame_00566_061.png",
                        "demo_alpha_frame_00567_019.png",
                        "demo_alpha_frame_00568_876.png",
                        "demo_alpha_frame_00569_623.png",
                        "demo_alpha_frame_00570_498.png",
                        "demo_alpha_frame_00571_611.png",
                        "demo_alpha_frame_00572_332.png",
                        "demo_alpha_frame_00573_775.png",
                        "demo_alpha_frame_00574_213.png",
                        "demo_alpha_frame_00575_915.png",
                        "demo_alpha_frame_00576_008.png",
                        "demo_alpha_frame_00577_887.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 150.0
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87100,
                    "duration": 49.6,
                    "description": "Review Sample Session 92 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00580_085.png",
                        "demo_alpha_frame_00581_641.png",
                        "demo_alpha_frame_00582_382.png",
                        "demo_alpha_frame_00583_811.png",
                        "demo_alpha_frame_00584_924.png",
                        "demo_alpha_frame_00585_737.png",
                        "demo_alpha_frame_00586_647.png",
                        "demo_alpha_frame_00587_101.png",
                        "demo_alpha_frame_00588_468.png",
                        "demo_alpha_frame_00589_643.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Calendar Item 64",
                            "qualifier": "filtered"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 49.6
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87101,
                    "duration": 35.5,
                    "description": "Review Sample Session 10 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00590_886.png",
                        "demo_alpha_frame_00591_064.png",
                        "demo_alpha_frame_00592_825.png",
                        "demo_alpha_frame_00593_667.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 75",
                            "qualifier": "reviewed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 35.5
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87108,
                    "duration": 51.3,
                    "description": "Review Sample Session 59 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00617_373.png",
                        "demo_alpha_frame_00618_713.png",
                        "demo_alpha_frame_00619_200.png",
                        "demo_alpha_frame_00620_854.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 55",
                            "qualifier": "accessed"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 51.3
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87110,
                    "duration": 28.8,
                    "description": "Review Sample Session 73 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00624_228.png",
                        "demo_alpha_frame_00625_548.png",
                        "demo_alpha_frame_00626_073.png",
                        "demo_alpha_frame_00627_875.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 77",
                            "qualifier": "opened"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 28.8
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87123,
                    "duration": 19.2,
                    "description": "Review Sample Session 75 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00691_779.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 19.2
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87124,
                    "duration": 11.5,
                    "description": "Review Sample Session 82 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00692_412.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 11.5
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87125,
                    "duration": 52.8,
                    "description": "Review Sample Session 89 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00693_534.png",
                        "demo_alpha_frame_00694_760.png",
                        "demo_alpha_frame_00695_668.png",
                        "demo_alpha_frame_00696_237.png",
                        "demo_alpha_frame_00697_369.png",
                        "demo_alpha_frame_00698_392.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 52.8
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87126,
                    "duration": 26.1,
                    "description": "Review Sample Session 96 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00699_742.png",
                        "demo_alpha_frame_00700_927.png",
                        "demo_alpha_frame_00701_247.png",
                        "demo_alpha_frame_00702_180.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 26.1
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87137,
                    "duration": 17.0,
                    "description": "Review Sample Session 77 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00737_536.png",
                        "demo_alpha_frame_00738_459.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 17.0
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87147,
                    "duration": 12.6,
                    "description": "Review Sample Session 44 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00804_304.png",
                        "demo_alpha_frame_00805_496.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 12.6
                    }
                },
                {
                    "nodeId": "step:review-recording-quicktime-player#quicktime-player",
                    "analysisNodeId": 87152,
                    "duration": 59.2,
                    "description": "Review Sample Session 79 and record a fictional outcome in QuickTime Player.",
                    "screenshots": [
                        "demo_alpha_frame_00811_522.png",
                        "demo_alpha_frame_00812_842.png",
                        "demo_alpha_frame_00813_163.png",
                        "demo_alpha_frame_00814_899.png",
                        "demo_alpha_frame_00815_377.png",
                        "demo_alpha_frame_00816_832.png",
                        "demo_alpha_frame_00817_618.png",
                        "demo_alpha_frame_00818_229.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "QuickTime Player": 56.9
                    }
                },
                {
                    "nodeId": "step:review-recording-slack#slack",
                    "analysisNodeId": 87154,
                    "duration": 8.1,
                    "description": "Review Sample Session 93 and record a fictional outcome in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00826_627.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 8.1
                    }
                },
                {
                    "nodeId": "step:review-recording-slack#slack",
                    "analysisNodeId": 87156,
                    "duration": 16.3,
                    "description": "Review Sample Session 18 and record a fictional outcome in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00828_198.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 01",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 16.3
                    }
                },
                {
                    "nodeId": "step:review-recording-slack#slack",
                    "analysisNodeId": 87160,
                    "duration": 24.2,
                    "description": "Review Sample Session 46 and record a fictional outcome in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00832_670.png",
                        "demo_alpha_frame_00833_074.png",
                        "demo_alpha_frame_00834_399.png",
                        "demo_alpha_frame_00835_503.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 24.2
                    }
                },
                {
                    "nodeId": "step:review-recording-slack#slack",
                    "analysisNodeId": 87161,
                    "duration": 6.0,
                    "description": "Review Sample Session 53 and record a fictional outcome in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00836_826.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 56",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 6.0
                    }
                },
                {
                    "nodeId": "step:review-recording-slack#slack",
                    "analysisNodeId": 87164,
                    "duration": 28.3,
                    "description": "Review Sample Session 74 and record a fictional outcome in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00840_361.png",
                        "demo_alpha_frame_00841_771.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 28.3
                    }
                },
                {
                    "nodeId": "step:review-recording-slack#slack",
                    "analysisNodeId": 87168,
                    "duration": 23.3,
                    "description": "Review Sample Session 95 and record a fictional outcome in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00855_859.png",
                        "demo_alpha_frame_00856_584.png",
                        "demo_alpha_frame_00857_776.png",
                        "demo_alpha_frame_00858_028.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 36",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 23.3
                    }
                },
                {
                    "nodeId": "step:review-recording-slack#slack",
                    "analysisNodeId": 87170,
                    "duration": 16.5,
                    "description": "Review Sample Session 20 and record a fictional outcome in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00860_483.png",
                        "demo_alpha_frame_00861_125.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 16.5
                    }
                },
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87266,
                    "duration": 132.8,
                    "description": "Review Sample Session 67 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01300_787.png",
                        "demo_alpha_frame_01301_908.png",
                        "demo_alpha_frame_01302_498.png",
                        "demo_alpha_frame_01303_636.png",
                        "demo_alpha_frame_01304_359.png",
                        "demo_alpha_frame_01305_242.png",
                        "demo_alpha_frame_01306_636.png",
                        "demo_alpha_frame_01307_936.png",
                        "demo_alpha_frame_01308_348.png",
                        "demo_alpha_frame_01309_337.png",
                        "demo_alpha_frame_01310_848.png",
                        "demo_alpha_frame_01311_366.png",
                        "demo_alpha_frame_01312_858.png",
                        "demo_alpha_frame_01313_775.png",
                        "demo_alpha_frame_01314_868.png",
                        "demo_alpha_frame_01315_341.png",
                        "demo_alpha_frame_01316_566.png",
                        "demo_alpha_frame_01317_497.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 47",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 132.8
                    }
                },
                {
                    "nodeId": "step:create-training-video-chrome#google-chrome",
                    "analysisNodeId": 87267,
                    "duration": 102.1,
                    "description": "Review Sample Session 74 and record a fictional outcome in Chrome.",
                    "screenshots": [
                        "demo_alpha_frame_01318_214.png",
                        "demo_alpha_frame_01319_739.png",
                        "demo_alpha_frame_01320_446.png",
                        "demo_alpha_frame_01321_969.png",
                        "demo_alpha_frame_01322_806.png",
                        "demo_alpha_frame_01323_436.png",
                        "demo_alpha_frame_01324_085.png",
                        "demo_alpha_frame_01325_373.png",
                        "demo_alpha_frame_01326_618.png",
                        "demo_alpha_frame_01327_174.png",
                        "demo_alpha_frame_01328_699.png",
                        "demo_alpha_frame_01329_952.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Google Chrome": 102.1
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:25",
            "analysisNodeId": 91026,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 25,
                "traceStart": "2025-02-04T12:15:34.890Z",
                "traceEnd": "2025-02-04T13:12:45.124Z",
                "avgDuration": 435.7
            },
            "steps": [
                {
                    "nodeId": "step:update-crm-record-slack#slack",
                    "analysisNodeId": 87158,
                    "duration": 12.7,
                    "description": "Open the fictional record for Demo Account 32 and update its sample fields in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00830_842.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 23",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 12.7
                    }
                },
                {
                    "nodeId": "step:share-content-slack#slack",
                    "analysisNodeId": 87173,
                    "duration": 45.9,
                    "description": "Review and update Sample Enablement Guide 34 with fictional onboarding details in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00868_849.png",
                        "demo_alpha_frame_00869_141.png",
                        "demo_alpha_frame_00870_786.png",
                        "demo_alpha_frame_00871_122.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 45.9
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87174,
                    "duration": 32.4,
                    "description": "Review the fictional conversation in #demo-ops-41 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00872_636.png",
                        "demo_alpha_frame_00873_260.png",
                        "demo_alpha_frame_00874_234.png",
                        "demo_alpha_frame_00875_433.png"
                    ],
                    "objects": [
                        {
                            "object": "#demo-ops-05",
                            "qualifier": "posted-to"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 32.4
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87175,
                    "duration": 22.9,
                    "description": "Review the fictional conversation in #demo-ops-48 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00876_676.png",
                        "demo_alpha_frame_00877_629.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 22.9
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87176,
                    "duration": 189.9,
                    "description": "Review the fictional conversation in #demo-ops-55 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00878_355.png",
                        "demo_alpha_frame_00879_820.png",
                        "demo_alpha_frame_00880_230.png",
                        "demo_alpha_frame_00881_708.png",
                        "demo_alpha_frame_00882_450.png",
                        "demo_alpha_frame_00883_736.png",
                        "demo_alpha_frame_00884_919.png",
                        "demo_alpha_frame_00885_432.png",
                        "demo_alpha_frame_00886_650.png",
                        "demo_alpha_frame_00887_108.png",
                        "demo_alpha_frame_00888_148.png",
                        "demo_alpha_frame_00889_162.png",
                        "demo_alpha_frame_00890_420.png",
                        "demo_alpha_frame_00891_841.png",
                        "demo_alpha_frame_00892_320.png"
                    ],
                    "objects": [
                        {
                            "object": "#demo-ops-27",
                            "qualifier": "posted-to"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 189.9
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87177,
                    "duration": 27.6,
                    "description": "Review the fictional conversation in #demo-ops-62 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00893_266.png",
                        "demo_alpha_frame_00894_082.png",
                        "demo_alpha_frame_00895_140.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 38",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 27.6
                    }
                },
                {
                    "nodeId": "step:review-recording-slack#slack",
                    "analysisNodeId": 87178,
                    "duration": 4.3,
                    "description": "Review Sample Session 69 and record a fictional outcome in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00896_034.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 49",
                            "qualifier": "accessed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 4.3
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87179,
                    "duration": 35.1,
                    "description": "Review the fictional conversation in #demo-ops-76 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00897_889.png",
                        "demo_alpha_frame_00898_670.png",
                        "demo_alpha_frame_00899_380.png",
                        "demo_alpha_frame_00900_605.png",
                        "demo_alpha_frame_00901_061.png",
                        "demo_alpha_frame_00902_876.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 35.1
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87180,
                    "duration": 16.5,
                    "description": "Review the fictional conversation in #demo-ops-83 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00903_159.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 16.5
                    }
                },
                {
                    "nodeId": "step:update-crm-record-slack#slack",
                    "analysisNodeId": 87193,
                    "duration": 48.4,
                    "description": "Open the fictional record for Demo Account 64 and update its sample fields in Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00962_208.png",
                        "demo_alpha_frame_00963_575.png",
                        "demo_alpha_frame_00964_078.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 48.4
                    }
                }
            ]
        },
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:36",
            "analysisNodeId": 91037,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 36,
                "traceStart": "2025-02-04T14:39:52.193Z",
                "traceEnd": "2025-02-04T14:43:49.714Z",
                "avgDuration": 234.9
            },
            "steps": [
                {
                    "nodeId": "step:create-training-video-arc#arc",
                    "analysisNodeId": 87266,
                    "duration": 132.8,
                    "description": "Review Sample Session 67 and record a fictional outcome in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01300_787.png",
                        "demo_alpha_frame_01301_908.png",
                        "demo_alpha_frame_01302_498.png",
                        "demo_alpha_frame_01303_636.png",
                        "demo_alpha_frame_01304_359.png",
                        "demo_alpha_frame_01305_242.png",
                        "demo_alpha_frame_01306_636.png",
                        "demo_alpha_frame_01307_936.png",
                        "demo_alpha_frame_01308_348.png",
                        "demo_alpha_frame_01309_337.png",
                        "demo_alpha_frame_01310_848.png",
                        "demo_alpha_frame_01311_366.png",
                        "demo_alpha_frame_01312_858.png",
                        "demo_alpha_frame_01313_775.png",
                        "demo_alpha_frame_01314_868.png",
                        "demo_alpha_frame_01315_341.png",
                        "demo_alpha_frame_01316_566.png",
                        "demo_alpha_frame_01317_497.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 47",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 132.8
                    }
                },
                {
                    "nodeId": "step:create-training-video-chrome#google-chrome",
                    "analysisNodeId": 87267,
                    "duration": 102.1,
                    "description": "Review Sample Session 74 and record a fictional outcome in Chrome.",
                    "screenshots": [
                        "demo_alpha_frame_01318_214.png",
                        "demo_alpha_frame_01319_739.png",
                        "demo_alpha_frame_01320_446.png",
                        "demo_alpha_frame_01321_969.png",
                        "demo_alpha_frame_01322_806.png",
                        "demo_alpha_frame_01323_436.png",
                        "demo_alpha_frame_01324_085.png",
                        "demo_alpha_frame_01325_373.png",
                        "demo_alpha_frame_01326_618.png",
                        "demo_alpha_frame_01327_174.png",
                        "demo_alpha_frame_01328_699.png",
                        "demo_alpha_frame_01329_952.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Google Chrome": 102.1
                    }
                }
            ]
        }
    ]
}
// biome-ignore format: keep the large static demo fixture compact for manual replacement.
export const navigateWorkspace = {
    "slug": "navigate-workspace",
    "name": "Navigate Workspace",
    "description": "Move through the workspace to continue Sample Workflow 72.",
    "aliases": [],
    "frequency": 1,
    "avgDuration": 4298.1,
    "firstSeen": "2025-02-04T08:48:08.219Z",
    "lastSeen": "2025-02-04T15:30:37.327Z",
    "nodes": [
        {
            "id": "step:check-messages-arc#arc",
            "name": "Check Messages (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:check-messages-gmail#arc",
            "name": "Check Messages (Gmail)",
            "app": "Arc"
        },
        {
            "id": "step:check-messages-gmail#salesforce",
            "name": "Check Messages (Gmail)",
            "app": "Salesforce"
        },
        {
            "id": "step:check-messages-slack#arc",
            "name": "Check Messages (Slack)",
            "app": "Arc"
        },
        {
            "id": "step:check-messages-slack#slack",
            "name": "Check Messages (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:enrich-contact-data-arc#arc",
            "name": "Enrich Contact Data (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:manage-calendar-and-availability-arc#arc",
            "name": "Manage Calendar and Availability (Arc)",
            "app": "Arc"
        },
        {
            "id": "step:message-teammate-slack#slack",
            "name": "Message Teammate (Slack)",
            "app": "Slack"
        },
        {
            "id": "step:navigate-workspace#arc",
            "name": "Navigate workspace",
            "app": "Arc"
        },
        {
            "id": "step:navigate-workspace#gmail",
            "name": "Navigate workspace",
            "app": "Gmail"
        },
        {
            "id": "step:navigate-workspace#google-chrome",
            "name": "Navigate workspace",
            "app": "Google Chrome"
        },
        {
            "id": "step:navigate-workspace#none",
            "name": "Navigate workspace",
            "app": null
        },
        {
            "id": "step:navigate-workspace#notion",
            "name": "Navigate workspace",
            "app": "Notion"
        },
        {
            "id": "step:navigate-workspace#salesforce",
            "name": "Navigate workspace",
            "app": "Salesforce"
        },
        {
            "id": "step:navigate-workspace#slack",
            "name": "Navigate workspace",
            "app": "Slack"
        },
        {
            "id": "step:navigate-workspace#vimeo",
            "name": "Navigate workspace",
            "app": "Vimeo"
        }
    ],
    "sources": [
        {
            "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
            "recordingName": "BDR work",
            "userId": "00068000-11fb-8302-8c10-1a913601212b",
            "userName": "Anonymous Bdr",
            "recordingDate": "2025-02-04",
            "traceIndex": 1,
            "traceStart": "2025-02-04T08:48:08.219Z",
            "traceEnd": "2025-02-04T15:30:37.327Z",
            "avgDuration": 4298.1
        }
    ],
    "instances": [
        {
            "id": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb:1",
            "analysisNodeId": 91002,
            "source": {
                "recordingId": "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
                "recordingName": "BDR work",
                "userId": "00068000-11fb-8302-8c10-1a913601212b",
                "userName": "Anonymous Bdr",
                "recordingDate": "2025-02-04",
                "traceIndex": 1,
                "traceStart": "2025-02-04T08:48:08.219Z",
                "traceEnd": "2025-02-04T15:30:37.327Z",
                "avgDuration": 4298.1
            },
            "steps": [
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87002,
                    "duration": 30.0,
                    "description": "Review a sample calendar entry for Demo Account 66 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00005_369.png",
                        "demo_alpha_frame_00006_759.png",
                        "demo_alpha_frame_00007_941.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 30.0
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87005,
                    "duration": 20.6,
                    "description": "Move through the workspace to continue Sample Workflow 87.",
                    "screenshots": [
                        "demo_alpha_frame_00033_582.png",
                        "demo_alpha_frame_00034_604.png",
                        "demo_alpha_frame_00035_883.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 15.7,
                        "LinkedIn": 4.9
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87009,
                    "duration": 30.2,
                    "description": "Move through the workspace to continue Sample Workflow 19.",
                    "screenshots": [
                        "demo_alpha_frame_00051_616.png",
                        "demo_alpha_frame_00052_553.png",
                        "demo_alpha_frame_00053_987.png",
                        "demo_alpha_frame_00054_397.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 30.2
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87011,
                    "duration": 119.2,
                    "description": "Move through the workspace to continue Sample Workflow 26.",
                    "screenshots": [
                        "demo_alpha_frame_00056_448.png",
                        "demo_alpha_frame_00057_819.png",
                        "demo_alpha_frame_00058_186.png",
                        "demo_alpha_frame_00059_129.png",
                        "demo_alpha_frame_00060_853.png",
                        "demo_alpha_frame_00061_184.png",
                        "demo_alpha_frame_00062_921.png",
                        "demo_alpha_frame_00063_738.png",
                        "demo_alpha_frame_00064_747.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 119.2
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87012,
                    "duration": 77.1,
                    "description": "Move through the workspace to continue Sample Workflow 33.",
                    "screenshots": [
                        "demo_alpha_frame_00065_355.png",
                        "demo_alpha_frame_00066_358.png",
                        "demo_alpha_frame_00067_048.png",
                        "demo_alpha_frame_00068_799.png",
                        "demo_alpha_frame_00069_559.png",
                        "demo_alpha_frame_00070_501.png",
                        "demo_alpha_frame_00071_682.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 77.1
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87017,
                    "duration": 14.0,
                    "description": "Move through the workspace to continue Sample Workflow 61.",
                    "screenshots": [
                        "demo_alpha_frame_00087_746.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 10.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#vimeo",
                    "analysisNodeId": 87025,
                    "duration": 32.6,
                    "description": "Move through the workspace to continue Sample Workflow 21.",
                    "screenshots": [
                        "demo_alpha_frame_00127_036.png",
                        "demo_alpha_frame_00128_112.png",
                        "demo_alpha_frame_00129_781.png",
                        "demo_alpha_frame_00130_671.png",
                        "demo_alpha_frame_00131_048.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 2.5,
                        "Vimeo": 20.4,
                        "Claude": 9.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#vimeo",
                    "analysisNodeId": 87027,
                    "duration": 154.5,
                    "description": "Move through the workspace to continue Sample Workflow 35.",
                    "screenshots": [
                        "demo_alpha_frame_00134_996.png",
                        "demo_alpha_frame_00135_436.png",
                        "demo_alpha_frame_00136_503.png",
                        "demo_alpha_frame_00137_870.png",
                        "demo_alpha_frame_00138_543.png",
                        "demo_alpha_frame_00139_933.png",
                        "demo_alpha_frame_00140_939.png",
                        "demo_alpha_frame_00141_578.png",
                        "demo_alpha_frame_00142_970.png",
                        "demo_alpha_frame_00143_319.png",
                        "demo_alpha_frame_00144_523.png",
                        "demo_alpha_frame_00145_565.png",
                        "demo_alpha_frame_00146_120.png",
                        "demo_alpha_frame_00147_741.png",
                        "demo_alpha_frame_00148_212.png",
                        "demo_alpha_frame_00149_424.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 22.0,
                        "Vimeo": 128.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87031,
                    "duration": 170.3,
                    "description": "Move through the workspace to continue Sample Workflow 63.",
                    "screenshots": [
                        "demo_alpha_frame_00201_063.png",
                        "demo_alpha_frame_00202_509.png",
                        "demo_alpha_frame_00203_051.png",
                        "demo_alpha_frame_00204_250.png",
                        "demo_alpha_frame_00205_198.png",
                        "demo_alpha_frame_00206_977.png",
                        "demo_alpha_frame_00207_799.png",
                        "demo_alpha_frame_00208_452.png",
                        "demo_alpha_frame_00209_510.png",
                        "demo_alpha_frame_00210_433.png",
                        "demo_alpha_frame_00211_293.png",
                        "demo_alpha_frame_00212_213.png",
                        "demo_alpha_frame_00213_336.png",
                        "demo_alpha_frame_00214_037.png",
                        "demo_alpha_frame_00215_218.png",
                        "demo_alpha_frame_00216_238.png",
                        "demo_alpha_frame_00217_213.png",
                        "demo_alpha_frame_00218_457.png",
                        "demo_alpha_frame_00219_115.png",
                        "demo_alpha_frame_00220_944.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 169.8
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87032,
                    "duration": 5.3,
                    "description": "Move through the workspace to continue Sample Workflow 70.",
                    "screenshots": [
                        "demo_alpha_frame_00221_845.png",
                        "demo_alpha_frame_00222_062.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 5.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#none",
                    "analysisNodeId": 87036,
                    "duration": 7.0,
                    "description": "Move through the workspace to continue Sample Workflow 91.",
                    "screenshots": [
                        "demo_alpha_frame_00243_216.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Claude": 2.0,
                        "Arc": 2.5
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87051,
                    "duration": 12.0,
                    "description": "Move through the workspace to continue Sample Workflow 65.",
                    "screenshots": [
                        "demo_alpha_frame_00315_249.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "lemlist": 5.9,
                        "Arc": 6.2
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87053,
                    "duration": 9.9,
                    "description": "Move through the workspace to continue Sample Workflow 79.",
                    "screenshots": [
                        "demo_alpha_frame_00321_907.png",
                        "demo_alpha_frame_00322_419.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 9.9
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87056,
                    "duration": 27.1,
                    "description": "Move through the workspace to continue Sample Workflow 11.",
                    "screenshots": [
                        "demo_alpha_frame_00327_462.png",
                        "demo_alpha_frame_00328_217.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 27.1
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87058,
                    "duration": 404.7,
                    "description": "Move through the workspace to continue Sample Workflow 25.",
                    "screenshots": [
                        "demo_alpha_frame_00331_180.png",
                        "demo_alpha_frame_00332_715.png",
                        "demo_alpha_frame_00333_389.png",
                        "demo_alpha_frame_00334_192.png",
                        "demo_alpha_frame_00335_578.png",
                        "demo_alpha_frame_00336_766.png",
                        "demo_alpha_frame_00337_520.png",
                        "demo_alpha_frame_00338_398.png",
                        "demo_alpha_frame_00339_078.png",
                        "demo_alpha_frame_00340_667.png",
                        "demo_alpha_frame_00341_052.png",
                        "demo_alpha_frame_00342_823.png",
                        "demo_alpha_frame_00343_830.png",
                        "demo_alpha_frame_00344_047.png",
                        "demo_alpha_frame_00345_404.png",
                        "demo_alpha_frame_00346_763.png",
                        "demo_alpha_frame_00347_162.png",
                        "demo_alpha_frame_00348_125.png",
                        "demo_alpha_frame_00349_675.png",
                        "demo_alpha_frame_00350_444.png",
                        "demo_alpha_frame_00351_662.png",
                        "demo_alpha_frame_00352_970.png",
                        "demo_alpha_frame_00353_574.png",
                        "demo_alpha_frame_00354_854.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 404.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#gmail",
                    "analysisNodeId": 87060,
                    "duration": 11.5,
                    "description": "Move through the workspace to continue Sample Workflow 39.",
                    "screenshots": [
                        "demo_alpha_frame_00361_686.png",
                        "demo_alpha_frame_00362_622.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Gmail": 11.5
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#salesforce",
                    "analysisNodeId": 87062,
                    "duration": 13.2,
                    "description": "Move through the workspace to continue Sample Workflow 53.",
                    "screenshots": [
                        "demo_alpha_frame_00368_863.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Gmail": 6.0,
                        "Salesforce": 6.4
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#arc",
                    "analysisNodeId": 87063,
                    "duration": 15.7,
                    "description": "Review the fictional conversation in #demo-ops-60 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_00369_569.png",
                        "demo_alpha_frame_00370_453.png",
                        "demo_alpha_frame_00371_620.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 11.8
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87066,
                    "duration": 16.0,
                    "description": "Move through the workspace to continue Sample Workflow 81.",
                    "screenshots": [
                        "demo_alpha_frame_00382_862.png",
                        "demo_alpha_frame_00383_836.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 10.1,
                        "Gmail": 6.0
                    }
                },
                {
                    "nodeId": "step:check-messages-slack#slack",
                    "analysisNodeId": 87072,
                    "duration": 20.6,
                    "description": "Review the fictional conversation in #demo-ops-20 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00440_028.png",
                        "demo_alpha_frame_00441_945.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 47",
                            "qualifier": "archived"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 11.5
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87089,
                    "duration": 5.4,
                    "description": "Move through the workspace to continue Sample Workflow 22.",
                    "screenshots": [
                        "demo_alpha_frame_00538_407.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 5.4
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87094,
                    "duration": 21.5,
                    "description": "Move through the workspace to continue Sample Workflow 50.",
                    "screenshots": [
                        "demo_alpha_frame_00549_058.png",
                        "demo_alpha_frame_00550_307.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 21.5
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87119,
                    "duration": 8.4,
                    "description": "Move through the workspace to continue Sample Workflow 47.",
                    "screenshots": [
                        "demo_alpha_frame_00673_551.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 8.4
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87122,
                    "duration": 5.9,
                    "description": "Move through the workspace to continue Sample Workflow 68.",
                    "screenshots": [
                        "demo_alpha_frame_00690_461.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 5.9
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87151,
                    "duration": 9.9,
                    "description": "Move through the workspace to continue Sample Workflow 72.",
                    "screenshots": [
                        "demo_alpha_frame_00808_910.png",
                        "demo_alpha_frame_00809_304.png",
                        "demo_alpha_frame_00810_768.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 9.9
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87153,
                    "duration": 36.7,
                    "description": "Move through the workspace to continue Sample Workflow 86.",
                    "screenshots": [
                        "demo_alpha_frame_00819_628.png",
                        "demo_alpha_frame_00820_820.png",
                        "demo_alpha_frame_00821_442.png",
                        "demo_alpha_frame_00822_519.png",
                        "demo_alpha_frame_00823_767.png",
                        "demo_alpha_frame_00824_012.png",
                        "demo_alpha_frame_00825_670.png"
                    ],
                    "objects": [
                        {
                            "object": "Demo Item 65",
                            "qualifier": "viewed"
                        },
                        {
                            "object": "Demo Item 82",
                            "qualifier": "viewed"
                        },
                        {
                            "object": "Demo Item 02",
                            "qualifier": "viewed"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 31.1
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87155,
                    "duration": 14.1,
                    "description": "Move through the workspace to continue Sample Workflow 11.",
                    "screenshots": [
                        "demo_alpha_frame_00827_762.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 11.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87157,
                    "duration": 10.3,
                    "description": "Move through the workspace to continue Sample Workflow 25.",
                    "screenshots": [
                        "demo_alpha_frame_00829_580.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 10.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87159,
                    "duration": 8.8,
                    "description": "Move through the workspace to continue Sample Workflow 39.",
                    "screenshots": [
                        "demo_alpha_frame_00831_978.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 8.8
                    }
                },
                {
                    "nodeId": "step:check-messages-slack#slack",
                    "analysisNodeId": 87162,
                    "duration": 8.5,
                    "description": "Review the fictional conversation in #demo-ops-60 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00837_431.png",
                        "demo_alpha_frame_00838_198.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 8.5
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87163,
                    "duration": 8.6,
                    "description": "Move through the workspace to continue Sample Workflow 67.",
                    "screenshots": [
                        "demo_alpha_frame_00839_306.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 8.6
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#notion",
                    "analysisNodeId": 87166,
                    "duration": 6.8,
                    "description": "Move through the workspace to continue Sample Workflow 81.",
                    "screenshots": [
                        "demo_alpha_frame_00843_583.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 2.4,
                        "Notion": 4.3
                    }
                },
                {
                    "nodeId": "step:check-messages-slack#arc",
                    "analysisNodeId": 87167,
                    "duration": 122.5,
                    "description": "Review the fictional conversation in #demo-ops-88 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_00844_067.png",
                        "demo_alpha_frame_00845_576.png",
                        "demo_alpha_frame_00846_850.png",
                        "demo_alpha_frame_00847_436.png",
                        "demo_alpha_frame_00848_759.png",
                        "demo_alpha_frame_00849_914.png",
                        "demo_alpha_frame_00850_380.png",
                        "demo_alpha_frame_00851_765.png",
                        "demo_alpha_frame_00852_591.png",
                        "demo_alpha_frame_00853_258.png",
                        "demo_alpha_frame_00854_174.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 108.2
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87169,
                    "duration": 9.4,
                    "description": "Move through the workspace to continue Sample Workflow 13.",
                    "screenshots": [
                        "demo_alpha_frame_00859_178.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 5.8,
                        "Gmail": 3.8
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87172,
                    "duration": 7.5,
                    "description": "Move through the workspace to continue Sample Workflow 27.",
                    "screenshots": [
                        "demo_alpha_frame_00867_819.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 1.0,
                        "Arc": 6.5
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87181,
                    "duration": 14.0,
                    "description": "Move through the workspace to continue Sample Workflow 90.",
                    "screenshots": [
                        "demo_alpha_frame_00904_671.png",
                        "demo_alpha_frame_00905_697.png",
                        "demo_alpha_frame_00906_823.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 14.0
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87182,
                    "duration": 9.8,
                    "description": "Move through the workspace to continue Sample Workflow 97.",
                    "screenshots": [
                        "demo_alpha_frame_00907_354.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 9.8
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87187,
                    "duration": 8.0,
                    "description": "Move through the workspace to continue Sample Workflow 36.",
                    "screenshots": [
                        "demo_alpha_frame_00923_313.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 8.0
                    }
                },
                {
                    "nodeId": "step:check-messages-arc#arc",
                    "analysisNodeId": 87189,
                    "duration": 11.8,
                    "description": "Review the fictional conversation in #demo-ops-50 and post a sample status update using Arc.",
                    "screenshots": [
                        "demo_alpha_frame_00926_786.png",
                        "demo_alpha_frame_00927_485.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 8.8
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87196,
                    "duration": 53.6,
                    "description": "Move through the workspace to continue Sample Workflow 85.",
                    "screenshots": [
                        "demo_alpha_frame_00976_895.png",
                        "demo_alpha_frame_00977_260.png",
                        "demo_alpha_frame_00978_067.png",
                        "demo_alpha_frame_00979_806.png",
                        "demo_alpha_frame_00980_499.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 51.0
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87198,
                    "duration": 94.1,
                    "description": "Move through the workspace to continue Sample Workflow 92.",
                    "screenshots": [
                        "demo_alpha_frame_00985_906.png",
                        "demo_alpha_frame_00986_480.png",
                        "demo_alpha_frame_00987_225.png",
                        "demo_alpha_frame_00988_887.png",
                        "demo_alpha_frame_00989_448.png",
                        "demo_alpha_frame_00990_555.png",
                        "demo_alpha_frame_00991_651.png",
                        "demo_alpha_frame_00992_035.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 83.0
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87199,
                    "duration": 36.9,
                    "description": "Move through the workspace to continue Sample Workflow 10.",
                    "screenshots": [
                        "demo_alpha_frame_00993_998.png",
                        "demo_alpha_frame_00994_539.png",
                        "demo_alpha_frame_00995_094.png",
                        "demo_alpha_frame_00996_984.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "LinkedIn": 17.8,
                        "Arc": 19.1
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87210,
                    "duration": 166.4,
                    "description": "Move through the workspace to continue Sample Workflow 80.",
                    "screenshots": [
                        "demo_alpha_frame_01039_457.png",
                        "demo_alpha_frame_01040_908.png",
                        "demo_alpha_frame_01041_709.png",
                        "demo_alpha_frame_01042_072.png",
                        "demo_alpha_frame_01043_221.png",
                        "demo_alpha_frame_01044_343.png",
                        "demo_alpha_frame_01045_712.png",
                        "demo_alpha_frame_01046_449.png",
                        "demo_alpha_frame_01047_090.png",
                        "demo_alpha_frame_01048_269.png",
                        "demo_alpha_frame_01049_845.png",
                        "demo_alpha_frame_01050_181.png",
                        "demo_alpha_frame_01051_379.png",
                        "demo_alpha_frame_01052_932.png",
                        "demo_alpha_frame_01053_574.png",
                        "demo_alpha_frame_01054_236.png",
                        "demo_alpha_frame_01055_362.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 160.4
                    }
                },
                {
                    "nodeId": "step:manage-calendar-and-availability-arc#arc",
                    "analysisNodeId": 87218,
                    "duration": 5.9,
                    "description": "Review a sample calendar entry for Demo Account 47 and update its demo availability in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01088_783.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 4.6
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#salesforce",
                    "analysisNodeId": 87221,
                    "duration": 6.3,
                    "description": "Move through the workspace to continue Sample Workflow 68.",
                    "screenshots": [
                        "demo_alpha_frame_01092_855.png",
                        "demo_alpha_frame_01093_950.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Salesforce": 6.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87223,
                    "duration": 74.7,
                    "description": "Move through the workspace to continue Sample Workflow 82.",
                    "screenshots": [
                        "demo_alpha_frame_01095_733.png",
                        "demo_alpha_frame_01096_893.png",
                        "demo_alpha_frame_01097_739.png",
                        "demo_alpha_frame_01098_753.png",
                        "demo_alpha_frame_01099_614.png",
                        "demo_alpha_frame_01100_558.png",
                        "demo_alpha_frame_01101_172.png",
                        "demo_alpha_frame_01102_196.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 74.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#gmail",
                    "analysisNodeId": 87224,
                    "duration": 12.6,
                    "description": "Move through the workspace to continue Sample Workflow 89.",
                    "screenshots": [
                        "demo_alpha_frame_01103_420.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 5.8,
                        "Gmail": 6.8
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#gmail",
                    "analysisNodeId": 87238,
                    "duration": 30.5,
                    "description": "Move through the workspace to continue Sample Workflow 84.",
                    "screenshots": [
                        "demo_alpha_frame_01124_329.png",
                        "demo_alpha_frame_01125_016.png",
                        "demo_alpha_frame_01126_623.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Gmail": 28.9
                    }
                },
                {
                    "nodeId": "step:check-messages-slack#slack",
                    "analysisNodeId": 87239,
                    "duration": 11.3,
                    "description": "Review the fictional conversation in #demo-ops-91 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01127_943.png",
                        "demo_alpha_frame_01128_388.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 11.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#gmail",
                    "analysisNodeId": 87240,
                    "duration": 227.4,
                    "description": "Move through the workspace to continue Sample Workflow 98.",
                    "screenshots": [
                        "demo_alpha_frame_01129_658.png",
                        "demo_alpha_frame_01130_059.png",
                        "demo_alpha_frame_01131_407.png",
                        "demo_alpha_frame_01132_097.png",
                        "demo_alpha_frame_01133_243.png",
                        "demo_alpha_frame_01134_161.png",
                        "demo_alpha_frame_01135_109.png",
                        "demo_alpha_frame_01136_203.png",
                        "demo_alpha_frame_01137_478.png",
                        "demo_alpha_frame_01138_729.png",
                        "demo_alpha_frame_01139_684.png",
                        "demo_alpha_frame_01140_702.png",
                        "demo_alpha_frame_01141_616.png",
                        "demo_alpha_frame_01142_855.png",
                        "demo_alpha_frame_01143_380.png",
                        "demo_alpha_frame_01144_836.png",
                        "demo_alpha_frame_01145_913.png",
                        "demo_alpha_frame_01146_044.png",
                        "demo_alpha_frame_01147_086.png",
                        "demo_alpha_frame_01148_026.png",
                        "demo_alpha_frame_01149_393.png",
                        "demo_alpha_frame_01150_209.png",
                        "demo_alpha_frame_01151_763.png",
                        "demo_alpha_frame_01152_656.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Gmail": 224.4
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87242,
                    "duration": 223.2,
                    "description": "Move through the workspace to continue Sample Workflow 23.",
                    "screenshots": [
                        "demo_alpha_frame_01177_892.png",
                        "demo_alpha_frame_01178_252.png",
                        "demo_alpha_frame_01179_695.png",
                        "demo_alpha_frame_01180_720.png",
                        "demo_alpha_frame_01181_686.png",
                        "demo_alpha_frame_01182_761.png",
                        "demo_alpha_frame_01183_907.png",
                        "demo_alpha_frame_01184_279.png",
                        "demo_alpha_frame_01185_817.png",
                        "demo_alpha_frame_01186_261.png",
                        "demo_alpha_frame_01187_640.png",
                        "demo_alpha_frame_01188_858.png",
                        "demo_alpha_frame_01189_306.png",
                        "demo_alpha_frame_01190_052.png",
                        "demo_alpha_frame_01191_240.png",
                        "demo_alpha_frame_01192_078.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 74",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 223.2
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87243,
                    "duration": 242.6,
                    "description": "Move through the workspace to continue Sample Workflow 30.",
                    "screenshots": [
                        "demo_alpha_frame_01193_785.png",
                        "demo_alpha_frame_01194_195.png",
                        "demo_alpha_frame_01195_282.png",
                        "demo_alpha_frame_01196_109.png",
                        "demo_alpha_frame_01197_143.png",
                        "demo_alpha_frame_01198_503.png",
                        "demo_alpha_frame_01199_451.png",
                        "demo_alpha_frame_01200_469.png",
                        "demo_alpha_frame_01201_161.png",
                        "demo_alpha_frame_01202_576.png",
                        "demo_alpha_frame_01203_505.png",
                        "demo_alpha_frame_01204_369.png",
                        "demo_alpha_frame_01205_164.png",
                        "demo_alpha_frame_01206_297.png",
                        "demo_alpha_frame_01207_088.png",
                        "demo_alpha_frame_01208_856.png",
                        "demo_alpha_frame_01209_757.png",
                        "demo_alpha_frame_01210_370.png",
                        "demo_alpha_frame_01211_452.png",
                        "demo_alpha_frame_01212_013.png",
                        "demo_alpha_frame_01213_521.png",
                        "demo_alpha_frame_01214_412.png",
                        "demo_alpha_frame_01215_520.png",
                        "demo_alpha_frame_01216_918.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 242.6
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#google-chrome",
                    "analysisNodeId": 87244,
                    "duration": 1036.8,
                    "description": "Move through the workspace to continue Sample Workflow 37.",
                    "screenshots": [
                        "demo_alpha_frame_01217_016.png",
                        "demo_alpha_frame_01218_840.png",
                        "demo_alpha_frame_01219_908.png",
                        "demo_alpha_frame_01220_370.png",
                        "demo_alpha_frame_01221_740.png",
                        "demo_alpha_frame_01222_816.png",
                        "demo_alpha_frame_01223_768.png",
                        "demo_alpha_frame_01224_480.png",
                        "demo_alpha_frame_01225_612.png",
                        "demo_alpha_frame_01226_005.png",
                        "demo_alpha_frame_01227_550.png",
                        "demo_alpha_frame_01228_189.png",
                        "demo_alpha_frame_01229_610.png",
                        "demo_alpha_frame_01230_303.png",
                        "demo_alpha_frame_01231_500.png",
                        "demo_alpha_frame_01232_755.png",
                        "demo_alpha_frame_01233_141.png",
                        "demo_alpha_frame_01234_473.png",
                        "demo_alpha_frame_01235_330.png",
                        "demo_alpha_frame_01236_372.png",
                        "demo_alpha_frame_01237_274.png",
                        "demo_alpha_frame_01238_939.png",
                        "demo_alpha_frame_01239_213.png",
                        "demo_alpha_frame_01240_149.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Google Chrome": 1036.8
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87245,
                    "duration": 8.7,
                    "description": "Move through the workspace to continue Sample Workflow 44.",
                    "screenshots": [
                        "demo_alpha_frame_01241_922.png",
                        "demo_alpha_frame_01242_687.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 8.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#salesforce",
                    "analysisNodeId": 87247,
                    "duration": 43.5,
                    "description": "Move through the workspace to continue Sample Workflow 58.",
                    "screenshots": [
                        "demo_alpha_frame_01244_369.png",
                        "demo_alpha_frame_01245_430.png",
                        "demo_alpha_frame_01246_469.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 9.4,
                        "Salesforce": 27.9
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87250,
                    "duration": 8.3,
                    "description": "Move through the workspace to continue Sample Workflow 79.",
                    "screenshots": [
                        "demo_alpha_frame_01258_602.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 65",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 82",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 8.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87254,
                    "duration": 57.6,
                    "description": "Move through the workspace to continue Sample Workflow 11.",
                    "screenshots": [
                        "demo_alpha_frame_01267_005.png",
                        "demo_alpha_frame_01268_868.png",
                        "demo_alpha_frame_01269_152.png",
                        "demo_alpha_frame_01270_505.png",
                        "demo_alpha_frame_01271_074.png",
                        "demo_alpha_frame_01272_369.png",
                        "demo_alpha_frame_01273_465.png",
                        "demo_alpha_frame_01274_844.png",
                        "demo_alpha_frame_01275_456.png",
                        "demo_alpha_frame_01276_428.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 12",
                            "qualifier": "referenced"
                        },
                        {
                            "object": "Sample Reference 29",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 57.6
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87256,
                    "duration": 5.0,
                    "description": "Move through the workspace to continue Sample Workflow 18.",
                    "screenshots": [
                        "demo_alpha_frame_01283_273.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 2.5,
                        "Arc": 2.5
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87258,
                    "duration": 11.3,
                    "description": "Review the fictional conversation in #demo-ops-25 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01286_281.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 56",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 8.3
                    }
                },
                {
                    "nodeId": "step:message-teammate-slack#slack",
                    "analysisNodeId": 87261,
                    "duration": 32.4,
                    "description": "Review the fictional conversation in #demo-ops-32 and post a sample status update using Slack.",
                    "screenshots": [
                        "demo_alpha_frame_01290_395.png",
                        "demo_alpha_frame_01291_642.png",
                        "demo_alpha_frame_01292_477.png",
                        "demo_alpha_frame_01293_735.png",
                        "demo_alpha_frame_01294_707.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 32.4
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87263,
                    "duration": 11.9,
                    "description": "Move through the workspace to continue Sample Workflow 46.",
                    "screenshots": [
                        "demo_alpha_frame_01296_699.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 14",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Slack": 11.9
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87264,
                    "duration": 14.7,
                    "description": "Move through the workspace to continue Sample Workflow 53.",
                    "screenshots": [
                        "demo_alpha_frame_01297_572.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 10.4
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#salesforce",
                    "analysisNodeId": 87268,
                    "duration": 9.1,
                    "description": "Review the fictional conversation in #demo-ops-81 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01330_608.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Salesforce": 4.0,
                        "Arc": 2.8
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87269,
                    "duration": 8.6,
                    "description": "Move through the workspace to continue Sample Workflow 88.",
                    "screenshots": [
                        "demo_alpha_frame_01331_230.png",
                        "demo_alpha_frame_01332_183.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 8.5
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#arc",
                    "analysisNodeId": 87270,
                    "duration": 21.8,
                    "description": "Review the fictional conversation in #demo-ops-95 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01333_458.png",
                        "demo_alpha_frame_01334_301.png",
                        "demo_alpha_frame_01335_701.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 11.6,
                        "LinkedIn": 10.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87271,
                    "duration": 13.1,
                    "description": "Move through the workspace to continue Sample Workflow 13.",
                    "screenshots": [
                        "demo_alpha_frame_01336_675.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 13.1
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87273,
                    "duration": 109.2,
                    "description": "Move through the workspace to continue Sample Workflow 20.",
                    "screenshots": [
                        "demo_alpha_frame_01343_061.png",
                        "demo_alpha_frame_01344_619.png",
                        "demo_alpha_frame_01345_655.png",
                        "demo_alpha_frame_01346_681.png",
                        "demo_alpha_frame_01347_974.png",
                        "demo_alpha_frame_01348_424.png",
                        "demo_alpha_frame_01349_248.png",
                        "demo_alpha_frame_01350_492.png",
                        "demo_alpha_frame_01351_911.png",
                        "demo_alpha_frame_01352_901.png",
                        "demo_alpha_frame_01353_997.png",
                        "demo_alpha_frame_01354_497.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 106.0
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#salesforce",
                    "analysisNodeId": 87275,
                    "duration": 5.0,
                    "description": "Move through the workspace to continue Sample Workflow 34.",
                    "screenshots": [
                        "demo_alpha_frame_01358_495.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 49",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Salesforce": 5.0
                    }
                },
                {
                    "nodeId": "step:check-messages-gmail#arc",
                    "analysisNodeId": 87280,
                    "duration": 94.7,
                    "description": "Review the fictional conversation in #demo-ops-69 and post a sample status update using Gmail.",
                    "screenshots": [
                        "demo_alpha_frame_01369_802.png",
                        "demo_alpha_frame_01370_165.png",
                        "demo_alpha_frame_01371_912.png",
                        "demo_alpha_frame_01372_268.png",
                        "demo_alpha_frame_01373_305.png",
                        "demo_alpha_frame_01374_594.png",
                        "demo_alpha_frame_01375_747.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 85.6
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87285,
                    "duration": 4.6,
                    "description": "Move through the workspace to continue Sample Workflow 15.",
                    "screenshots": [
                        "demo_alpha_frame_01384_696.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 4.6
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87289,
                    "duration": 8.3,
                    "description": "Move through the workspace to continue Sample Workflow 36.",
                    "screenshots": [
                        "demo_alpha_frame_01389_911.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Salesforce": 2.6,
                        "Arc": 3.5
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87290,
                    "duration": 12.3,
                    "description": "Move through the workspace to continue Sample Workflow 43.",
                    "screenshots": [
                        "demo_alpha_frame_01390_954.png",
                        "demo_alpha_frame_01391_960.png",
                        "demo_alpha_frame_01392_599.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 12.3
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#slack",
                    "analysisNodeId": 87291,
                    "duration": 17.4,
                    "description": "Move through the workspace to continue Sample Workflow 50.",
                    "screenshots": [
                        "demo_alpha_frame_01393_685.png",
                        "demo_alpha_frame_01394_842.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Slack": 8.7,
                        "lemlist": 8.7
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87305,
                    "duration": 7.4,
                    "description": "Move through the workspace to continue Sample Workflow 45.",
                    "screenshots": [
                        "demo_alpha_frame_01418_996.png",
                        "demo_alpha_frame_01419_101.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 88",
                            "qualifier": "referenced"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 7.4
                    }
                },
                {
                    "nodeId": "step:enrich-contact-data-arc#arc",
                    "analysisNodeId": 87310,
                    "duration": 20.1,
                    "description": "Open the fictional record for Demo Account 80 and update its sample fields in Arc.",
                    "screenshots": [
                        "demo_alpha_frame_01428_414.png",
                        "demo_alpha_frame_01429_869.png"
                    ],
                    "objects": [
                        {
                            "object": "Sample Reference 46",
                            "qualifier": "edited"
                        }
                    ],
                    "appSeconds": {
                        "Arc": 20.1
                    }
                },
                {
                    "nodeId": "step:navigate-workspace#arc",
                    "analysisNodeId": 87337,
                    "duration": 31.4,
                    "description": "Move through the workspace to continue Sample Workflow 56.",
                    "screenshots": [
                        "demo_alpha_frame_01541_684.png",
                        "demo_alpha_frame_01542_456.png",
                        "demo_alpha_frame_01543_169.png"
                    ],
                    "objects": [],
                    "appSeconds": {
                        "Arc": 31.4
                    }
                }
            ]
        }
    ]
}

export const ALL_PROCESSES = [
  outboundPipelineGeneration,
  internalCollaborationAdmin,
  teamEnablementOnboarding,
  navigateWorkspace,
] as unknown as Process[];
